import * as Yup from 'yup'
import axios from 'axios'
import { Icon } from '@iconify/react'
import trash2Outline from '@iconify/icons-eva/trash-2-outline'
import { useCallback, useEffect, useMemo, useRef, useState, Fragment } from 'react'
import quickbookLogo from 'src/assets/quickbookLogo-removebg-preview.png'
import { capitalCase, sentenceCase } from 'change-case'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Form, FormikProvider, useFormik } from 'formik'
import {
  Container,
  Grid,
  IconButton,
  Stack,
  Box,
  Button,
  TableRow,
  TableBody,
  Checkbox,
  Card,
  TableCell,
  Typography,
  TableContainer,
  Table,
  TablePagination,
  TextField,
  Switch,
  FormControlLabel,
  Autocomplete,
  Divider,
  Paper,
  Popover,
  CardHeader,
  TableHead,
  List,
  Menu,
  MenuItem,
  ListItemText,
  ListItem,
  Tabs,
  Tab,
  Chip,
  Tooltip,
  CircularProgress,
  Badge,
  FormHelperText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@material-ui/core'
import CloseIcon from '@iconify/icons-eva/close-fill'
import {
  useTheme,
  experimentalStyled as styled,
} from '@material-ui/core/styles'
import plusFill from '@iconify/icons-eva/plus-fill'
// redux
import {
  LoadingButton,
  MobileDatePicker,
  MobileDateRangePicker,
} from '@material-ui/lab'
// routes
// components
import Page from '../../components/Page'
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs'
import Modal from '../../components/_dashboard/blog/ProjectModel'
import Label from 'src/components/Label'
import { useSnackbar } from 'notistack'
import {
  Delete,
  UploadFile,
  LocationOn,
  ExpandMore,
  ExpandLess,
  Remove,
  Add,
  NoteAdd,
  Visibility,
  VisibilityOff,
  ViewModule,
  ViewList,
  List as ListIcon,
  Settings,
  FilterList,
  KeyboardBackspaceOutlined,
  SwapHorizontalCircleOutlined,
  DragIndicator,
  PictureAsPdf,
  Description,
} from '@material-ui/icons'
import AttachmentDownloadIconButton from 'src/components/_dashboard/official-request/AttachmentDownloadIconButton'
import AttachmentDownloadAllButton from 'src/components/_dashboard/official-request/AttachmentDownloadAllButton'
import OfficialRequestSearch from 'src/components/_dashboard/official-request/OfficialRequestSearch'
import InfiniteScroll from 'react-infinite-scroll-component'
import OfficialCard from 'src/components/_dashboard/official-request/OfficialCard'
import Scrollbar from 'src/components/Scrollbar'
import moment from 'moment'
import { formatDateOnly, localTodayDateOnlyUnix, toDateOnlyUnix } from 'src/utils/dateOnly'
import DesignFormTabs from 'src/components/design-form/DesignFormTabs'
import {
  REST_API,
  REST_API_END_POINT,
  UNITS,
} from 'src/constants/Defaultvalues'
import { UploadAvatar, UploadMultiFile } from 'src/components/upload'
import { storage } from '../../firebase/firebase'
import { getDownloadURL, ref, uploadBytesResumable } from 'firebase/storage'
import ReactToPrint from 'react-to-print'
import { empty } from 'src/Helpers/Common'
import { resolveAttachmentProxyPath } from 'src/Helpers/FileDownloadUtils'
import LoadingScreen from 'src/components/LoadingScreen'
import SearchNotFound from 'src/components/SearchNotFound'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import NavSection from 'src/components/NavSection'
import { PATH_DASHBOARD } from 'src/routes/paths'
import RequestProgressModal from 'src/components/RequestProgressModal';
import FullScreenDialogDesignOrder from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogDesignOrder';
import DesignOrderList from './DesignOrderList'
import { supabase } from '../../supabase/supabaseClient';
import { fUSPrice } from 'src/utils/formatNumber'
import {
  clearCatalogInstallCost,
  applyInstallPriceEdit,
  applyRetailPriceEdit,
  ensureCatalogBaselines,
  formatPriceToTwoDecimals,
  formatRetailPriceDisplay,
  getCatalogPickerOriginalPrices,
  getCatalogProductWithAdjustment,
  getDisplayedInstallPrice,
  getSignedInstallMarketingAdjustment,
  limitDecimalInput,
  normalizeProductForSave,
  normalizeRetailArrowChange,
  parseMarketingAdjValueTypeFromDb,
  reconcileCatalogMarketingPrices,
  applyMarketingAdjustmentChange,
  applyInstallMarketingAdjustmentChange,
  applyProductAdjValueTypeChange,
  applyInstallAdjValueTypeChange,
  stepRetailPriceByArrow,
} from 'src/utils/retailPriceEdit'
import useDesignOrderProductGrouping from './designOrder/useDesignOrderProductGrouping'
import {
  DesignOrderGroupDialogs,
  DesignOrderGroupActionBar,
  DesignOrderGroupSummaryRow,
  getDesignOrderGroupValueColumns,
  DESIGN_ORDER_NEGATIVE_MARKETING_PERMISSIONS,
  DESIGN_ORDER_PRODUCT_TABLE_PRODUCT_COL_SX,
  DESIGN_ORDER_PRODUCT_TABLE_DESCRIPTION_COL_SX,
} from './designOrder/DesignOrderProductGroupingUI'
import {
  computeDesignOrderProductsSubTotal,
  DESIGN_ORDER_ROW_ACTIONS_BOX_SX,
  DESIGN_ORDER_ROW_ACTIONS_CELL_SX,
  DESIGN_ORDER_ROW_ACTIONS_LEADING_SLOT_SX,
  enrichDesignOrderAttachmentForDisplay,
  getDesignOrderLosingMoneyRowSx,
  mapDesignOrderProductAttachmentForDisplay,
} from './designOrder/designOrderProductRowHelpers'
import {
  getGroupAnchorIndexId,
  isIndexIdInList,
  resolveGroupMemberMarketingForSave,
  stripGroupFieldsFromCatalogOption,
  collapseProductsForAutocompleteChips,
  getCatalogAutocompleteDisplayName,
  getCatalogAutocompleteTooltip,
  getAutocompleteSelectionKey,
} from './quotation/quotationGroupingHelpers'

const getStatusColorAndLabel = (status, hold) => {
  switch (status) {
    case 1:
      return { color: hold == 1 ? 'warning' : 'info', label: hold == 1 ? 'Status: Hold' : 'Status: Open'}
    case 2:
      return { color: hold == 1 ? 'warning' : 'success', label: hold == 1 ? 'Status: Hold' : 'Status: Approved' } // Evaluating
    case 3:
      return { color: hold == 1 ? 'warning' : 'success', label: hold == 1 ? 'Status: Hold' : 'Status: In Sales Order' }
    case 4:
      return { color: hold == 1 ? 'warning' : 'warning', label: hold == 1 ? 'Status: Hold' : 'Status: Draft' }
    case 5:
      return { color: hold == 1 ? 'warning' : 'warning', label: hold == 1 ? 'Status: Hold' : 'Status: Closed' }
    case 6:
      return { color: hold == 1 ? 'warning' : 'error', label: hold == 1 ? 'Status: Hold' : 'Status: Rejected' }
    default:
      return { color: hold == 1 ? 'warning' : 'default', label: hold == 1 ? 'Status: Hold' : 'Status: Open' }
  }
}

// const ACCOUNT_TABS = [
//   {
//     value: 'ALL',
//     name: 'ALL',
//     count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 1)?.length || 0
//   },
//   {
//     value: 'OPEN',
//     name: 'OPEN',
//     count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
//   },
//   {
//     value: 'Approved',
//     name: 'Approved',
//     count : projectCategoriesInitialData?.filter((item)=>item?.category_type == 2)?.length || 0
//   },
// ]
//sorting
const SORT = [
  { id: 'new', label: 'Newest', color: '#54D62C' },
  { id: 'old', label: 'Oldest', color: '#ffff00' },
  { id: 'last_updated', label: 'Recently Updated', color: '#ffff00' },
  { id: 'custom_order', label: 'Custom Order', color: '#ffff00' },
]

const MAX_CHARACTERS = 500

const splitOrderCatalogTypes = [
  { id: 'all', label: 'All' },
  { id: 'in_stock', label: 'In Stock Catalog' },
  { id: 'client_owned', label: 'Client Owned Catalog' },
  { id: 'traffic', label: 'Traffic Catalog' },
  { id: 'production_catalog', label: 'Production Catalog' },
  { id: 'sub_contract', label: 'Sub Contract' },
  { id: 'estimate_catalog', label: 'Estimate Catalog' },
]

const getCatalogProductSuffix = (option) => {
  if (!option) return ''
  if (option.isTrafficCatalog) return '(TC)'
  if (option.inhouse === 5) return '(Client Owned Catalog)'
  if (option.inhouse === 4) return '(In Stock Catalog)'
  if (option.inhouse === 0) return '(Sub Contract)'
  if (option.inhouse === 6) return '(Split Catalog)'
  if (option.inhouse === 7) return '(Estimate Catalog)'
  return '(Production Catalog)'
}

const getCatalogProductDisplayName = (option) =>
  getCatalogAutocompleteDisplayName(option)

const getMaxNegativeAdjustment = (item, hasPermission) => {
  const formulaEach = item?.inhouse === 0
    ? Number(item?.sub_contract_price || 0)
    : Number(
      (item?.expected_material_cost_with_markup || 0) +
        (item?.expected_service_cost_with_markup || 0),
    )
  const retailEachBase = Math.max(
    0,
    Number(
      item.original_actual_retail_price ??
        item.original_retail_price ??
        item.actual_retail_price ??
        item.retail_price ??
        item.product_retail_price ??
        0,
    ),
  )
  let maxNegative = Math.max(0, retailEachBase - formulaEach)
  if (hasPermission) {
    maxNegative = retailEachBase
  }
  return maxNegative
}

const getMaxNegativeInstallAdjustment = (data, hasPermission) => {
  const formula = Number(data?.expected_install_labor_cost_with_markup) || 0
  const retail = Math.max(
    0,
    Number(data?.original_install_cost) || Number(data?.install_cost) || 0,
  )
  let maxNegative = Math.max(0, retail - formula)
  if (hasPermission) {
    maxNegative = retail
  }
  return maxNegative
}

const createEmptyProductRow = (indexId = 1) => ({
  indexId,
  entryMode: 'write',
  product_name: '',
  product_desc: '',
  price: 0,
  retail_price: 0,
  is_product_row: 1,
  catalogProduct: null,
})

const PRODUCT_ENTRY_TOGGLE_PAD = 4

const PRODUCT_TABLE_PRODUCT_COL_SX = {
  minWidth: 280,
  width: 280,
  maxWidth: 280,
  verticalAlign: 'middle',
}

const PRODUCT_TABLE_DESCRIPTION_COL_SX = {
  minWidth: 320,
  width: 320,
  maxWidth: 320,
  verticalAlign: 'middle',
}

const ProductLineEntryToggle = ({ mode, onChange, disabled }) => {
  const theme = useTheme()
  const isWrite = mode === 'write'
  const pad = PRODUCT_ENTRY_TOGGLE_PAD
  const inactiveColor =
    theme.palette.mode === 'dark' ? theme.palette.grey[300] : theme.palette.grey[800]
  const activeColor = theme.palette.common.white

  const segmentButtonSx = (active) => ({
    flex: 1,
    position: 'relative',
    zIndex: 1,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 0.5,
    minWidth: 0,
    px: 1.25,
    py: 0.75,
    borderRadius: '12px',
    fontSize: '0.75rem',
    fontWeight: active ? 800 : 600,
    lineHeight: 1.25,
    color: active ? activeColor : inactiveColor,
    textShadow: active ? '0 1px 2px rgba(0,0,0,0.28)' : 'none',
    textTransform: 'none',
    letterSpacing: 0.2,
    transition: 'color 0.25s ease, transform 0.15s ease',
    '& .segment-icon': {
      opacity: active ? 1 : 0.85,
    },
    '&:hover': {
      bgcolor: active ? 'transparent' : (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)'),
      color: active ? activeColor : (theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.grey[900]),
    },
    '&:active': {
      transform: active ? 'none' : 'scale(0.98)',
    },
  })

  return (
    <Box
      role="group"
      aria-label="Product entry mode"
      sx={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'stretch',
        width: '100%',
        maxWidth: 176,
        minWidth: 160,
        p: `${pad}px`,
        borderRadius: '14px',
        border: `1px solid ${theme.palette.divider}`,
        bgcolor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, 0.04)'
            : 'rgba(145, 158, 171, 0.1)',
        opacity: disabled ? 0.55 : 1,
        pointerEvents: disabled ? 'none' : 'auto',
        boxShadow:
          theme.palette.mode === 'dark'
            ? 'inset 0 1px 0 rgba(255,255,255,0.06)'
            : 'inset 0 1px 2px rgba(0,0,0,0.05)',
      }}
    >
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          top: pad,
          left: pad,
          bottom: pad,
          width: `calc((100% - ${pad * 2}px) / 2)`,
          borderRadius: '10px',
          transform: isWrite ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.32s cubic-bezier(0.34, 1.2, 0.64, 1), background 0.32s ease, box-shadow 0.32s ease',
          zIndex: 0,
          background: isWrite
            ? `linear-gradient(145deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 55%, ${theme.palette.primary.dark} 100%)`
            : `linear-gradient(145deg, ${theme.palette.success.light} 0%, ${theme.palette.success.main} 55%, ${theme.palette.success.dark} 100%)`,
          boxShadow: isWrite
            ? `0 2px 6px ${theme.palette.primary.main}33`
            : `0 1px 4px ${theme.palette.success.main}22`,
        }}
      />
      <Button
        variant="text"
        disableRipple
        size="small"
        onClick={() => onChange('write')}
        sx={segmentButtonSx(isWrite)}
      >
        <Icon className="segment-icon" icon="eva:edit-2-outline" width={15} height={15} />
        Write
      </Button>
      <Button
        variant="text"
        disableRipple
        size="small"
        onClick={() => onChange('choose')}
        sx={segmentButtonSx(!isWrite)}
      >
        <Icon className="segment-icon" icon="eva:grid-outline" width={15} height={15} />
        Choose
      </Button>
    </Box>
  )
}
const formatProjectAddress = (project) => {
  if (!project) return 'No address available'
  const addressParts = [project.address, project.city, project.state, project.zip]
    .map((part) => (part || '').toString().trim())
    .filter(Boolean)
  return addressParts.length > 0 ? addressParts.join(', ') : 'No address available'
}

const getCommunityLocationFromProject = (community) => {
  if (!community) {
    return { address: '', city: '', state: '', zip: '' }
  }
  return {
    address: (community.address || '').toString().trim(),
    city: (community.city || '').toString().trim(),
    state: (community.state || '').toString().trim(),
    zip: (community.zip || community.zipcode || '').toString().trim(),
  }
}

const hasCompleteProductLocation = (product) => {
  const locations = Array.isArray(product?.location) ? product.location : []
  const firstLocation = locations[0]
  return Boolean(
    firstLocation?.address &&
      firstLocation?.city &&
      firstLocation?.state &&
      firstLocation?.zip,
  )
}

const withCommunityLocationIfMissing = (product, community) => {
  if (!product || hasCompleteProductLocation(product)) return product
  const communityLocation = getCommunityLocationFromProject(community)
  if (
    !communityLocation.address ||
    !communityLocation.city ||
    !communityLocation.state ||
    !communityLocation.zip
  ) {
    return product
  }
  return {
    ...product,
    location: [{ id: 0, ...communityLocation }],
  }
}

const selectInputValue = (event) => {
  const input = event.target
  setTimeout(() => {
    if (input?.select) {
      input.select()
    }
  }, 0)
}

const capitalCaseWithSlash = (text) =>
  text
    .split(' ')
    .map(word => {
      if (word === '/') return '/'
      return word
        .split('/')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join('/')
    })
    .join(' ')

// Alphanumeric comparison helper function (natural sort)
function alphanumericCompare(str1, str2) {
  const normalize = (str) => {
    if (str === null || str === undefined) return '';
    // Strip leading and trailing quotes before comparison
    let normalized = str.toString().trim();
    // Remove leading and trailing quotes (both single and double)
    normalized = normalized.replace(/^["']+|["']+$/g, '');
    return normalized;
  };

  const a = normalize(str1);
  const b = normalize(str2);

  if (!a && !b) return 0;
  if (!a) return -1;
  if (!b) return 1;

  const getChunks = (str) => {
    const chunks = [];
    let currentChunk = '';
    let chunkType = null; // 'hash', 'otherSpecial', 'digit', or 'letter'

    for (let i = 0; i < str.length; i++) {
      const char = str[i];
      const isDigit = /\d/.test(char);
      const isLetter = /[a-zA-Z]/.test(char);
      const isHash = char === '#';
      const isOtherSpecial = !isDigit && !isLetter && !isHash;
      
      // Determine chunk type with priority: hash < otherSpecial < digit < letter
      let currentType;
      if (isHash) {
        currentType = 'hash';
      } else if (isOtherSpecial) {
        currentType = 'otherSpecial';
      } else if (isDigit) {
        currentType = 'digit';
      } else {
        currentType = 'letter';
      }

      if (i === 0) {
        chunkType = currentType;
        currentChunk = char;
      } else if (currentType === chunkType) {
        currentChunk += char;
      } else {
        chunks.push({
          value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
          type: chunkType
        });
        currentChunk = char;
        chunkType = currentType;
      }
    }

    if (currentChunk) {
      chunks.push({
        value: chunkType === 'digit' ? parseInt(currentChunk, 10) : currentChunk.toLowerCase(),
        type: chunkType
      });
    }

    return chunks;
  };

  const chunksA = getChunks(a);
  const chunksB = getChunks(b);
  const len = Math.min(chunksA.length, chunksB.length);

  // Type priority: hash (0) < otherSpecial (1) < digit (2) < letter (3)
  const getTypePriority = (type) => {
    if (type === 'hash') return 0;
    if (type === 'otherSpecial') return 1;
    if (type === 'digit') return 2;
    return 3; // letter
  };

  for (let i = 0; i < len; i++) {
    const chunkA = chunksA[i];
    const chunkB = chunksB[i];

    const priorityA = getTypePriority(chunkA.type);
    const priorityB = getTypePriority(chunkB.type);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    // Same type, compare values
    if (chunkA.type === 'digit') {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    } else {
      if (chunkA.value < chunkB.value) return -1;
      if (chunkA.value > chunkB.value) return 1;
    }
  }

  if (chunksA.length < chunksB.length) return -1;
  if (chunksA.length > chunksB.length) return 1;

  return 0;
}

  const CustomTab = styled(Tab)(({ theme }) => ({
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    boxShadow: 'none', //theme.shadows[5],
    minHeight: 'fit-content',
    indicator: {
      display: 'none',
    },
    height: 38,
    fontSize: 12,
    borderRadius: 'none', //20
    border: '1.5px solid #00c2ff', //newlyadded
    background: '#161c24',
    margin: 0, //5
    color: theme.palette.text.primary,
    '&:hover': {
      background: '#161c24',
    },
    '&.Mui-selected': {
      background: theme.palette.primary.main,
      color: '#fff',
    },
    '&:first-child': {
      borderRadius: '7px 0 0 7px',
      borderLeft: `1.5px solid ${theme.palette.primary.main}`,
    },
    '&:nth-child(2)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:nth-child(3)': {
      borderRadius: '0',
      borderLeft: '0',
    },
    '&:last-child': {
      borderRadius: '0 7px 7px 0',
      borderLeft: '0',
    },
  
    [theme.breakpoints.up('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('lg')]: {
      marginRight: `0 !important`,
      minWidth: '20% !important',
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: `0 !important`,
      minWidth: '30.33% !important',
    },
  }))
const ATTACHMENTS_PUBLIC_MARKER = '/storage/v1/object/public/signwise-attachments/'

const normalizeUrlString = (raw) => {
  if (!raw) return ''
  try {
    const u = new URL(raw)
    return `${u.origin}${u.pathname}`.replace(/\/+$/, '')
  } catch {
    return raw.split('?')[0].split('#')[0].trim()
  }
}

/** True for URLs / storage paths — false for bare filenames like "Screenshot.png". */
const looksLikeAttachmentRef = (raw) => {
  const s = String(raw || '')
  if (!s) return false
  if (
    s.includes('://') ||
    s.includes('/attachments/file') ||
    s.includes('/storage/v1/object/') ||
    s.includes(ATTACHMENTS_PUBLIC_MARKER)
  ) {
    return true
  }
  // storage-relative path e.g. sales-orders/123_file.png
  return s.includes('/') && /\.[a-z0-9]+$/i.test(s)
}

/** Collapse proxy URLs + direct Supabase URLs to the same storage path. */
const normalizeAttachmentIdentifier = (raw) => {
  if (!raw) return ''
  const str = String(raw).trim()
  if (!str) return ''

  if (str.includes('/attachments/file') && str.includes('path=')) {
    return normalizeUrlString(resolveAttachmentProxyPath(str))
  }

  const publicIdx = str.indexOf(ATTACHMENTS_PUBLIC_MARKER)
  if (publicIdx !== -1) {
    return normalizeUrlString(str.slice(publicIdx + ATTACHMENTS_PUBLIC_MARKER.length))
  }

  return normalizeUrlString(str)
}

const getAttachmentId = (file) =>
  file?.id ?? file?.ID ?? file?.attachment_id ?? file?.design_order_attachment_id ?? null

/** Prefer url/file_url; only use name when it is a URL/path (not a bare filename). */
const getAttachmentPrimaryRef = (f) => {
  if (!f) return ''
  if (f.url) return f.url
  if (f.file_url) return f.file_url
  if (looksLikeAttachmentRef(f.name)) return f.name
  return ''
}

const attachmentFileKey = (f) => {
  const primary = getAttachmentPrimaryRef(f)
  if (primary) return normalizeAttachmentIdentifier(primary)
  // last resort: bare name (unique only when filenames differ)
  return normalizeAttachmentIdentifier(f?.name || '')
}

const attachmentMatches = (a, b) => {
  const idA = getAttachmentId(a)
  const idB = getAttachmentId(b)
  if (idA != null && idB != null && String(idA) !== '' && String(idB) !== '') {
    return String(idA) === String(idB)
  }

  const keyA = attachmentFileKey(a)
  const keyB = attachmentFileKey(b)
  return Boolean(keyA && keyB && keyA === keyB)
}

const pruneAttachmentMapsByFile = (map, fileToRemove) => {
  if (!fileToRemove || !map) return map || {}
  const next = { ...map }
  Object.keys(next).forEach((k) => {
    const arr = next[k]
    if (!Array.isArray(arr)) return
    const filtered = arr.filter((f) => !attachmentMatches(f, fileToRemove))
    if (filtered.length === 0) {
      delete next[k]
    } else {
      next[k] = filtered
    }
  })
  return next
}

const isProductLinkedDesignAttachment = (file, productAttachmentsMap = {}) => {
  const allProductAttachmentFiles = Object.values(productAttachmentsMap).flat()
  const productAttachmentKeys = new Set(
    allProductAttachmentFiles.map(attachmentFileKey).filter(Boolean),
  )
  const productAttachmentIds = new Set(
    allProductAttachmentFiles
      .map((attachment) => getAttachmentId(attachment))
      .filter((id) => id !== null && id !== undefined)
      .map(String),
  )

  const attachmentId = getAttachmentId(file)
  if (attachmentId != null && productAttachmentIds.has(String(attachmentId))) {
    return true
  }

  const fileKey = attachmentFileKey(file)
  return Boolean(fileKey && productAttachmentKeys.has(fileKey))
}

const filterDesignOnlyAttachments = (files, productAttachmentsMap) =>
  (files || []).filter((file) => !isProductLinkedDesignAttachment(file, productAttachmentsMap))

export default function DesignOrder() {
  const theme = useTheme()
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const locationState = useLocation()
  const newTab = locationState.state?.newTab
  const [searching, setSearching] = useState(null)
  const [open, setOpen] = useState(false)
  const [page, setPage] = useState(0)
  const [preview, setPreview] = useState([])
  const [rowsPerPage, setRowsPerPage] = useState(25)
  const [totalCount, setTotalCount] = useState(0)
  const [allCount, setAllCount] = useState(0)
  const [acceptedCount, setAcceptedCount] = useState(0)
  const [rejectedCount, setRejectedCount] = useState(0)
  const [holdCount, setHoldCount] = useState(0)
  const [draftCount, setDraftCount] = useState(0)
  const [openCount, setOpenCount] = useState(0)
  const [allRequest, setAllRequest] = useState([])
  const [loadingCards, setLoadingCards] = useState(true)
  const [renderCards, setRenderCards] = useState(false)
  const [skillServices, setSkillServices] = useState([])
  const [allProducts, setAllproducts] = useState([])
  const [loadingAddFormData, setLoadingAddFormData] = useState(false)
  const [materials, setAllMaterials] = useState([])
  const [labourCostServices, setLabourCostServices] = useState([])
  const [filteredServices, setFilteredServices] = useState([])
  const [filteredMembers, setFilteredMembers] = useState([])
  const [designers, setDesigners] = useState([])
  const [collaborators, setCollaborators] = useState([])
  const [salesRepName, setSalesRepName] = useState('')
  const [salesRepId, setSalesRepId] = useState(null)
  const [salesRepOptions, setSalesRepOptions] = useState([])
  const [teamMembersOptions, setTeamMembersOptions] = useState([])
  const [teamMembersLoading, setTeamMembersLoading] = useState(false)
  const [requestTeam, setRequestTeam] = useState([])
  const [openPreview, setOpenPreview] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [selectedProducts, setSelectedProducts] = useState([])
  const [selectedMaterials, setSelectedMaterials] = useState([])
  const [selectedServices, setSelectedServices] = useState([])
  const [filtersApplied, setFiltersApplied] = useState(false)
  const [isDeletingFilters, setIsDeletingFilters] = useState(false)
  const [filtersInitialized, setFiltersInitialized] = useState(false)
  const [additionalSelectedServices, setAdditionalSelectedServices] = useState(
    [],
  )
  const [productRows, setProductRows] = useState([createEmptyProductRow(1)])
  const [productAttachments, setProductAttachments] = useState({})
  const [openProductAttachment, setOpenProductAttachment] = useState({})
  const [attachmentTabValue, setAttachmentTabValue] = useState({})
  const [selectedUploadedImages, setSelectedUploadedImages] = useState({})
  const [isUploadingProduct, setIsUploadingProduct] = useState({})
  const [productAttachmentDragOver, setProductAttachmentDragOver] = useState({})
  const [catalogPickerOpen, setCatalogPickerOpen] = useState(false)
  const [catalogPickerRowIndexId, setCatalogPickerRowIndexId] = useState(null)
  const [catalogPickerDraft, setCatalogPickerDraft] = useState(null)
  const [rowErrors, setRowErrors] = useState({})
  /** Local text for order header fields — avoids Formik+Yup validating the whole form on every keystroke */
  const [orderTextFields, setOrderTextFields] = useState({
    name: '',
    description: '',
    notes: '',
  })
  const [orderTextFieldErrors, setOrderTextFieldErrors] = useState({})
  const [productIndexCounter, setProductIndexCounter] = useState(1)
  const [tabValue, setTabValue] = useState('one');
  
  // Fetch view type from backend
  const fetchViewType = async () => {
    try {
      const userId = user?.user_id || user?.id;
      if (!userId) return;
      
      const res = await axios.post(`${REST_API_END_POINT}get-design-order-view-type`, { userId });
      if (res.data?.status === 1 && res.data?.data?.viewType !== undefined) {
        setTabValue(res.data.data.viewType);
      }
    } catch (error) {
      console.error('Error fetching view type:', error);
    }
  };
  
  // Load view type from backend on mount
  useEffect(() => {
    fetchViewType();
    if (userId) fetchTeamMembersForCollaborators();
  }, []);

  

    const handleChange = async (event, newValue) => {
    setTabValue(newValue);
    
    // Save view type to backend
    try {
      const userId = user?.user_id || user?.id;
      if (!userId) return;
      
      await axios.post(`${REST_API_END_POINT}update-design-order-view-type`, { userId, viewType: newValue });
    } catch (error) {
      console.error('Error updating view type:', error);
    }
  };
  const [avatarUrl, setAvatarUrl] = useState([])
  const [referenceFiles, setReferenceFiles] = useState([])
  const [location, setLocation] = useState(false)
  const [projectTypes, setProjectTypes] = useState([])
  const [workflow, setWorkFlow] = useState([])
  const [projectCategories, setProjectCategories] = useState([])
  const [communities, setCommunities] = useState([])
  const [isCommunityLoading, setIsCommunityLoading] = useState(false)
  const [locationStates, setLocationStates] = useState({})
  const [serviceOnlyLocationStates, setServiceOnlyLocationStates] = useState({})
  const [rfpLocationStates, setRfpLocationStates] = useState({})
  const [rfpServiceLocationStates, setRfpServiceLocationStates] = useState({})
  const [allLocationSame, setAllLocationSame] = useState(false)
  const [allServiceLocationSame, setAllServiceLocationSame] = useState(false)
  const [allRfpServiceLocationSame, setAllRfpServiceLocationSame] =
    useState(false)
  const [allRfpProductsLocationSame, setAllRfpProductsLocationSame] =
    useState(false)
  const [address, setAddress] = useState({
    23: [{ 0: { address: 'addd', city: 'fsdasadf', state: 'fsd', zip: 1654 } }],
  }) // 23:[{address:'sdfsdf',city:'fsdasadf',state:'fsd',zip:1654}]
  const [progress, setProgress] = useState(null)
  const [currentDate, setCurrentDate] = useState(() => localTodayDateOnlyUnix())
  let user = JSON.parse(localStorage.getItem('user'))
  let userType = user.user_type
  let userId = user.user_id
  let isClient = user.isClient
  let teamId=user.team_id||null;

  if(user.added_by_client && user.parent_user_type && user.parent_id) {
    userId = user.parent_id
    userType = 3 //user.parent_user_type
  }

 

  // Fetch team members for collaborators dropdown
  const fetchTeamMembersForCollaborators = async () => {
    if (!userId) return; // guard
    setTeamMembersLoading(true);
    try {
      const res = await axios.post(`${REST_API_END_POINT}teams/get-all-teams-data-collaborators`, {
        usersId: userId,
        usersType: userType,
        isClient: isClient || false,
        page: 1,
        rowsPerPage: 5000,
        orderBy: 'name',
        order: 'asc',
      });
      const raw = res.data?.team_members?.data || res.data?.team_members || [];
      const list = Array.isArray(raw) ? raw : [];
      const filteredList = list.filter(member => member.userRole !== "Development" && member.user_type !== 51);
      setTeamMembersOptions(filteredList);
    } catch (error) {
      console.log(error, 'Error fetching team members for collaborators');
      setTeamMembersOptions([]);
    } finally {
      setTeamMembersLoading(false);
    }
  };

  const explodedPermissions = user?.exploded_permissions
  const hasMarkupPermission = explodedPermissions?.some((permission) =>
    ['View Markup'].includes(permission),
  )
    ? true
    : false
  const hasDiscountPermission = explodedPermissions?.some((permission) =>
    ['Manage Discount'].includes(permission),
  )
    ? false
    : true

    const viewasadmin =explodedPermissions?.some(permission => ['View Design Order as Admin'].includes(permission)) ? true : false
    
  const refClients = useRef(null)
  const [clientsOpen, setClientsOpen] = useState(false)
  const [clientData, setClientData] = useState([])
  const [filterClient, setFilterClient] = useState([])
  const [clientSearchTerm, setClientSearchTerm] = useState('')
  const [projectSearchTerm, setProjectSearchTerm] = useState('')
  const [filterProject, setFilterProject] = useState([])
  const refCommunities = useRef(null)
  const refProjects = useRef(null)
  const [allClients, setAllClients] = useState([])
  const [client, setClient] = useState([])
  const [projectData, setProjectData] = useState([])
  const [projectsOpen, setProjectsOpen] = useState(false)
  const [markupType, setMarkupType] = useState(2)
  const [order, setOrder] = useState('desc')
  const [orderBy, setOrderBy] = useState('id')
  const [currentTab, setCurrentTab] = useState(newTab || 'ALL')
  const [indexCounter, setIndexCounter] = useState(0)
  const [serviceIndexCounter, setServiceIndexCounter] = useState(0)
  const printableContentRef = useRef()
  const [openModal, setOpenModal] = useState(false)
  const [tabIndex, setTabIndex] = useState(0)
  const [rfpServices, setRfpServices] = useState([])
  const [rfpProducts, setRfpProducts] = useState([])
  const [cart, setCart] = useState([])
  const [cartService, setCartService] = useState([])
  const [totalProductLabourCost, setTotalProductLabourCost] = useState(0)
  const [filterDateValue, setFilterDateValue] = useState([null, null])
  const [sort, setSort] = useState(SORT[0])
  const [sortOpen, setSortOpen] = useState(false)
  const refSort = useRef(null)
  const refSettings = useRef(null)
  const [filtersAnchorEl, setFiltersAnchorEl] = useState(null)
  const isFiltersOpen = Boolean(filtersAnchorEl)
  const [isNewRowIdPresent,setIsNewRowIdPresent] = useState([])
  const [openProductNote, setOpenProductNote] = useState({})
  const [isSavingNote, setIsSavingNote] = useState(false)

  const grouping = useDesignOrderProductGrouping({
    productRows,
    setProductRows,
    markupType,
    theme,
    enqueueSnackbar,
    productAttachments,
    setProductAttachments,
    explodedPermissions,
    hasMarkupPermission,
    onRemapRowSideEffects: (indexIdMap) => {
      setRowErrors((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = indexIdMap[oldKey]
          if (newKey !== undefined) next[newKey] = prev[oldKey]
        })
        return next
      })
      setProductAttachments((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = indexIdMap[oldKey]
          if (newKey !== undefined) next[newKey] = prev[oldKey]
        })
        return next
      })
    },
  })

  const {
    productTableBodyRenderOrder,
    groupedProducts,
    groupedProductsMap,
    catalogProducts,
    setCatalogProducts,
    groupSelectedProductIds,
    groupEditMode,
    toggleGroupProductSelection,
    getProductAttachmentsList: getGroupProductAttachmentsList,
  } = grouping

  const designOrderGroupValueColumns = useMemo(
    () => getDesignOrderGroupValueColumns(markupType, hasMarkupPermission),
    [markupType, hasMarkupPermission],
  )

  const hasNegativeDesignMarketingPermission = explodedPermissions?.some((permission) =>
    DESIGN_ORDER_NEGATIVE_MARKETING_PERMISSIONS.includes(permission),
  )
  const [currentNote, setCurrentNote] = useState('')
  const [selectedTaxCategory, setSelectedTaxCategory] = useState(null)
  const [taxCategories, setTaxCategories] = useState([])
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [isSavingDraft, setIsSavingDraft] = useState(false)
  const [dueData,setDueData] = useState(true)
  const didRunInitialFiltersSyncRef = useRef(false)
  const[membersLoading,setMembersLoading] = useState(false)
  const [isUploading,setIsUploading] = useState(false)
  const [isUploadingReference,setIsUploadingReference] = useState(false)
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [progressRequestData, setProgressRequestData] = useState(null);
  const [socketReady, setSocketReady] = useState(false);
  const [progressHeading, setProgressHeading] = useState('Creating Design Order');
  const [autoUpdateData, setAutoUpdateData] = useState(null);
  const [designFormData, setDesignFormData] = useState({});
  const [mainTab, setMainTab] = useState(0); // 0 = Form Content, 1 = Design Form

  // Auto-save confirmation dialog state
  const [openBackConfirm, setOpenBackConfirm] = useState(false);
  
  const handleOpenDesignOrderTemp = localStorage.getItem(
    'designOrderOpenProductionPopup',
  )
  const [handleOpenDesignOrder, setHandleOpenDesignOrder] = useState(
    handleOpenDesignOrderTemp || false,
  )
  const [designOrderId, setDesignOrderId] = useState(false)
  const [designOrderName, setDesignOrderName] = useState(false)
  const [isEditDesignOrder, setIsEditDesignOrder] = useState(false)

  const handleOpenViewDesignOrder = (id, name) => {
    setIsEditDesignOrder(true)
    setDesignOrderId(id)
    setDesignOrderName(name)
    setHandleOpenDesignOrder(true)
    localStorage.setItem('designOrderProjectId', id);
    localStorage.setItem('designOrderProjectName', name);
    localStorage.setItem('isEditDesignOrder', "true");
    localStorage.setItem('designOrderOpenProductionPopup', 'true');
  }
  const handleOpenDetailsDesignOrder = (id, name) => {
    setIsEditDesignOrder(false)
    setDesignOrderId(id)
    setDesignOrderName(name)
    setHandleOpenDesignOrder(true)
    localStorage.setItem('designOrderProjectId', id);
    localStorage.setItem('designOrderProjectName', name);
    localStorage.setItem('isEditDesignOrder', "false");
    localStorage.setItem('designOrderOpenProductionPopup', 'true');
  }

  const getCommunitySalesRepIds = (community) => {
    // Use ?? so an empty eligible list does not fall back to raw stored IDs.
    const rawIds = community?.all_sales_rep_ids ?? community?.sales_rep_ids;
    if (!rawIds) {
      return [];
    }

    const ids = Array.isArray(rawIds)
      ? rawIds
      : typeof rawIds === 'string'
        ? rawIds.split(',')
        : [];

    return ids
      .map((id) => String(id ?? '').trim())
      .filter(Boolean);
  };

  const getSalesRepOptionsFromCommunity = (community) => {
    const rawNames = community?.all_sales_rep_names ?? community?.sales_rep_names;
    const rawIds = community?.all_sales_rep_ids ?? community?.sales_rep_ids;

    const names = Array.isArray(rawNames)
      ? rawNames
      : typeof rawNames === 'string'
        ? rawNames.split(',').map((s) => s.trim()).filter(Boolean)
        : [];

    const ids = Array.isArray(rawIds)
      ? rawIds
      : typeof rawIds === 'string'
        ? rawIds.split(',').map((s) => s.trim()).filter(Boolean)
        : [];

    const maxLen = Math.max(names.length, ids.length);
    const options = [];

    for (let idx = 0; idx < maxLen; idx += 1) {
      const id = ids[idx] ?? null;
      const rawName = names[idx];

      const matchedTeamMember = teamMembersOptions?.find((member) => {
        const memberId = member?.id ?? member?.user_id;
        return id != null && memberId != null && String(memberId) === String(id);
      });

      const fallbackName =
        matchedTeamMember?.name ||
        [matchedTeamMember?.first_name, matchedTeamMember?.last_name].filter(Boolean).join(' ').trim();

      const name = String(rawName ?? '').trim() || fallbackName || '';
      if (!name && id == null) continue;

      options.push({
        id,
        name: name || String(id),
      });
    }

    return options;
  };

  
  const handleByDue =()=>{
    setDueData(!dueData)
  }

  const handleOpenFilters = (event) => {
    setFiltersAnchorEl(event.currentTarget)
  }

  const handleCloseFilters = () => {
    setFiltersAnchorEl(null)
    setClientsOpen(false)
    setProjectsOpen(false)
    setSortOpen(false)
  }




  const handleOpenNote = (indexId, note) => {
    setCurrentNote(note || '')
    setOpenProductNote((prev) => ({ ...prev, [indexId]: true }))
  }

  const handleCloseNote = (indexId) => {
    const isInstall = typeof indexId === 'string' && indexId.endsWith('_install')
    const realIndexId = isInstall ? indexId.replace('_install', '') : indexId
    setOpenProductNote((prev) => ({
      ...prev,
      [indexId]: false,
      [realIndexId]: false,
      [`${realIndexId}_install`]: false,
    }))
    setCurrentNote('')
    grouping.setOpenGroupProductNoteIndex(null)
    grouping.setOpenGroupInstallNoteIndex(null)
  }

  const handleNoteChange = (event) => {
    const newNote = event.target.value
    if (newNote.length <= MAX_CHARACTERS) {
      setCurrentNote(newNote)
    }
  }

  const getNoteTargetIds = (indexId) => {
    const isInstall = typeof indexId === 'string' && indexId.endsWith('_install')
    const realIndexId = isInstall ? indexId.replace('_install', '') : indexId
    if (isInstall) {
      const fromInstallTargets =
        grouping.groupInstallNoteTargets?.[String(realIndexId)] ||
        grouping.groupInstallNoteTargets?.[String(indexId)]
      if (Array.isArray(fromInstallTargets) && fromInstallTargets.length) {
        return fromInstallTargets
      }
      // Fall back to all current group members when editing install note on a grouped row
      const product = (productRows || []).find(
        (row) => Number(row?.indexId) === Number(realIndexId),
      )
      const groupId = product?.catalogProduct?.group_id ?? product?.group_id
      if (groupId != null && groupId !== '') {
        const memberIds = (productRows || [])
          .filter(
            (row) =>
              String(row?.catalogProduct?.group_id ?? row?.group_id ?? '') ===
              String(groupId),
          )
          .map((row) => row.indexId)
        if (memberIds.length) return memberIds
      }
      return [realIndexId]
    }
    const fromGroupTargets =
      grouping.groupNoteTargets?.[String(indexId)] ||
      grouping.groupNoteTargets?.[String(realIndexId)]
    if (Array.isArray(fromGroupTargets) && fromGroupTargets.length) {
      return fromGroupTargets
    }
    return [realIndexId]
  }

  const handleSaveNote = (indexId) => {
    setIsSavingNote(true)
    setTimeout(() => {
      const isInstall = typeof indexId === 'string' && indexId.endsWith('_install')
      const realIndexId = isInstall ? indexId.replace('_install', '') : indexId
      const targetIds = getNoteTargetIds(indexId)
      const targetIdSet = new Set(targetIds.map(String))

      setProductRows((prev) =>
        prev.map((row) => {
          if (!targetIdSet.has(String(row.indexId))) return row
          if (row.entryMode === 'choose' && row.catalogProduct) {
            return {
              ...row,
              catalogProduct: isInstall
                ? { ...row.catalogProduct, install_notes: currentNote }
                : { ...row.catalogProduct, product_notes: currentNote },
            }
          }
          return isInstall
            ? { ...row, install_notes: currentNote }
            : { ...row, product_notes: currentNote }
        }),
      )
      setIsSavingNote(false)
      // Always close popup (group note path used to skip this and leave install modal open)
      handleCloseNote(indexId)
    }, 100)
  }

  const handleOpenGroupNote = (indexId, note) => {
    setCurrentNote(note || '')
    grouping.handleOpenGroupNote(indexId)
  }

  const handleOpenGroupInstallNote = (indexId, note) => {
    setCurrentNote(note || '')
    grouping.handleOpenGroupInstallNote(indexId)
    setOpenProductNote((prev) => ({ ...prev, [`${indexId}_install`]: true }))
  }

  const handleClearNote = (indexId) => {
    setTimeout(() => {
      const isInstall = typeof indexId === 'string' && indexId.endsWith('_install')
      const realIndexId = isInstall ? indexId.replace('_install', '') : indexId
      const targetIds = getNoteTargetIds(indexId)
      const targetIdSet = new Set(targetIds.map(String))

      setProductRows((prev) =>
        prev.map((row) => {
          if (!targetIdSet.has(String(row.indexId))) return row
          if (row.entryMode === 'choose' && row.catalogProduct) {
            return {
              ...row,
              catalogProduct: isInstall
                ? { ...row.catalogProduct, install_notes: '' }
                : { ...row.catalogProduct, product_notes: '' },
            }
          }
          return isInstall
            ? { ...row, install_notes: '' }
            : { ...row, product_notes: '' }
        }),
      )
      handleCloseNote(indexId)
    }, 100)
  }

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue)
  }

  const addToCart = (item) => {
    if (tabIndex === 0) {
      let addresses = [
        {
          id: 0,
          address: '',
          city: '',
          state: '',
          zip: '',
        },
      ]
      setCartService([...cartService, { ...item, addresses: addresses }])
    } else {
      let addresses = [
        {
          id: 0,
          address: '',
          city: '',
          state: '',
          zip: '',
        },
      ]
      setCart([...cart, { ...item, addresses: addresses }])
    }

    setOpenModal(false)
    setFieldValue('rfp', null)
    if (allRfpServiceLocationSame) {
      const commonAddress = cartService[0]?.addresses?.[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      }

      setCartService((prevProducts) =>
        prevProducts.map((product) => ({
          ...product,
          addresses: product.addresses
            ? product.addresses.map(() => ({ ...commonAddress }))
            : [{ ...commonAddress }],
        })),
      )
    }

    if (allRfpProductsLocationSame) {
      const commonAddress = cart[0]?.addresses?.[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      }

      setCart((prevProducts) =>
        prevProducts.map((product) => ({
          ...product,
          addresses: product.addresses
            ? product.addresses.map(() => ({ ...commonAddress }))
            : [{ ...commonAddress }],
        })),
      )
    }
  }
  const handleMaterial = (newValue) => {
    setSelectedMaterials(newValue)
  }
  const handleDeleteMaterial = (id) => {
    const updatedMaterials = selectedMaterials.filter(
      (material) => material.id !== id,
    )
    setSelectedMaterials(updatedMaterials)
  }
  const isInCart = (item) => {
    return cart.some((cartItem) => cartItem.product_id === item.product_id)
  }
  const isInCartService = (item) => {
    return cartService.some((cartItem) => cartItem.id === item.id)
  }
  const closeModal = () => {
    setOpenModal(false)
    setFieldValue('rfp', null)
  }
  
  const handleDeleteRFPProduct = (productId) => {
    setCart((prevCart) => prevCart.filter((item) => item.id !== productId))
  }
  const handleDeleteRFPService = (productId) => {
    setCartService((prevCart) =>
      prevCart.filter((item) => item.id !== productId),
    )
  }
  function handleToggleClient(id) {
    setFilterClient((prevIds) => {
      // If not yet in filterCommunity, add it
      if (!prevIds.includes(id)) {
        return [...prevIds, id]
      }
      // If it's already in there, remove it
      return prevIds.filter((oldId) => oldId !== id)
    })
  }

   // Load saved filters for Design Order page
   useEffect(() => {
    const loadSavedDesignOrderFilters = async () => {
      try {
        if (!userId) return;

        const response = await axios.post(`${REST_API_END_POINT}get-project-filters`, {
          userId,
          pageKey: 'design_order',
        });

        if (response?.data?.status === 1 && response?.data?.data) {
          const saved = response.data.data;
          if(saved.filtersApplied) {
            setFiltersApplied(true);
          }

          setFilterDateValue([
            saved.fromDate ? new Date(saved.fromDate * 1000) : null,
            saved.toDate ? new Date(saved.toDate * 1000) : null,
          ]);

          setDueData(Number(saved.dueFilter) === 1);
          if (saved.sortFilter) {
            const matchedSort = SORT.find((item) => item.id === saved.sortFilter);
            if (matchedSort) {
              setSort(matchedSort);
            }
          }
          if (Array.isArray(saved.clientFilter)) {
            setFilterClient(saved.clientFilter);
          }
          if (Array.isArray(saved.communityFilter)) {
            setFilterProject(saved.communityFilter);
          }
        }
      } catch (error) {
        console.error('Error loading design order filters:', error);
      } finally {
        setFiltersInitialized(true)
      }
    }
    loadSavedDesignOrderFilters()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // Persist Design Order list filters to shared preferences
  useEffect(() => {
    if (!filtersInitialized) return

    // Skip calling update-project-filters once right after initial load
    if (!didRunInitialFiltersSyncRef.current) {
      didRunInitialFiltersSyncRef.current = true
      return
    }

    // While deleting filters, don't sync to backend
    if (isDeletingFilters) return

    if (!userId) return

    const timeoutId = setTimeout(async () => {
      try {
        await axios.post(`${REST_API_END_POINT}update-project-filters`, {
          userId,
          teamFilter: [],
          clientFilter: filterClient || [],
          communityFilter: filterProject || [],
          userFilter: [],
          jobClassFilter: [],
          jobTypeFilter: [],
          projectTypeFilter: null,
          dueFilter: dueData ? 1 : 0,
          sortFilter: sort?.id || 'new',
          fromDate: filterDateValue[0]
            ? Math.floor(filterDateValue[0].getTime() / 1000)
            : null,
          toDate: filterDateValue[1]
            ? Math.floor(filterDateValue[1].getTime() / 1000)
            : null,
          pageKey: 'design_order',
        })
        const hasActiveFilters =
          (filterClient && filterClient.length > 0) ||
          (filterProject && filterProject.length > 0) ||
          !dueData ||
          sort?.id !== SORT[0]?.id ||
          !!filterDateValue[0] ||
          !!filterDateValue[1]

        setFiltersApplied(hasActiveFilters)
      } catch (error) {
        console.error('Error saving design order filters:', error)
      }
    }, 300)
    return () => clearTimeout(timeoutId)
  }, [
    userId,
    filterClient,
    filterProject,
    dueData,
    sort,
    filterDateValue,
    filtersInitialized,
    isDeletingFilters,
  ])

  const deleteDesignOrderFilters = async () => {
    if (!userId || isDeletingFilters) return

    setIsDeletingFilters(true)
    try {
      await axios.post(`${REST_API_END_POINT}delete-project-filters`, {
        userId,
        pageKey: 'design_order',
      })

      setFilterClient([])
      setFilterProject([])
      setDueData(true)
      setSort(SORT[0])
      setFilterDateValue([null, null])
      setPage(0)
      setFiltersApplied(false)
    } catch (error) {
      console.error('Error deleting design order filters:', error)
    } finally {
      setIsDeletingFilters(false)
    }
  }

  function handleToggleProject(id) {
    setFilterProject((prevIds) => {
      // If not yet in filterProject, add it
      if (!prevIds.includes(id)) {
        return [...prevIds, id]
      }
      // If it's already in there, remove it
      return prevIds.filter((oldId) => oldId !== id)
    })
  }
  // const [userId, setUserId] = useState(() => {
  //   const storedUser = JSON.parse(localStorage.getItem('user'));
  //   return storedUser ? storedUser.user_id : null;
  // });

  // useEffect(() => {
  //   if (selectedProducts.length <= 0) {
  //     setAllLocationSame(false)
  //   }
  //   if (additionalSelectedServices.length <= 0) {
  //     setAllServiceLocationSame(false)
  //   }
  //   if (cart.length <= 0) {
  //     setAllRfpProductsLocationSame(false)
  //   }
  //   if (cartService.length <= 0) {
  //     setAllRfpServiceLocationSame(false)
  //   }
  // }, [selectedProducts, additionalSelectedServices, cart, cartService])
   const VALUE = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    { id: 3, value: 'Note' },
    //  { id: 4, value: 'Product formula cost (Material cost + Service cost with markup)' },
    { id: 5, value: 'Product formula cost' },
    {
      id: 6,
      value: markupType
        ? markupType == 2 && hasMarkupPermission
          ? 'Selling Price (per product)'
          : null
        : null,
    },
    {
      id: 7,
      value: markupType
        ? markupType == 1 && hasMarkupPermission
          ? 'Selling Price (per product)'
          : null
        : null,
    },
    { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    { id: 8, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 9, value: 'Unit' },
    { id: 10, value: 'Quantity' },
    { id: 11, value: 'Location' },
    { id: 11, value: 'Marketing Adjustment Type' },
    { id: 12, value: 'Marketing Adjustment ' },
    // { id: 12, value: 'Discount' },
    { id: 13, value: 'Subtotal' },
    { id: 15, value: '' },
  ]
  const VALUE_TIME = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    { id: 3, value: 'Note' },
    { id: 4, value: 'Selling Price (per product)' },
    { id: 14, value: 'SPMA' },
    { id: 5, value: 'Unit' },
    { id: 6, value: 'Quantity' },
    { id: 7, value: 'Location' },
    { id: 11, value: 'Marketing Adjustment Type' },
    { id: 8, value: 'Marketing Adjustment ' },
    { id: 9, value: 'Subtotal' },
    { id: 10, value: '' },
  ]
  const VALUE_TIME_Preview = [
    { id: 1, value: 'Sl No.' },
    { id: 2, value: 'Products' },
    // { id: 3, value: 'Note' },
    { id: 4, value: 'Selling Price (per product)' },
    { id: 14, value: 'SPMA' },
    { id: 5, value: 'Unit' },
    { id: 6, value: 'Quantity' },
    // { id: 7, value: 'Location' },
    { id: 8, value: 'Marketing Adjustment' },
    { id: 9, value: 'Subtotal' },
    { id: 10, value: '' },
  ]
  const VALUE_MATERIAL = [
    { id: 0, value: 'Product' },
    { id: 1, value: 'Unit Price' },
    { id: 2, value: 'Markup (%)' },
    { id: 3, value: 'Markup Cost (Unit)' },
    { id: 4, value: 'Quantity' },
    { id: 5, value: 'Product Formula Cost' },
    { id: 6, value: 'Total' },
    { id: 7, value: '' },
  ]
  const VALUEPreview = [
    { id: 0, value: 'Sl No.' },
    { id: 1, value: 'Products & Notes' },
    // { id: 2, value: 'Product formula cost' }, // (Material cost + Service cost with markup)
    {
      id: 3,
      value: markupType
        ? markupType == 2 && hasMarkupPermission
          ? 'Selling Price (per product)'
          : null
        : null,
    },
    {
      id: 4,
      value: markupType
        ? markupType == 1 && hasMarkupPermission
          ? 'Selling Price (per product)'
          : null
        : null,
    },
    { id: 14, value: hasMarkupPermission ? 'SPMA' : null },
    { id: 5, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 6, value: 'Unit  ' },
    { id: 7, value: 'Quantity' },
    { id: 8, value: 'Marketing Adjustment' },
    // { id: 8, value: 'Discount' },
    { id: 9, value: 'Subtotal' },
    { id: 10, value: '' },
  ]

  const VALUE_SERVICES = [
    // { id: 0, value: 'Product Sl No.' },
    { id: 1, value: 'Service Name' },
    { id: 2, value: 'Markup (%)' },
    { id: 3, value: 'Cost (Hourly)' },
    { id: 4, value: 'Markup Cost (Hourly)' },
    { id: 5, value: 'Hours' },
    // { id: 6, value: 'Location' },
    { id: 7, value: 'Product Formula Cost' },
    { id: 8, value: 'Additional Cost' },
    { id: 9, value: 'Total cost' },
    { id: 10, value: '' },
  ]
  const VALUE_RFP_Product = [
    { id: 0, value: ' Name' },
    { id: 1, value: 'Mark Up' },
    { id: 2, value: 'Cost ' },
    { id: 3, value: 'Selling Price' },
    { id: 4, value: 'Unit' },
    { id: 5, value: 'Quantity' },
    { id: 6, value: 'Product Formula Cost' },
    { id: 7, value: 'Total' },
    { id: 8, value: '' },
    { id: 9, value: '' },
  ]
  const VALUE_RFP = [
    { id: 0, value: ' Name' },
    { id: 1, value: 'Markup (%)' },
    { id: 2, value: 'Cost ' },
    { id: 3, value: 'Markup Cost (Hourly)' },
    { id: 4, value: 'Hours' },
    { id: 5, value: 'Total cost' },
    { id: 6, value: '' },
    { id: 7, value: '' },
  ]
  // const [expandedCommunities, setExpandedCommunities] = useState({});

  // const handleExpandToggle = (community) => {
  //   setExpandedCommunities(prevState => ({
  //     ...prevState,
  //     [community]: !prevState[community]
  //   }));
  // };

  const NewUserSchema = Yup.object().shape({
    // name / description validated manually on submit (local state); keeps typing responsive
    clients:
      (userType != 3 && !isClient) && Yup.object().nullable().required('Client is required'),
    start: Yup.mixed().required('Start Date is required'),
    end: Yup.date()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue ? new Date(originalValue * 1000) : null
      })
      .when('start', (start, schema) => {
        return start
          ? schema.min(
              start,
              'Due Date must be greater than the Start Date',
            )
          : schema
      }),
    // project_type: userType != 3 && Yup.object().nullable().required('Job Type is required'),
    // markup_type: userType != 3 && Yup.object().nullable().required('Please select the markup type'),
    // project_categories: userType != 3 && Yup.object().nullable().required('Job Category is required'),
    community:( userType != 3 && !isClient) && Yup.object().nullable().required('Project is required,Enable projects for client'),
  })
  //
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
  }))
  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    // color: theme.palette.text.secondary,
  }))
  const load = useLocation().state
  // Reusable function for calling all-design-order API and updating shared state
  const fetchDesignOrders = async (values, tabName) => {
    try {
      const res = await axios.post(`${REST_API}webservice/design/all-design-order`, values);

      const data = res?.data?.data;
      const requests = Array.isArray(data?.data) ? data.data : [];

      setAllRequest(requests);
      // if (data?.totalCount) {
      //   setTotalCount(data.totalCount);
      // } else {
      //   setTotalCount(0);
      // }

      // const othersClient = { id: 'other', name: 'Others' };
      // if (res.data?.clients) {
      //   setClientData([...res.data.clients]);
      // } else {
      //   setClientData([othersClient]);
      // }

      // const othersProject = { id: 'other', name: 'Others' };
      // if (res.data?.community) {
      //   setProjectData([...res.data.community, othersProject]);
      // } else {
      //   setProjectData([othersProject]);
      // }

      // Update allCount based on tab
      // if (tabName) {
      //   if (tabName === 'ALL') {
      //     setAllCount(data?.totalCount || 0);
      //   } else if (tabName === 'DRAFT') {
      //     setDraftCount(data?.totalCount || 0);
      //   } else {
      //     setAllCount(data?.allCount || 0);
      //   }
      // }
    } catch (errors) {
      console.log(errors, 'error in fetching all requests');
    }
  };

  const fetchDesignOrdersPaginationCounts = async (values, tabName) => {
    try {
      const res = await axios.post(`${REST_API}webservice/design/design-order-pagination-count`, values);

      const data = res?.data?.data;
      const requests = data?.data || [];

      if (data?.totalCount) {
        setTotalCount(data.totalCount);
      } else {
        setTotalCount(0);
      }
      if (tabName) {
        if (tabName === 'ALL') {
          setAllCount(data?.totalCount || 0);
        } else if (tabName === 'DRAFT') {
          setDraftCount(data?.totalCount || 0);
        } else {
          setAllCount(data?.allCount || 0);
        }
      }
    } catch (errors) {
      console.log(errors, 'error in fetching all requests');
    }
  };

  //get All request
  const fetchAllRequest = async () => {
    setLoadingCards(true)
    try {
      let user = JSON.parse(localStorage.getItem('user'))
     

      let whereCondition = ''
      if (currentTab == 'NEW') {
        whereCondition = ` d.status = 1 AND d.hold = 0 AND d.is_in_queue = 0 AND d.design_order_job_status = 1 AND d.send_client_app_req=0`
        // whereCondition = ` d.status=1 AND d.hold=0 AND doa.id IS NULL AND d.design_order_job_status != 3 AND d.send_client_app_req=0`
      } else if (currentTab == 'IN QUEUE') {
        whereCondition = ` d.status = 1 AND d.hold = 0 AND d.is_in_queue = 1 AND d.design_order_job_status IN (1,7) AND d.send_client_app_req=0`
        // whereCondition = ` doa.id IS NOT NULL AND d.status = 1 AND d.hold = 0 AND d.send_client_app_req=0 AND d.design_order_job_status != 3`
      } else if (currentTab == 'IN DESIGN') {
        whereCondition = ` d.status = 1 AND d.hold = 0 AND d.design_order_job_status = 2 AND d.send_client_app_req=0`
        // whereCondition = ` doa.id IS NOT NULL AND d.status = 1 AND d.hold = 0 AND d.send_client_app_req=0 AND d.design_order_job_status != 3`
      } else if (currentTab == 'REVIEW/SEND FOR APPROVAL') {
        whereCondition = ` d.design_order_job_status = 3 AND d.send_client_app_req=0 AND d.status !=0 AND d.hold = 0`
      } else if (currentTab == 'AWAITING APPROVAL') {
        // Match list label logic (DesignOrderList): send_client_app_req=1 is enough
        whereCondition = ` d.status=1 AND d.hold=0 AND d.send_client_app_req=1`
      } else if (currentTab == 'APPROVED') {
        whereCondition = ` d.status=2 AND d.hold=0`
      } else if (currentTab == 'REJECTED') {
        whereCondition = ` d.status=6 AND d.hold=0`
      } else if (currentTab == 'HOLD') {
        whereCondition = ` d.hold=1 AND d.status !=0`
      } else if (currentTab == 'DRAFT') {
        whereCondition = ` d.status=4 AND d.hold=0`
      }
      const formattedFrom = filterDateValue[0]
        ? moment(filterDateValue[0]).format('YYYY-MM-DD HH:mm:ss')
        : null
      const formattedTo = filterDateValue[1]
        ? moment(filterDateValue[1]).format('YYYY-MM-DD HH:mm:ss')
        : null

      const values = {
        userType: viewasadmin ? 1 : userType,
        userId: userId,
        page: page + 1,
        rowsPerPage,
        search: searching,
        where: whereCondition,
        sort: sort.id,
        from: formattedFrom,
        to: formattedTo,
        dueData:dueData,
        filterClient:filterClient,
        filterProject:filterProject,
        isClient:isClient
      }

      await fetchDesignOrders(values, currentTab);
      await fetchDesignOrdersPaginationCounts(values, currentTab);
    } catch (error) {
      console.log('fetchAllRequest error : ', error)
    } finally {
      setLoadingCards(false)
    }
  }

  // const fetchDesignOrderCount = async () => {
  //   try {
      
  //     const response = await axios.post(`${REST_API}webservice/design/design-order-tabs-count`, { userId });
  //     console.log("response.data",response.data.data)
  //     if (response?.data?.status === 1) {
  //       const { open_count_ids = [], approved_count_ids = [] ,rejected_ids =[],hold_count_ids = [] } = response.data?.data;
  //         const validOpenCountIds = open_count_ids ? open_count_ids.split(',') : [];
  //         const validApprovedCountIds = approved_count_ids ? approved_count_ids.split(',') : [];
  //         const validRejectedIds = rejected_ids ? rejected_ids.split(',') : [];
  //         const validHoldCountIds = hold_count_ids ? hold_count_ids.split(',') : [];
  //         const allIds = [...validOpenCountIds, ...validApprovedCountIds,...validRejectedIds,...validHoldCountIds];
  //         const uniqueIds = [...new Set(allIds)];
  //         const commaSeparatedIds = uniqueIds.join(',');
  //         setIsNewRowIdPresent(commaSeparatedIds);
  //         console.log('commaSeparatedIds', commaSeparatedIds)

  //       // setOpenCount(response.data?.data?.open_count);
  //       // setAcceptedCount(response.data?.data?.approved_count);
  //       // setRejectedCount(response.data?.data?.rejected_count);
  //       // setHoldCount(response.data?.data?.hold_count);
  //     } else {
  //       console.warn("Failed to fetch design order counts:", response?.data?.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching design order counts:", error);
  //   }
  // };  
  // useEffect(()=>{
  //   fetchDesignOrderCount()
  // },[open, searching, rowsPerPage, sort, filterDateValue, dueData,filterClient, filterProject, renderCards])

  useEffect(() => {
    if (!filtersInitialized) return
    if (isDeletingFilters) return
    fetchAllRequest()
  }, [filtersInitialized, open, currentTab, page, searching, rowsPerPage, sort, filterDateValue, dueData,filterClient, filterProject, renderCards, isDeletingFilters])

  // Browser back button interception for auto-save (only when form is open)
  useEffect(() => {
    if (!open) return; // Only intercept when form is open

    const handlePopState = (event) => {
      event.preventDefault();
      setOpenBackConfirm(true);
      // Push a dummy state to prevent immediate navigation
      window.history.pushState(null, '', window.location.href);
    };

    // Push initial state for back button interception
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [open]);

  const handleOnDragEnd = (result) => {
    if (!result.destination) return
    const reorderedItems = Array.from(allRequest)
    const [movedItem] = reorderedItems.splice(result.source.index, 1)
    reorderedItems.splice(result.destination.index, 0, movedItem)
    setAllRequest(reorderedItems)
    saveNewOrder(reorderedItems)
  }

  const saveNewOrder = async (reorderedItems) => {
    try {
      await axios.post(`${REST_API}webservice/design/update-card-order`, {
        reorderedItems,
      })
      console.log('Order saved successfully')
    } catch (error) {
      console.error('Error saving order:', error)
    }
  }

  const fetchAllCommunityByClient = async (clientId) => {
    setIsCommunityLoading(true)
    try {
      clientId = clientId.id
      const res = await axios.post(
        `${REST_API}webservice/rfq/get-community-by-client`,
        { clientId,From:"addSalesOrder",teamId: teamId,userType:userType},
      )
      let data = res.data?.community || []
      // Sort communities alphanumerically by name
      const sortedCommunities = [...data].sort((a, b) => 
        alphanumericCompare(a?.name || '', b?.name || '')
      )
      setCommunities(sortedCommunities)
    } catch (error) {
      console.log(error, 'Error in fetching all clients')
      setCommunities([])
    } finally {
      setIsCommunityLoading(false)
    }
  }

  const applyClientsFromResponse = (clientsList = [], communityList = []) => {
    const data = clientsList || []
    setAllClients(data)
    const filteredClient = data.filter((client) => client.user_id === userId)
    if (filteredClient[0]) {
      setClient(filteredClient[0])
      fetchAllCommunityByClient(filteredClient[0])
    }
    const othersClient = { id: 'other', name: 'Others' }
    setClientData(data.length ? [...data] : [othersClient])
    const othersProject = { id: 'other', name: 'Others' }
    if (communityList?.length) {
      setProjectData([...communityList, othersProject])
    } else {
      setProjectData([othersProject])
    }
  }

  const fetchAllClients = async () => {
    try {
      const res = await axios.post(
        `${REST_API}webservice/clients/getAll-filters-clients`,
        { userType, userId, FromDesignOrder: true },
      )
      applyClientsFromResponse(res.data?.clients, res.data?.community)
    } catch (error) {
      console.log(error, 'Error in fetching all clients', error)
    }
  }

  const fetchTaxCategory = async () => {
    try {
      const response = await axios.post(
        `${REST_API_END_POINT}product/get-tax-category`,
      )
      if (response.data.status === 1) {
        setTaxCategories(response.data.taxResult)
      } else {
        setTaxCategories([])
      }
    } catch (error) {
      console.log('Error - ', error)
      setTaxCategories([])
    }
  }

  const isDesignOrderService = (service) => Number(service?.service_type) === 33

  const fetchAllServices =async()=>{
    await axios.post(`${REST_API}webservice/request/get-all-request`, values)
    .then((res) => {
      const sortedServices = [...(res.data.labourCostServices || [])]
        .filter(isDesignOrderService)
        .sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
      setFilteredServices(sortedServices)
    })
    .catch((errors) => {
      console.log(errors, 'error in fetching all requests')
    })
  }

const fetchAllProjectMembers = async (services) => {
  setMembersLoading(true);

  const workflowIds = services
    .map(service => service.workflow)
    .filter(id => id !== null && id !== undefined);

  const uniqueWorkflowIds = [...new Set(workflowIds)];

  try {
    const res = await axios.post(`${REST_API}webservice/workflow/project-members`, {
      workflow: uniqueWorkflowIds,
    });

    if (res.data?.projectManagers) {
      // Sort designers alphanumerically by name
      const sortedDesigners = [...(res.data.projectManagers || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
      // setFilteredMembers(sortedDesigners);
      setDesigners(sortedDesigners);
    }
  } catch (error) {
    console.error('Error in fetching project members:', error);
    // setFilteredMembers([]);
    setDesigners([]);
  } finally {
    setMembersLoading(false);
  }
};


  const fetchAddFormData = useCallback(async () => {
    setLoadingAddFormData(true)
    try {
      const res = await axios.post(`${REST_API_END_POINT}project/get-data-for-add-project`, {
        headers: {
          'Content-Type': 'application/json',
        },
        FromDesignOrder: true,
        userType,
        userId,
        skipClients: allClients.length > 0,
      })

      if (res.data?.status === 1) {
        if (res.data.products) {
          setAllproducts(res.data.products)
        }
        if (res.data.clients?.length) {
          applyClientsFromResponse(res.data.clients, res.data.community)
        }
        const sortedServices = [...(res.data?.labourCostServices.filter(
          isDesignOrderService,
        ) || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
        setFilteredServices(sortedServices)
        const sortedDesigners = [...(res.data?.allDesigners || [])].sort((a, b) =>
          alphanumericCompare(a?.name || '', b?.name || ''),
        )
        setFilteredMembers(sortedDesigners)
      } else {
        setAllproducts([])
        setFilteredServices([])
        setFilteredMembers([])
      }
    } catch (error) {
      console.log('Error fetching add form data for design order:', error)
    } finally {
      setLoadingAddFormData(false)
    }
  }, [userType, userId, allClients.length])

  useEffect(() => {
    fetchAllClients()
    fetchTaxCategory()
  }, [])

  const ACCOUNT_TABS = [
    {
      value: 'ALL',
      name: 'ALL',
      count : allCount || 0
    },
    {
      value: 'NEW',
      name: 'NEW',
      count : openCount || 0
    },
    {
      value: 'IN QUEUE',
      name: 'IN QUEUE',
      count : openCount || 0
    },
    {
      value: 'IN DESIGN',
      name: 'IN DESIGN',
      count : openCount || 0
    },
    {
      value: 'REVIEW/SEND FOR APPROVAL',
      name: 'REVIEW/SEND FOR APPROVAL',
      count : openCount || 0
    },
    {
      value: 'AWAITING APPROVAL',
      name: 'AWAITING APPROVAL',
      count : openCount || 0
    },
    {
      value: 'APPROVED',
      name: 'APPROVED',
      count :acceptedCount || 0
    },
    {
      value: 'REJECTED',
      name: 'REJECTED',
      count : rejectedCount || 0
    },
    {
      value: 'HOLD',
      name: 'HOLD',
      count : holdCount || 0
    },
    {
      value: 'DRAFT',
      name: 'DRAFT',
      count : draftCount || 0
    },
  ]

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    setRenderCards(!renderCards)
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1
    }
    if (b[orderBy] > a[orderBy]) {
      return 1
    }
    return 0
  }

  function getComparator(order, orderBy) {
    return order === 'desc'
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy)
  }

  function applySortFilter(array, comparator, community) {
    const stabilizedThis = array?.map((el, index) => [el, index])
    stabilizedThis?.sort((a, b) => {
      const order = comparator(a[0], b[0])
      if (order !== 0) return order
      return a[1] - b[1]
    })
    // Filter based on the community parameter
    if (community && community?.length > 0) {
      if (community?.includes('other')) {
        array = array?.filter(
          (item) =>
            item?.community === null || community?.includes(item?.community),
        )
      } else {
        array = array?.filter((item) => community?.includes(item?.community))
      }
    }
    return array
  }

  const roundToThreeDecimals = (num) => Math.round(num * 1000) / 1000;

  const mapCatalogProductForSubmit = (p, attachmentsByIndex = {}) => {
    const withMemberMarketing = resolveGroupMemberMarketingForSave(p, markupType)
    const adjusted = getCatalogProductWithAdjustment(withMemberMarketing)
    const price = adjusted.max_price ? adjusted.max_price : (adjusted.actual_retail_price || adjusted.retail_price)
    const installCost = parseFloat(adjusted?.install_cost) || 0

    const formulaCost = (adjusted.inhouse === 0
      ? parseFloat(adjusted?.sub_contract_price) || 0
      : (
        (parseFloat(adjusted?.expected_material_cost_with_markup) || 0) +
        (parseFloat(adjusted?.expected_service_cost_with_markup) || 0)
      )) || parseFloat(adjusted?.expected_formula_price) || parseFloat(adjusted?.expected_cost) || 0

    const productMarkup =
      adjusted.inhouse === 0
        ? ((adjusted?.sub_contract_markup ?? adjusted?.markup) != null &&
          (adjusted?.sub_contract_markup ?? adjusted?.markup) !== ''
          ? Number(adjusted.sub_contract_markup ?? adjusted.markup)
          : 0)
        : null

    const retailPriceEach = Number(adjusted.actual_retail_price || adjusted.retail_price || price || 0)
    const qty = Number(adjusted.quantity) || 1
    const installQty = Number(adjusted.install_quantity) || 1
    const productSubTotal = retailPriceEach * qty
    const installSubTotal = installCost > 0 ? installCost * installQty : 0
    const productTotal = productSubTotal + installSubTotal

    return {
      ...adjusted,
      id: adjusted.id || adjusted.product_id || null,
      product_id: adjusted.id || adjusted.product_id || null,
      product_name: adjusted.name || adjusted.product_name || '',
      product_desc: adjusted.description || adjusted.product_desc || '',
      expected_formula_price: formulaCost,
      unit_cost: formulaCost,
      markup: productMarkup,
      retail_price: Number(adjusted.retail_price || retailPriceEach),
      actual_retail_price: retailPriceEach,
      price: adjusted.price ?? formulaCost,
      quantity: qty,
      locationQuantity: qty,
      product_sub_total: Number(productSubTotal.toFixed(2)),
      product_total: Number(productTotal.toFixed(2)),
      location: typeof adjusted.location === 'string' ? adjusted.location : JSON.stringify(adjusted.location || [{ address: '', city: '', state: '', zip: '' }]),
      product_notes: adjusted.product_notes || '',
      install_notes: adjusted.install_notes || '',
      install_quantity: installQty,
      install_cost: installCost || null,
      attachments: attachmentsByIndex[adjusted.indexId] || [],
      is_product_row: 0,
      markup_type: markupType,
    }
  }

  const getRowsWithCommunityProductLocations = (rows, community) =>
    rows.map((row) => {
      if (row.entryMode === 'choose' && row.catalogProduct) {
        return {
          ...row,
          catalogProduct: withCommunityLocationIfMissing(
            row.catalogProduct,
            community,
          ),
        }
      }
      return row
    })

  const buildDesignOrderGroupMarketingPayload = (groups) => ({
    groupProductMarketingData: groups
      ? groups.map((group) => ({
          group_id: group.id,
          group_name: group.name,
          group_description: group.description,
          quantity: group.groupQuantity || 1,
          adj_value_type: group.groupAdjValueType ?? true,
          adjustment: Number(group.groupAdjustment ?? 0),
          total_formula_each: Number((group.totalProductFormulaEach || 0).toFixed(2)),
          total_retail_each: Number((group.totalProductRetailEach || 0).toFixed(2)),
          adjusted_retail_each: Number((group.adjustedGroupRetailEach || 0).toFixed(2)),
          adjusted_subtotal: Number((group.adjustedGroupSubtotal || 0).toFixed(2)),
        }))
      : [],
    groupInstallMarketingData: groups
      ? groups.map((group) => ({
          group_id: group.id,
          group_name: group.name,
          group_description: group.description,
          quantity: group.groupInstallQuantity || 1,
          adj_value_type: group.groupInstallAdjValueType ?? true,
          adjustment: Number(group.groupInstallAdjustment ?? 0),
          total_formula_each: Number((group.totalInstallFormulaEach || 0).toFixed(2)),
          total_retail_each: Number((group.totalInstallRetailEach || 0).toFixed(2)),
          adjusted_retail_each: Number((group.adjustedGroupInstallRetailEach || 0).toFixed(2)),
          adjusted_subtotal: Number((group.adjustedGroupInstallSubtotal || 0).toFixed(2)),
        }))
      : [],
  })

  const buildDesignOrderProductsPayload = (rows, community) =>
    getRowsWithCommunityProductLocations(rows, community)
      .filter((row) => {
        if (row.entryMode === 'choose') {
          return Boolean(row.catalogProduct)
        }
        return String(row.product_name || '').trim() !== ''
      })
      .map((row) => {
        if (row.entryMode === 'choose' && row.catalogProduct) {
          return mapCatalogProductForSubmit(
            { ...row.catalogProduct, indexId: row.indexId },
            productAttachments,
          )
        }
        return {
          ...row,
          product_name: row.product_name,
          product_desc: row.product_desc,
          product_notes: row.product_notes || '',
          install_notes: row.install_notes || '',
          attachments: productAttachments[row.indexId] || [],
          is_product_row: 1,
        }
      })

  const calculateServiceTotal = (price, quantity, discount, location = 1) => {
    const parsedQuantity = parseFloat(quantity) || 1;
    const parsedDiscount = parseFloat(discount) || 0;
    const locationQuantity = parseFloat(location) || 1
    const subtotal = price * parsedQuantity * locationQuantity;
    if (discount) {
      const totalDiscount = subtotal - discount;
      return totalDiscount;
    } else {
      return subtotal;
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    validateOnBlur: true,
    initialValues: {
      name: '',
      description: '',
      notes: '',
      clients: null,
      start: toDateOnlyUnix(currentDate) ?? localTodayDateOnlyUnix(),
      end: toDateOnlyUnix(currentDate) ?? localTodayDateOnlyUnix(),
      welcome_message: null,
      draft: null,
      client_approve: (userType !==3 || !isClient) ? false :true,
      subject: null,
      email_content: null,
      quantityFieldName:null,
      split_catalog_type: splitOrderCatalogTypes.find((type) => type.id === 'all'),
      // designer_email_sent: 0,
      // designer_sms_sent: 0,
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        values.name = orderTextFields.name || ''
        values.description = orderTextFields.description || ''
        values.notes = orderTextFields.notes || ''

        console.log('isClient', isClient)
        let user = JSON.parse(localStorage.getItem('user'))

        const productRowsWithLocations = getRowsWithCommunityProductLocations(
          productRows,
          values.community,
        )
        setProductRows(productRowsWithLocations)

        let errors = {}
        productRowsWithLocations.forEach((row) => {
          if (row.entryMode === 'choose') {
            if (!row.catalogProduct) {
              errors[row.indexId] = 'Select a catalog product or switch to Write'
            }
          } else if (!row.product_name?.trim() && row.product_desc?.trim()) {
            errors[row.indexId] = 'Product name is required when description is provided'
          }
        })
        if (Object.keys(errors).length > 0) {
          setRowErrors(errors)
          enqueueSnackbar('Please fill in all required product names if a description is provided.', { variant: 'error' })
          return
        }

        const hasProductMissingLocation = productRowsWithLocations.some((row) => {
          if (row.entryMode !== 'choose' || !row.catalogProduct) return false
          return !hasCompleteProductLocation(row.catalogProduct)
        })
        if (hasProductMissingLocation) {
          enqueueSnackbar(
            'Please add a complete location for each catalog product (or select a project with a full address).',
            { variant: 'error' },
          )
          return
        }
        
        if(additionalSelectedServices?.length <= 0 && (userType !==3 && !isClient)){
          enqueueSnackbar('Please choose atleast one service', {variant: 'error',})
          return;
        }
        if(designers?.length <= 0 && (userType !==3 && !isClient)){
          enqueueSnackbar('Please choose atleast one designer', {variant: 'error',})
          return;
        }
        
        // Check if on first tab and no design form data filled - switch to Design Form tab as reminder
        const hasDesignFormData = designFormData && Object.keys(designFormData).length > 0 && 
          Object.values(designFormData).some(form => form && Object.keys(form).length > 0)
        
        if (mainTab === 0 && !hasDesignFormData) {
          // Switch to Design Form tab as a reminder
          setMainTab(1)
          return; // Don't proceed with submission
        }
        
        setIsSubmitted(true)
     
       
       
        const userName = user.first_name
        const clientsArray = values.clients ? [values.clients] : []
        values.clientsData = clientsArray
        values.avatarUrl = filterDesignOnlyAttachments(avatarUrl, productAttachments)
        values.referenceFiles = referenceFiles
        const mappedProducts = buildDesignOrderProductsPayload(
          productRowsWithLocations,
          values.community,
        )
        values.markup_type = markupType
        values.products = mappedProducts
        values.productRows = mappedProducts.filter((p) => p.is_product_row === 1)
        values.selectedCatalogProducts = mappedProducts.filter((p) => p.is_product_row === 0)

        let selectedServicesTotalCost = additionalSelectedServices?.reduce((total, service, index) => {
          const quantityFieldName = `service_quantity_${index}`;
          const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
          const serviceTotal = calculateServiceTotal(service?.total_cost, service?.quantity, 0, 1);
         
          // return total + Number(service?.total);
          return total + Number(serviceTotal);
        }, 0);
        selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost);

        const requestData = {
          values,
          userId,
          userType,
          userName,
          salesRepName,
          salesRepId,
          selectedServices :additionalSelectedServices,
          totalCost:selectedServicesTotalCost,
          designers:designers,
          collaborators: Array.isArray(collaborators) ? collaborators.map((c) => (typeof c === 'object' && c?.id != null ? c.id : c)).filter(Boolean).join(',') : (collaborators || ''),
          isClient:isClient,
          socketId: null, // Will be set by the progress modal
          ...buildDesignOrderGroupMarketingPayload(groupedProducts),
        }

        // 🚀 PROGRESS TRACKING: Show progress modal and make API call
        setProgressHeading("Creating Design Order");
        setProgressRequestData(requestData);
        setShowProgressModal(true);
        
        // Wait for socket connection to establish and stabilize
        await new Promise(resolve => setTimeout(resolve, 2000));
        
        // Additional wait if socket is not ready yet
        if (!socketReady) {
            console.log('[PROGRESS-MODAL] ⏳ Waiting for socket connection...');
            await new Promise(resolve => setTimeout(resolve, 1000));
        }

        await axios
          .post(`${REST_API}webservice/design/add-order`, requestData)
          .then(async (res) => {
            // Get design order ID from response
            // The backend returns result as the design order ID, but may not include it in response
            // We need to extract it from the response or use a workaround
            const designOrderId = res.data?.data?.id || res.data?.id || res.data?.result
            
            // Save design forms if any form data exists - using batch save API (single call)
            if (designOrderId && designFormData && Object.keys(designFormData).length > 0) {
              try {
                // Normalize form data - convert autocomplete objects to strings for backend compatibility
                // This prevents [object Object] from being saved to the database
                const normalizeFormData = (formData) => {
                  const normalized = { ...formData }
                  Object.keys(normalized).forEach(key => {
                    const field = normalized[key]
                    
                    // Remove checkboxgroup key to prevent duplicate saves
                    if (key === 'checkboxgroup') {
                      delete normalized[key]
                      return
                    }
                    
                    // For checkbox groups (arrays), remove duplicates - keep as arrays
                    if (Array.isArray(field) && field.length > 0) {
                      const seen = new Set()
                      const uniqueArray = field.filter(item => {
                        if (!item || typeof item !== 'object') return false
                        const key = `${item.field_id}_${item.value}`
                        if (seen.has(key)) {
                          return false
                        }
                        seen.add(key)
                        return true
                      })
                      normalized[key] = uniqueArray
                      return
                    }
                    
                    // Handle object fields (text, textarea, number, select, autocomplete, date, etc.)
                    if (field && typeof field === 'object' && !Array.isArray(field)) {
                      if (field.content === 'autocomplete') {
                        // Convert autocomplete object to string (label) for backend
                        if (typeof field.value === 'object' && field.value !== null) {
                          normalized[key] = {
                            ...field,
                            value: field.value.label || field.value.value || ''
                          }
                        }
                      } else if (field.value !== undefined) {
                        // For other field types, ensure value is a string (not an object)
                        if (typeof field.value === 'object' && field.value !== null && !Array.isArray(field.value)) {
                          const stringValue = field.value?.label || field.value?.value || String(field.value) || ''
                          normalized[key] = {
                            ...field,
                            value: stringValue
                          }
                        } else if (field.value !== null && field.value !== undefined) {
                          normalized[key] = {
                            ...field,
                            value: String(field.value)
                          }
                        }
                      }
                    }
                  })
                  return normalized
                }
                
                // Prepare forms array for batch save with normalized data
                const forms = Object.entries(designFormData)
                  .filter(([templateId, submitForm]) => submitForm && Object.keys(submitForm).length > 0)
                  .map(([templateId, submitForm]) => ({
                    id: templateId,
                    submitForm: normalizeFormData(submitForm) // Normalize before saving
                  }))
                
                if (forms.length > 0) {
                  // Single API call to save all forms at once
                  await axios.post(`${REST_API_END_POINT}design-form/batch-save-templates`, {
                    forms,
                    design_order_id: designOrderId,
                    status: 1,
                    userId
                  })
                  console.log(`Successfully saved ${forms.length} design form(s) in one API call`)
                }
              } catch (error) {
                console.error('Error saving design forms:', error)
                // Don't block the success message if form save fails
              }
            }
            
            setOpen(false)
            resetForm()
            setOrderTextFields({ name: '', description: '', notes: '' })
            setOrderTextFieldErrors({})
            setProductRows([createEmptyProductRow(1)])
            resetCatalogProductFields()
            setProductIndexCounter(1)
            setRowErrors({})
            setAvatarUrl([])
            setDesignFormData({})
            setReferenceFiles([])
            setAutoUpdateData({ 
              type: 'design_order_created', 
              orderName: values.name,
              timestamp: Date.now()
            });
            setShowProgressModal(false);
            enqueueSnackbar('Design Order created successfully', {
              variant: 'success',
            })
            setAdditionalSelectedServices([])
            setDesigners([]);
            setAvatarUrl([])
            setReferenceFiles([])
            navigate(PATH_DASHBOARD.design.root)
            // window.location.reload()
          })
          .catch((errors) => {
            setShowProgressModal(false);
            console.log(errors, 'error')
            enqueueSnackbar('Design Order created successfully', {
              variant: 'success',
            })
          })
      } catch (error) {
        console.error(error)
        enqueueSnackbar('Failed to create design order', { variant: 'error' });
      } finally {
        setIsSubmitted(false)
        setShowProgressModal(false)
        // setTimeout(() => {
        //   setShowProgressModal(false)
        // }, 1000);
      }
    },
  })

  const {
    errors,
    values,
    touched,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    getFieldProps,
    validateForm,
    setTouched,
  } = formik

  const filteredProducts = useMemo(() => {
    return (allProducts || []).filter((option) => {
      const catalogType = values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')
      if (catalogType.id === 'all') return true
      switch (catalogType.id) {
        case 'in_stock': return option.inhouse === 4
        case 'client_owned': return option.inhouse === 5
        case 'traffic': return option.isTrafficCatalog == 1
        case 'production_catalog': return option.inhouse === 1 && option.isTrafficCatalog !== 1
        case 'split_catalog': return option.inhouse === 6
        case 'estimate_catalog': return option.inhouse === 7
        case 'sub_contract': return option.inhouse === 0
        default: return false
      }
    }).sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
  }, [allProducts, values.split_catalog_type])

  const resetCatalogProductFields = () => {
    setProductAttachments({})
    setOpenProductAttachment({})
    setIsUploadingProduct({})
    setOpenProductNote({})
    setCatalogPickerOpen(false)
    setCatalogPickerRowIndexId(null)
    setCatalogPickerDraft(null)
  }

  // const collaboratorOptions = useMemo(() => {
  //   const availableTeamMembers = Array.isArray(teamMembersOptions) ? teamMembersOptions : [];
  //   let filteredMembers = availableTeamMembers;
  //   const communitySalesRepIds = getCommunitySalesRepIds(values.community);

  //   if (values.community && communitySalesRepIds.length > 0) {
  //     const allowedIds = new Set(communitySalesRepIds.map((id) => String(id)));
  //     filteredMembers = availableTeamMembers.filter((member) => {
  //       const memberId = member?.id ?? member?.user_id;
  //       return memberId != null && allowedIds.has(String(memberId));
  //     });
  //   }

  //   if (collaborators?.length) {
  //     const filteredIds = new Set(
  //       filteredMembers.map((member) => String(member?.id ?? member?.user_id))
  //     );
  //     const missingSelections = collaborators.filter((member) => {
  //       const memberId = member?.id ?? member?.user_id;
  //       return memberId != null && !filteredIds.has(String(memberId));
  //     });
  //     if (missingSelections.length) {
  //       filteredMembers = [...filteredMembers, ...missingSelections];
  //     }
  //   }

  //   return filteredMembers;
  // }, [teamMembersOptions, values.community, collaborators]);


  const collaboratorOptions = useMemo(() => {
    const availableTeamMembers = Array.isArray(teamMembersOptions)
      ? teamMembersOptions
      : [];
  
    let filteredMembers = [...availableTeamMembers];
  
    // Keep already-selected collaborators even if they are not
    // currently present in teamMembersOptions.
    if (collaborators?.length) {
      const availableMemberIds = new Set(
        filteredMembers
          .map((member) => member?.id ?? member?.user_id)
          .filter((id) => id != null)
          .map(String)
      );
  
      const missingSelections = collaborators.filter((member) => {
        const memberId = member?.id ?? member?.user_id;
  
        return (
          memberId != null &&
          !availableMemberIds.has(String(memberId))
        );
      });
  
      if (missingSelections.length) {
        filteredMembers = [...filteredMembers, ...missingSelections];
      }
    }
  
    return filteredMembers;
  }, [teamMembersOptions, collaborators]);

  useEffect(() => {
    const repOptions = getSalesRepOptionsFromCommunity(values.community);
    setSalesRepOptions(repOptions);

    if (!repOptions.length) {
      setSalesRepName('');
      setSalesRepId(null);
      return;
    }

    const hasSelectedRep = repOptions.some((option) => {
      if (salesRepId != null && option?.id != null) {
        return String(option.id) === String(salesRepId);
      }
      return salesRepName && option?.name === salesRepName;
    });

    if (!hasSelectedRep) {
      setSalesRepName(repOptions[0]?.name || '');
      setSalesRepId(repOptions[0]?.id || null);
    }
  }, [values.community, teamMembersOptions]);

  // Sync collaborators from form values or requestTeam when team members load
  useEffect(() => {
    if (!teamMembersOptions || teamMembersOptions.length === 0) return;

    const collaboratorsData =
      values?.collaborators || requestTeam?.collaborators || '';

    if (!collaboratorsData) return;

    const collaboratorIds = String(collaboratorsData)
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);

    const matchedCollaborators = teamMembersOptions.filter((member) =>
      collaboratorIds.includes(String(member?.id))
    );

    setCollaborators(matchedCollaborators);
  }, [teamMembersOptions, values?.collaborators, requestTeam?.collaborators]);

  // Custom submit handler that checks validation and switches tabs if needed
  const handleFormSubmit = async (e) => {
    e.preventDefault()

    const textErrs = {}
    if (!orderTextFields.name?.trim()) {
      textErrs.name = 'Name is required.'
    }
    if (!orderTextFields.description?.trim()) {
      textErrs.description = 'Description is required.'
    }
    setOrderTextFieldErrors(textErrs)
    if (Object.keys(textErrs).length > 0) {
      setMainTab(0)
      enqueueSnackbar('Please fill all required fields in the form', {
        variant: 'error',
      })
      return
    }

    // Validate form manually first
    const validationErrors = await validateForm()
    
    // If there are validation errors and we're on Design Form tab, switch to first tab
    if (validationErrors && Object.keys(validationErrors).length > 0 && mainTab === 1) {
      // Mark all error fields as touched so errors are visible
      const touchedFields = {}
      Object.keys(validationErrors).forEach(key => {
        touchedFields[key] = true
      })
      // Also mark common required fields
      touchedFields.name = true
      touchedFields.description = true
      if (values.clients !== null && values.clients !== undefined) {
        touchedFields.clients = true
      }
      if (values.community !== null && values.community !== undefined) {
        touchedFields.community = true
      }
      touchedFields.start = true
      touchedFields.end = true
      
      setTouched(touchedFields)
      // Switch to first tab to show validation errors
      setMainTab(0)
      enqueueSnackbar('Please fill all required fields in the form', {
        variant: 'error',
      })
      return; // Don't proceed with submission
    }
    
    // If no validation errors or already on first tab, proceed with normal submit
    handleSubmit(e)
  }

  useEffect(() => {
    if (!openPreview) return
    // Format description and notes to handle line breaks (header text from local state)
    const formattedDescription = Array.isArray(values?.description_lines) && values.description_lines.length
      ? values.description_lines.join('\n')
      : (orderTextFields.description || '').replace(/\r?\n/g, '\n');
    const formattedNotes = Array.isArray(values?.notes_lines) && values.notes_lines.length
      ? values.notes_lines.join('\n')
      : (orderTextFields.notes || '').replace(/\r?\n/g, '\n');

    setPreview({
      ...values,
      name: orderTextFields.name,
      description: formattedDescription,
      notes: formattedNotes
    })
  }, [openPreview, values, orderTextFields])

  // const handleDrop = useCallback(
  //   (acceptedFiles) => {
  //     if (acceptedFiles && acceptedFiles.length > 0) {
  //       setIsUploading(true);
  //       const uploadPromises = acceptedFiles?.map((file) => {
  //         return new Promise((resolve, reject) => {
  //           const Filename = new Date().getTime() + file.name
  //           const StorageRef = ref(storage, Filename)
  //           const uploadTask = uploadBytesResumable(StorageRef, file)

  //           uploadTask.on(
  //             'state_changed',
  //             (snapshot) => {
  //               const progress = Math.round(
  //                 (snapshot.bytesTransferred / snapshot.totalBytes) * 100,
  //               )
  //               setProgress(progress)
  //             },
  //             (error) => {
  //               console.error(error.message)
  //               setIsUploading(false);
  //               reject(error)
  //             },
  //             () => {
  //               getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
  //                 resolve({
  //                   url: downloadURL,
  //                   file_type: file.type,
  //                   extension: file.name.split('.').pop(),
  //                   size: file.size,
  //                 })
  //               })
  //             },
  //           )
  //         })
  //       })

  //       Promise.all(uploadPromises)
  //         .then((downloadURLs) => {
  //           setAvatarUrl((prevAvatarUrls) => {
  //             const updatedFiles = downloadURLs.map((file) => ({
  //               url: file.url,
  //               file_type: file.file_type,
  //               extension: file.extension,
  //               size: file.size,
  //             }))
  //             return [...prevAvatarUrls, ...updatedFiles]
  //           })
  //           setIsUploading(false);
  //         })
  //         .catch((error) => {
  //           console.error(error.message)
  //           setIsUploading(false);
  //         })
  //     }
  //   },
  //   [setFieldValue],
  // )

  const handleDrop = useCallback(
    async (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return;

      setIsUploading(true);

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          const sanitizedFileName = file.name.replace(/\s+/g, '_');
          const fileName = `${timestamp}_${sanitizedFileName}`;
          const filePath = `design-order/designs/${fileName}`; // ✅ correct path

          // Upload to Supabase
          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) {
            throw uploadError;
          }

          // Get public URL
          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }

          // Return file metadata
          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);

        setAvatarUrl((prevAvatarUrls) => [
          ...prevAvatarUrls,
          ...uploadedFiles
        ]);
      } catch (error) {
        console.error('Upload error:', error.message);
        enqueueSnackbar('Upload failed: ' + error.message, { variant: 'error' });
      } finally {
        setIsUploading(false);
      }
    },
    [setAvatarUrl, setIsUploading]
  );

  const handleDropReference = useCallback(
    async (acceptedFiles) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return;

      setIsUploadingReference(true);

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now();
          const sanitizedFileName = file.name.replace(/\s+/g, '_');
          const fileName = `${timestamp}_${sanitizedFileName}`;
          const filePath = `design-order/references/${fileName}`; // ✅ correct path

          // Upload to Supabase
          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file);

          if (uploadError) {
            throw uploadError;
          }

          // Get public URL
          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath);

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL');
          }

          // Return file metadata
          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size
          };
        });

        const uploadedFiles = await Promise.all(uploadPromises);

        setReferenceFiles((prevAvatarUrls) => [
          ...prevAvatarUrls,
          ...uploadedFiles
        ]);
      } catch (error) {
        console.error('Upload error:', error.message);
        enqueueSnackbar('Upload failed: ' + error.message, { variant: 'error' });
      } finally {
        setIsUploadingReference(false);
      }
    },
    [setReferenceFiles, setIsUploadingReference]
  );

  const handleRemoveAll = () => {
    const removed = [...avatarUrl]
    setAvatarUrl([])
    if (removed.length === 0) return
    setProductAttachments((prev) =>
      removed.reduce((acc, f) => pruneAttachmentMapsByFile(acc, f), prev),
    )
  }

  const handleRemove = (file) => {
    if (file?._productAttachment && file?.product_index_id != null && String(file.product_index_id) !== '') {
      handleProductRemove(file, file.product_index_id)
      return
    }

    setAvatarUrl((prev) => prev.filter((f) => !attachmentMatches(f, file)))
    setProductAttachments((prev) => pruneAttachmentMapsByFile(prev, file))
  }

  const handleRemoveAllReference = () => {
    setReferenceFiles([])
  }

  const handleRemoveReference = (file) => {
    const filteredItems = referenceFiles.filter((_file) => _file !== file)
    setReferenceFiles(filteredItems)
  }

  const handleCancel = async () => {
    setOpenBackConfirm(true);
  }

  const handleSaveDraft = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    try {
      if (userType !== 3 && !isClient && !values.clients) {
        enqueueSnackbar('Please select a client to save draft', { variant: 'warning' });
        return;
      }
      setIsSavingDraft(true);
      const user = JSON.parse(localStorage.getItem('user'));
      const userName = user?.first_name || '';
      const vals = {
        ...values,
        name: orderTextFields.name || '',
        description: orderTextFields.description || '',
        notes: orderTextFields.notes || '',
      };
      vals.clientsData = values.clients ? [values.clients] : [];
      vals.avatarUrl = filterDesignOnlyAttachments(avatarUrl, productAttachments);
      vals.referenceFiles = referenceFiles;
      const draftProductRowsWithLocations = getRowsWithCommunityProductLocations(
        productRows,
        values.community,
      )
      const draftMappedProducts = buildDesignOrderProductsPayload(
        draftProductRowsWithLocations,
        values.community,
      )
      vals.markup_type = markupType
      vals.products = draftMappedProducts
      vals.productRows = draftMappedProducts.filter((p) => p.is_product_row === 1)
      vals.selectedCatalogProducts = draftMappedProducts.filter((p) => p.is_product_row === 0)
      vals.draft = true;

      let selectedServicesTotalCost = additionalSelectedServices?.reduce((total, service, index) => {
        const quantityFieldName = `service_quantity_${index}`;
        const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1;
        const serviceTotal = calculateServiceTotal(service?.total_cost, service?.quantity, 0, 1);
        return total + Number(serviceTotal);
      }, 0);
      selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost || 0);

      const requestData = {
        values: vals,
        userId,
        userType,
        userName,
        salesRepName,
        salesRepId,
        selectedServices: additionalSelectedServices || [],
        totalCost: selectedServicesTotalCost,
        designers: designers || [],
        collaborators: Array.isArray(collaborators) ? collaborators.map((c) => (typeof c === 'object' && c?.id != null ? c.id : c)).filter(Boolean).join(',') : (collaborators || ''),
        isClient,
        socketId: null,
        ...buildDesignOrderGroupMarketingPayload(groupedProducts),
      };

      setProgressHeading('Saving Design Order as draft');
      setProgressRequestData(requestData);
      setShowProgressModal(true);
      await new Promise((resolve) => setTimeout(resolve, 1000));

      await axios
        .post(`${REST_API}webservice/design/add-order`, requestData)
        .then(async (res) => {
          const designOrderId = res.data?.data?.id || res.data?.id || res.data?.result;
          if (designOrderId && designFormData && Object.keys(designFormData).length > 0) {
            try {
              const normalizeFormData = (formData) => {
                const normalized = { ...formData };
                Object.keys(normalized).forEach((key) => {
                  const field = normalized[key];
                  if (key === 'checkboxgroup') {
                    delete normalized[key];
                    return;
                  }
                  if (Array.isArray(field) && field.length > 0) {
                    const seen = new Set();
                    const uniqueArray = field.filter((item) => {
                      if (!item || typeof item !== 'object') return false;
                      const k = `${item.field_id}_${item.value}`;
                      if (seen.has(k)) return false;
                      seen.add(k);
                      return true;
                    });
                    normalized[key] = uniqueArray;
                    return;
                  }
                  if (field && typeof field === 'object' && !Array.isArray(field)) {
                    if (field.content === 'autocomplete' && typeof field.value === 'object' && field.value !== null) {
                      normalized[key] = { ...field, value: field.value.label || field.value.value || '' };
                    } else if (field.value !== undefined && typeof field.value === 'object' && field.value !== null && !Array.isArray(field.value)) {
                      normalized[key] = { ...field, value: field.value?.label || field.value?.value || String(field.value) || '' };
                    } else if (field.value !== null && field.value !== undefined) {
                      normalized[key] = { ...field, value: String(field.value) };
                    }
                  }
                });
                return normalized;
              };
              const forms = Object.entries(designFormData)
                .filter(([templateId, submitForm]) => submitForm && Object.keys(submitForm).length > 0)
                .map(([templateId, submitForm]) => ({
                  id: templateId,
                  submitForm: normalizeFormData(submitForm),
                }));
              if (forms.length > 0) {
                await axios.post(`${REST_API_END_POINT}design-form/batch-save-templates`, {
                  forms,
                  design_order_id: designOrderId,
                  status: 1,
                  userId,
                });
              }
            } catch (error) {
              console.error('Error saving design forms:', error);
            }
          }
          setOpen(false);
          formik.resetForm();
          setOrderTextFields({ name: '', description: '', notes: '' });
          setOrderTextFieldErrors({});
          setAvatarUrl([]);
          setDesignFormData({});
          setReferenceFiles([]);
          setAdditionalSelectedServices([]);
          setDesigners([]);
          setAutoUpdateData({ type: 'design_order_created', orderName: vals.name, timestamp: Date.now() });
          enqueueSnackbar('Draft saved', { variant: 'success' });
          setShowProgressModal(false);
          setIsSavingDraft(false);
        })
        .catch((err) => {
          console.log(err, 'error');
          setShowProgressModal(false);
          setIsSavingDraft(false);
          enqueueSnackbar(err?.response?.data?.message || 'Failed to save draft', { variant: 'error' });
        });
    } catch (error) {
      console.error(error);
      setShowProgressModal(false);
      setIsSavingDraft(false);
      enqueueSnackbar('Failed to save draft', { variant: 'error' });
    }
  }

  // Auto-save confirmation dialog handlers
  const handleBackConfirmYes = async () => {
    setOpenBackConfirm(false);
    try {
      await formik.submitForm();
      // Navigation will happen in onSubmit success handler
    } catch (error) {
      console.error('Auto-save failed:', error);
      // Still proceed with cancel on error
      handleCancelAction();
    }
  };

  const handleBackConfirmNo = () => {
    setOpenBackConfirm(false);
    handleCancelAction();
  };

  const handleCancelAction = () => {
    setOpen(false)
    formik.resetForm()
    setOrderTextFields({ name: '', description: '', notes: '' })
    setOrderTextFieldErrors({})
    setDesigners([]);
    setAdditionalSelectedServices([])
    setAvatarUrl([])
    setMainTab(0) // Reset to default "New Order" tab
    setDesignFormData({}) // Clear design form data
    setReferenceFiles([])
    setProductRows([createEmptyProductRow(1)])
    setProductIndexCounter(1)
    setRowErrors({})
    resetCatalogProductFields()
    setFieldValue('split_catalog_type', splitOrderCatalogTypes.find((type) => type.id === 'all'))
  }
  const handleChangeTab = (event, newValue) => {
    setLoadingCards(true)
    setCurrentTab(newValue)
    setFilterDateValue([null, null])
    setPage(0)
  }
  const filteredUsers = applySortFilter(
    allRequest,
    getComparator(order, orderBy),
    [],
  )
  // const allServices = [...selectedServices, ...additionalSelectedServices];
  // const allServices = useMemo(
  //   () => [...selectedServices, ...additionalSelectedServices],
  //   [selectedServices, additionalSelectedServices]
  // );
  


  let selectedServicesTotalCost = additionalSelectedServices?.reduce((total, service, index) => {
    const quantityFieldName = `service_quantity_${index}`;
    const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
    const serviceTotal = calculateServiceTotal(service?.total_cost, service?.quantity, 0, 1);
   
    
    // return total + Number(service?.total);
    return total + Number(serviceTotal);
  }, 0);

// selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost);
  const handleChangeSort = (category) => {
    setSort(category)
    setSortOpen(false)
  }

  
  selectedServicesTotalCost = roundToThreeDecimals(selectedServicesTotalCost);
  const selectedServicesSubTotal = selectedServicesTotalCost 
  const selectedProductsSubTotal = useMemo(
    () => computeDesignOrderProductsSubTotal(productRows, groupedProducts),
    [productRows, groupedProducts],
  )
  const selectedProductsAndServicesSubTotal = roundToThreeDecimals(
    (selectedServicesSubTotal || 0) + (selectedProductsSubTotal || 0),
  )

  const designPreviewFiles = useMemo(() => {
    const getAttachmentId = (file) =>
      file?.id ?? file?.ID ?? file?.attachment_id ?? file?.design_order_attachment_id ?? null

    const allProductAttachmentFiles = Object.values(productAttachments || {}).flat()
    const productAttachmentKeys = new Set(
      allProductAttachmentFiles.map(attachmentFileKey).filter(Boolean),
    )
    const productAttachmentIds = new Set(
      allProductAttachmentFiles
        .map((file) => getAttachmentId(file))
        .filter((id) => id !== null && id !== undefined)
        .map(String),
    )

    const availableAvatarFiles = (avatarUrl || []).filter((file) => {
      const fileKey = attachmentFileKey(file)
      const attachmentId = getAttachmentId(file)
      if (attachmentId != null && productAttachmentIds.has(String(attachmentId))) {
        return false
      }
      return !fileKey || !productAttachmentKeys.has(fileKey)
    })

    const productPreviewFiles = (productRows || []).flatMap((row) => {
      const rowAttachments = productAttachments[row.indexId] || []
      return rowAttachments.map((file) =>
        mapDesignOrderProductAttachmentForDisplay(file, row, groupedProductsMap),
      )
    })

    const seenKeys = new Set()
    const dedupedProductFiles = productPreviewFiles.filter((file) => {
      const key = attachmentFileKey(file)
      if (!key) return true
      if (seenKeys.has(key)) return false
      seenKeys.add(key)
      return true
    })

    return [...availableAvatarFiles, ...dedupedProductFiles]
  }, [avatarUrl, productAttachments, productRows, groupedProductsMap])

  let totalAmount = 0;
  let totalMarkup = 0;
  let totalProductFormula = 0;
  let totalWholesalePrice = 0;
  let totalRetailPrice = 0;
  let originaltotalMarkup = 0
  let originaltotalServiceMarkup = 0
  let totalServiceMarkup = 0;


  const memoizedRows = useMemo(() => {
    let totalServiceMarkup = 0;
    let originaltotalServiceMarkup = 0;
    let totalProductFormula = 0;
    let totalWholesalePrice = 0;
    let totalRetailPrice = 0;
  
    // Map over additionalSelectedServices to calculate values without mutating
    const updatedRows = additionalSelectedServices.map((data, index) => {
      // const quantity = data?.quantity || 1; // Default to 1 if undefined
      const quantity = Number(data?.quantity) || 1; // Default to 1 if undefined or 0
      const total = data.total_cost * quantity; // Calculate total
      const markup = total > 0 ? (data.total_cost / total).toFixed(2) : 0;
  
      // Calculate original markup
      const originalMarkup = data.originalMarkup || 0;
  
      // Update totals
      totalServiceMarkup += Number(markup);
      originaltotalServiceMarkup += Number(originalMarkup);
      const productFormulaCost = (data.cost * quantity).toFixed(2);
      totalProductFormula += Number(productFormulaCost);
      totalWholesalePrice += Number(total);
      totalRetailPrice += Number(total);
  
      // Calculate quantityDifference (if needed)
      const quantityDifference = Number(quantity);
  
      // Return updated row without mutating the original object
      return {
        ...data,
        quantity,
        total: total.toFixed(2), // Include total
        markup,
        originalMarkup, // Include originalMarkup
        totalServiceMarkup: totalServiceMarkup.toFixed(2),
        quantityDifference, // Include quantityDifference
        jobcost_unit_cost: data.cost,
        jobcost_quantity: quantity,
        jobcost_total_cost: (data.cost * quantity).toFixed(2),
        quantity
      };
    });
  
    // Update Formik values only once after calculations
    values['totalServiceMarkup'] = totalServiceMarkup.toFixed(2);
    values['totalProductFormula'] = totalProductFormula.toFixed(2);
    values['totalWholesalePrice'] = totalWholesalePrice.toFixed(2);
    values['totalRetailPrice'] = totalRetailPrice.toFixed(2);
  
    return updatedRows;
  }, [additionalSelectedServices]);

  // Product rows handlers
  const addNewProductRow = () => {
    const newIndexCounter = Math.max(...productRows.map((row) => row.indexId), 0) + 1
    setProductIndexCounter(newIndexCounter)

    const newProduct = {
      indexId: newIndexCounter,
      entryMode: 'write',
      product_name: '',
      product_desc: '',
      price: 0,
      retail_price: 0,
      is_product_row: 1,
      catalogProduct: null,
    }

    setProductRows((prevRows) => [...prevRows, newProduct])
  }

  const buildChooseRowFromCatalogProduct = (product, indexId) => {
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}

    const catalogLine = withCommunityLocationIfMissing(
      {
        ...stripGroupFieldsFromCatalogOption(product),
        indexId,
        quantity: product.quantity || 1,
        install_quantity: product.install_quantity || 1,
        product_notes: product.product_notes || '',
        install_notes: product.install_notes || '',
        location: product.location || [
          { address: projAddress, city: projCity, state: projState, zip: projZip },
        ],
        is_product_row: 0,
      },
      values?.community,
    )

    return {
      indexId,
      entryMode: 'choose',
      product_name: catalogLine.name || '',
      product_desc: catalogLine.description || catalogLine.product_desc || '',
      price: 0,
      retail_price: 0,
      is_product_row: 0,
      catalogProduct: catalogLine,
    }
  }

  const selectedCatalogProductsForAutocomplete = useMemo(
    () =>
      collapseProductsForAutocompleteChips(
        (productRows || [])
          .filter((row) => row.entryMode === 'choose' && row.catalogProduct)
          .map((row) => row.catalogProduct),
      ),
    [productRows],
  )

  const handleAutocompleteCatalogProductsChange = (event, newCollapsed) => {
    const currentProducts = selectedCatalogProductsForAutocomplete
    const currentKeys = new Set(
      currentProducts.map((product) => getAutocompleteSelectionKey(product)),
    )
    const nextKeys = new Set(
      (newCollapsed || []).map((product) => getAutocompleteSelectionKey(product)),
    )

    if ((newCollapsed || []).length > currentProducts.length) {
      const addedProducts = (newCollapsed || [])
        .filter((product) => !currentKeys.has(getAutocompleteSelectionKey(product)))
        .map((product) => stripGroupFieldsFromCatalogOption(product))
      const currentMaxIndex = (productRows || []).reduce(
        (maxIndex, row) => Math.max(maxIndex, row.indexId || 0),
        0,
      )
      const newRows = addedProducts.map((product, productIndex) =>
        buildChooseRowFromCatalogProduct(product, currentMaxIndex + productIndex + 1),
      )
      setProductRows((prevRows) => [...prevRows, ...newRows])
      setProductIndexCounter(currentMaxIndex + newRows.length + 1)
      return
    }

    if ((newCollapsed || []).length < currentProducts.length) {
      const nextRows = []
      ;(productRows || []).forEach((row) => {
        if (row.entryMode !== 'choose' || !row.catalogProduct) {
          nextRows.push(row)
          return
        }
        const selectionKey = getAutocompleteSelectionKey(row.catalogProduct)
        if (nextKeys.has(selectionKey)) {
          nextRows.push(row)
        }
      })
      const finalRows = nextRows.length > 0 ? nextRows : [createEmptyProductRow(1)]
      const indexIdMap = {}
      finalRows.forEach((row, idx) => {
        indexIdMap[String(row.indexId)] = idx + 1
      })
      const renumberedRows = finalRows.map((row, idx) => {
        const newIndexId = idx + 1
        return {
          ...row,
          indexId: newIndexId,
          ...(row.catalogProduct
            ? { catalogProduct: { ...row.catalogProduct, indexId: newIndexId } }
            : {}),
        }
      })

      setRowErrors((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = indexIdMap[oldKey]
          if (newKey !== undefined) next[newKey] = prev[oldKey]
        })
        return next
      })
      setProductAttachments((prev) => {
        const next = {}
        Object.keys(prev || {}).forEach((oldKey) => {
          const newKey = indexIdMap[oldKey]
          if (newKey !== undefined) next[newKey] = prev[oldKey]
        })
        return next
      })
      setOpenProductAttachment({})
      setIsUploadingProduct({})
      grouping.remapDesignOrderProductIndexIds(indexIdMap)
      setProductRows(renumberedRows)
      setProductIndexCounter(renumberedRows.length + 1)
    }
  }

  const handleDeleteProduct = (indexId) => {
    grouping.clearGroupSelectionForProduct(indexId)
    if (productRows?.length > 1) {
      const updatedRows = productRows?.filter((row) => row.indexId !== indexId)
      setRowErrors((prevErrors) => {
        const newErrors = { ...prevErrors }
        delete newErrors[indexId]
        return newErrors
      })
      const renumberedRows = updatedRows?.map((row, idx) => ({
        ...row,
        indexId: idx + 1,
      }))
      setProductAttachments((prev) => {
        const next = {}
        updatedRows.forEach((row, idx) => {
          next[idx + 1] = prev[row.indexId] || []
        })
        return next
      })
      setOpenProductAttachment({})
      setIsUploadingProduct({})
      setProductRows(renumberedRows)
      setProductIndexCounter(renumberedRows?.length + 1)
    } else {
      setProductRows([createEmptyProductRow(1)])
      setProductIndexCounter(1)
      setProductAttachments({})
      setOpenProductAttachment({})
      setIsUploadingProduct({})
    }
  }

  const handleProductRowsDragEnd = useCallback(
    (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }

      const renderOrder = [...productTableBodyRenderOrder]
      const [moved] = renderOrder.splice(result.source.index, 1)
      renderOrder.splice(result.destination.index, 0, moved)

      const orderedOldIds = []
      renderOrder.forEach((item) => {
        if (item.type === 'row') {
          orderedOldIds.push(item.indexId)
        } else if (item.type === 'group') {
          const group = groupedProductsMap.get(item.groupId)
          const groupProducts = [...(group?.products || [])].sort(
            (a, b) => (Number(a?.indexId) || 0) - (Number(b?.indexId) || 0),
          )
          groupProducts.forEach((p) => orderedOldIds.push(p.indexId))
        }
      })

      const orderedSet = new Set(orderedOldIds.map(String))
      ;(productRows || []).forEach((row) => {
        if (row?.indexId != null && !orderedSet.has(String(row.indexId))) {
          orderedOldIds.push(row.indexId)
        }
      })

      const indexIdMap = {}
      orderedOldIds.forEach((oldId, idx) => {
        indexIdMap[String(oldId)] = idx + 1
      })

      grouping.remapDesignOrderProductIndexIds(indexIdMap)
      setProductIndexCounter(orderedOldIds.length + 1)
    },
    [
      productTableBodyRenderOrder,
      groupedProductsMap,
      productRows,
      grouping,
    ],
  )

  const handleRowEntryModeChange = (indexId, mode) => {
    const targetRow = productRows.find((row) => row.indexId === indexId)
    if (targetRow) {
      const currentMode = targetRow.entryMode === 'choose' ? 'choose' : 'write'
      if (currentMode === mode) return
    }

    setProductRows((prev) =>
      prev.map((row) => {
        if (row.indexId !== indexId) return row
        if (mode === 'choose') {
          return {
            indexId: row.indexId,
            entryMode: 'choose',
            product_name: '',
            product_desc: '',
            price: 0,
            retail_price: 0,
            is_product_row: 0,
            catalogProduct: null,
          }
        }
        return {
          indexId: row.indexId,
          entryMode: 'write',
          product_name: '',
          product_desc: '',
          price: 0,
          retail_price: 0,
          is_product_row: 1,
          catalogProduct: null,
        }
      }),
    )
    setRowErrors((prev) => {
      const next = { ...prev }
      delete next[indexId]
      return next
    })
  }

  const openCatalogPickerForRow = (indexId, existingCatalog = null) => {
    setCatalogPickerRowIndexId(indexId)
    if (existingCatalog?.id != null) {
      const base =
        filteredProducts.find((p) => p.id === existingCatalog.id) || existingCatalog
      setCatalogPickerDraft({
        ...base,
        quantity: existingCatalog.quantity ?? base.quantity ?? 1,
        install_quantity: existingCatalog.install_quantity ?? base.install_quantity ?? 1,
        product_notes: existingCatalog.product_notes ?? base.product_notes ?? '',
        install_notes: existingCatalog.install_notes ?? base.install_notes ?? '',
      })
    } else {
      setCatalogPickerDraft(null)
    }
    setCatalogPickerOpen(true)
  }

  const confirmCatalogPicker = () => {
    if (!catalogPickerDraft) {
      enqueueSnackbar('Please select a catalog product', { variant: 'warning' })
      return
    }
    const {
      address: projAddress = '',
      city: projCity = '',
      state: projState = '',
      zip: projZip = '',
    } = values?.community || {}
    const catalogLine = withCommunityLocationIfMissing(
      {
        ...catalogPickerDraft,
        ...getCatalogPickerOriginalPrices(catalogPickerDraft),
        indexId: catalogPickerRowIndexId,
        quantity: catalogPickerDraft.quantity || 1,
        install_quantity: catalogPickerDraft.install_quantity || 1,
        product_notes: catalogPickerDraft.product_notes || '',
        install_notes: catalogPickerDraft.install_notes || '',
        location: catalogPickerDraft.location || [
          { address: projAddress, city: projCity, state: projState, zip: projZip },
        ],
        is_product_row: 0,
        markAdjType: catalogPickerDraft.markAdjType ?? 1,
      },
      values?.community,
    )
    setProductRows((prev) =>
      prev.map((row) =>
        row.indexId === catalogPickerRowIndexId
          ? {
              ...row,
              entryMode: 'choose',
              catalogProduct: catalogLine,
              product_name: catalogLine.name || '',
              product_desc: catalogLine.description || catalogLine.product_desc || '',
              is_product_row: 0,
            }
          : row,
      ),
    )
    setCatalogPickerOpen(false)
    setCatalogPickerRowIndexId(null)
    setCatalogPickerDraft(null)
    setRowErrors((prev) => {
      const next = { ...prev }
      delete next[catalogPickerRowIndexId]
      return next
    })
  }

  const handleCatalogRowQuantityChange = (indexId, quantity) => {
    const val = Math.max(0, Number(quantity))
    setProductRows((prev) =>
      prev.map((row) => {
        if (row.indexId !== indexId || !row.catalogProduct) return row
        const installQuantity = row.manually_updated_install_quantity || row.catalogProduct?.manually_updated_install_quantity
          ? row.catalogProduct.install_quantity
          : val
        return {
          ...row,
          catalogProduct: {
            ...row.catalogProduct,
            quantity: val,
            locationQuantity: val,
            install_quantity: installQuantity,
          },
        }
      }),
    )
  }

  const handleInstallQuantityChange = (indexId, quantity) => {
    const val = Math.max(0, Number(quantity))
    setProductRows((prev) =>
      prev.map((row) => {
        if (row.indexId !== indexId || !row.catalogProduct) return row
        return {
          ...row,
          catalogProduct: {
            ...row.catalogProduct,
            install_quantity: val,
            manually_updated_install_quantity: true,
          },
          manually_updated_install_quantity: true,
        }
      }),
    )
  }

  const handleDeleteInstallCost = (indexId) => {
    setProductRows((prev) =>
      prev.map((row) => {
        if (row.indexId !== indexId || !row.catalogProduct) return row
        return {
          ...row,
          catalogProduct: clearCatalogInstallCost(row.catalogProduct),
          manually_updated_install_cost: true,
        }
      }),
    )
  }

  const applyCatalogInstallUpdate = (catalog, updates) =>
    normalizeProductForSave({ ...catalog, ...updates })

  const updateCatalogProduct = (indexId, updater) => {
    setProductRows((prev) =>
      prev.map((row) => {
        if (String(row.indexId) !== String(indexId) || !row.catalogProduct) return row
        const updatedCatalog = typeof updater === 'function'
          ? updater(row.catalogProduct)
          : { ...row.catalogProduct, ...updater }
        return { ...row, catalogProduct: updatedCatalog }
      }),
    )
  }

  const handleRetailPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        updateCatalogProduct(indexId, { retail_price_draft: undefined })
      } else {
        updateCatalogProduct(indexId, { retail_price_draft: limitedValue })
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      updateCatalogProduct(indexId, { retail_price_draft: limitedValue })
      return
    }

    updateCatalogProduct(indexId, (catalog) => {
      const editResult = applyRetailPriceEdit(
        ensureCatalogBaselines(catalog),
        valueToApply,
        markupType ?? 2,
        {
          hasNegativePermission: explodedPermissions?.some((permission) =>
            ['Allow Negative Marketing Adjustment Design'].includes(permission),
          ),
        },
      )

      if (!editResult) {
        return { ...catalog, retail_price_draft: limitedValue }
      }

      if (editResult.error) {
        if (!isBlur) {
          return { ...catalog, retail_price_draft: limitedValue }
        }
        enqueueSnackbar(editResult.error, { variant: 'error' })
        return { ...catalog, retail_price_draft: undefined }
      }

      const reconciled = reconcileCatalogMarketingPrices({
        ...catalog,
        ...editResult,
        adjustment_draft: undefined,
      })

      return {
        ...reconciled,
        retail_price_draft: isBlur ? undefined : limitedValue,
      }
    })
  }

  const handleInstallPriceChange = (indexId, rawValue, options = {}) => {
    const { isBlur = false } = options
    const limitedValue = limitDecimalInput(rawValue)
    const valueToApply = isBlur
      ? formatPriceToTwoDecimals(limitedValue)
      : limitedValue

    if (valueToApply === '' || valueToApply === '-') {
      if (isBlur) {
        updateCatalogProduct(indexId, { install_price_draft: undefined })
      } else {
        updateCatalogProduct(indexId, { install_price_draft: limitedValue })
      }
      return
    }

    if (!isBlur && Number.isNaN(parseFloat(valueToApply))) {
      updateCatalogProduct(indexId, { install_price_draft: limitedValue })
      return
    }

    updateCatalogProduct(indexId, (catalog) => {
      const editResult = applyInstallPriceEdit(
        ensureCatalogBaselines(catalog),
        valueToApply,
        {
          hasNegativePermission: explodedPermissions?.some((permission) =>
            ['Allow Negative Marketing Adjustment Design'].includes(permission),
          ),
        },
      )

      if (!editResult) {
        return { ...catalog, install_price_draft: limitedValue }
      }

      if (editResult.error) {
        if (!isBlur) {
          return { ...catalog, install_price_draft: limitedValue }
        }
        enqueueSnackbar(editResult.error, { variant: 'error' })
        return { ...catalog, install_price_draft: undefined }
      }

      const normalized = normalizeProductForSave({
        ...catalog,
        ...editResult,
      })

      return {
        ...normalized,
        install_price_draft: isBlur ? undefined : limitedValue,
        install_adjustment_draft: undefined,
      }
    })
  }

  const getLosingMoneyRowSx = (isLosingMoneyItem) =>
    getDesignOrderLosingMoneyRowSx(theme, isLosingMoneyItem)

  const handleCatalogAdjValueTypeChange = (indexId, data, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Design'].includes(permission),
    )
    if (newValue === false) {
      const formulaEach = Number(
        (data?.expected_material_cost_with_markup || 0) +
          (data?.expected_service_cost_with_markup || 0),
      )
      const retailEachBase = Math.max(
        0,
        Number(
          data.original_actual_retail_price ??
            data.original_retail_price ??
            data.actual_retail_price ??
            data.retail_price ??
            0,
        ),
      )
      if (retailEachBase <= formulaEach && !hasPermission) {
        enqueueSnackbar(
          'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
          { variant: 'error' },
        )
        return
      }
    }
    const maxNegative = getMaxNegativeAdjustment(data, hasPermission)
    const adjustment = Number(data.adjustment) || 0
    if (Number(adjustment) >= maxNegative && newValue === false && hasPermission) {
      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      return
    }
    if (Number(adjustment) > maxNegative && newValue === false && !hasPermission) {
      enqueueSnackbar(
        `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
        { variant: 'error' },
      )
      return
    }
    updateCatalogProduct(indexId, (catalog) =>
      applyProductAdjValueTypeChange(catalog, newValue),
    )
  }

  const handleCatalogAdjustmentChange = (indexId, data, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Design'].includes(permission),
    )
    const maxNegative = getMaxNegativeAdjustment(data, hasPermission)
    if (Number(newValue) >= maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && hasPermission) {
      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      return
    }
    if (Number(newValue) > maxNegative && (data.adj_value_type === false || data.adj_value_type === 0) && !hasPermission) {
      enqueueSnackbar(
        `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
        { variant: 'error' },
      )
      return
    }
    updateCatalogProduct(indexId, (catalog) =>
      applyMarketingAdjustmentChange(catalog, newValue),
    )
  }

  const handleInstallAdjValueTypeChange = (indexId, data, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Design'].includes(permission),
    )
    if (newValue === false) {
      const formulaEach = Number(data?.expected_install_labor_cost_with_markup || 0)
      const retailEachBase = Math.max(0, Number(data.install_cost || 0))
      if (retailEachBase <= formulaEach && !hasPermission) {
        enqueueSnackbar(
          'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
          { variant: 'error' },
        )
        return
      }
    }
    const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
    const adjustment = Number(data.install_adjustment) || 0
    if (Number(adjustment) >= maxNegative && newValue === false && hasPermission) {
      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      return
    }
    if (Number(adjustment) > maxNegative && newValue === false && !hasPermission) {
      enqueueSnackbar(
        `Negative Adjustment Amount cannot reduce below $${Number(maxNegative).toFixed(2)} (Install Formula Limit)`,
        { variant: 'error' },
      )
      return
    }
    updateCatalogProduct(indexId, (catalog) =>
      applyInstallAdjValueTypeChange(catalog, newValue),
    )
  }

  const handleInstallAdjustmentChange = (indexId, data, newValue) => {
    const hasPermission = explodedPermissions?.some((permission) =>
      ['Allow Negative Marketing Adjustment Design'].includes(permission),
    )
    const maxNegative = getMaxNegativeInstallAdjustment(data, hasPermission)
    if (Number(newValue) >= maxNegative && data.install_adj_value_type === false && hasPermission) {
      enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
      return
    }
    if (Number(newValue) > maxNegative && data.install_adj_value_type === false && !hasPermission) {
      enqueueSnackbar(
        `Negative Adjustment Amount cannot reduce below $${Number(maxNegative).toFixed(2)} (Install Formula Limit)`,
        { variant: 'error' },
      )
      return
    }
    updateCatalogProduct(indexId, (catalog) =>
      applyInstallMarketingAdjustmentChange(catalog, newValue),
    )
  }

  const handleOpenLocation = (indexId) => {
    setProductRows((prev) =>
      prev.map((row) => {
        if (row.indexId !== indexId || !row.catalogProduct) return row
        if (hasCompleteProductLocation(row.catalogProduct)) return row
        return {
          ...row,
          catalogProduct: withCommunityLocationIfMissing(
            row.catalogProduct,
            values?.community,
          ),
        }
      }),
    )
    setLocationStates((prev) => ({ ...prev, [indexId]: true }))
  }

  const handleCloseLocation = (indexId) => {
    setLocationStates((prev) => ({ ...prev, [indexId]: false }))
  }

  const handleLocationFieldChange = (indexId, field, value) => {
    setProductRows((prevItems) =>
      prevItems.map((row) => {
        if (row.indexId !== indexId || !row.catalogProduct) return row
        const updatedLocation = Array.isArray(row.catalogProduct.location)
          ? [...row.catalogProduct.location]
          : [{ address: '', city: '', state: '', zip: '' }]
        if (!updatedLocation[0]) {
          updatedLocation[0] = { address: '', city: '', state: '', zip: '' }
        }
        updatedLocation[0] = { ...updatedLocation[0], [field]: value }
        return {
          ...row,
          catalogProduct: { ...row.catalogProduct, location: updatedLocation },
        }
      }),
    )
  }

  const getServiceLineKey = (service) =>
    String(service?.newIndexId ?? service?.indexId ?? service?.id ?? '')

  const remapServiceIndexIds = useCallback((indexIdMap) => {
    const remapKey = (oldKey) => {
      const mapped = indexIdMap[String(oldKey)]
      return mapped !== undefined ? String(mapped) : String(oldKey)
    }

    const remapKeyedState = (prev) => {
      const next = {}
      Object.keys(prev || {}).forEach((oldKey) => {
        const newKey = remapKey(oldKey)
        next[newKey] = prev[oldKey]
      })
      return next
    }

    setAdditionalSelectedServices((prev) =>
      (prev || []).map((service) => {
        const oldKey = getServiceLineKey(service)
        const newId = indexIdMap[oldKey]
        if (newId === undefined) return service
        return {
          ...service,
          newIndexId: newId,
          indexId: newId,
          product_index: newId,
        }
      }),
    )

    setServiceOnlyLocationStates(remapKeyedState)
  }, [])

  const handleServiceTableDragEnd = useCallback(
    (result) => {
      if (!result.destination || result.destination.index === result.source.index) {
        return
      }

      const sorted = [...(additionalSelectedServices || [])].sort(
        (a, b) =>
          (Number(a?.newIndexId ?? a?.indexId ?? a?.product_index) || 0) -
          (Number(b?.newIndexId ?? b?.indexId ?? b?.product_index) || 0),
      )
      const [moved] = sorted.splice(result.source.index, 1)
      sorted.splice(result.destination.index, 0, moved)

      const indexIdMap = {}
      sorted.forEach((s, idx) => {
        indexIdMap[getServiceLineKey(s)] = idx + 1
      })

      remapServiceIndexIds(indexIdMap)
    },
    [additionalSelectedServices, remapServiceIndexIds],
  )

  const handleProductNameChange = (indexId, value) => {
    setProductRows((prevRows) =>
      prevRows.map((row) =>
        row.indexId === indexId && row.entryMode !== 'choose'
          ? { ...row, product_name: value, price: 0, retail_price: 0, is_product_row: 1 }
          : row,
      ),
    )
  }

  const handleProductDescChange = (indexId, value) => {
    setProductRows((prevRows) =>
      prevRows.map((row) => {
        if (row.indexId !== indexId) return row
        if (row.entryMode === 'choose' && row.catalogProduct) {
          return {
            ...row,
            product_desc: value,
            catalogProduct: {
              ...row.catalogProduct,
              description: value,
              product_desc: value,
            },
          }
        }
        if (row.entryMode !== 'choose') {
          return { ...row, product_desc: value, price: 0, retail_price: 0, is_product_row: 1 }
        }
        return row
      }),
    )
  }

  const handleAddAttachment = (indexId) => {
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: true }))
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 }))
    const currentAttachments = productAttachments[indexId] || productAttachments[String(indexId)] || []
    setSelectedUploadedImages((prev) => ({ ...prev, [String(indexId)]: [...currentAttachments] }))
  }

  const handleCloseAttachment = (indexId) => {
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }))
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: 0 }))
    setSelectedUploadedImages((prev) => ({ ...prev, [indexId]: [] }))
  }

  const handleAttachmentTabChange = (event, newValue, indexId) => {
    setAttachmentTabValue((prev) => ({ ...prev, [indexId]: newValue }))
  }

  const handleImageSelect = (file, indexId, isSelected) => {
    const key = String(indexId ?? '')
    setSelectedUploadedImages((prev) => {
      const current = prev[key] || prev[indexId] || []
      if (isSelected) {
        if (current.some((f) => attachmentMatches(f, file))) return prev
        return { ...prev, [key]: [...current, file] }
      }
      return { ...prev, [key]: current.filter((f) => !attachmentMatches(f, file)) }
    })
  }

  const getProductAttachmentsList = useCallback(
    (productIndexId) =>
      productAttachments[productIndexId] || productAttachments[String(productIndexId)] || [],
    [productAttachments],
  )

  const handleAddSelectedImages = (indexId) => {
    const key = String(indexId ?? '')
    const selected = selectedUploadedImages[key] || selectedUploadedImages[indexId] || []
    setProductAttachments((prev) => {
      const updatedFiles = selected.map((file) => ({
        ...file,
        product_index_id: indexId,
      }))
      return {
        ...prev,
        [key]: updatedFiles,
      }
    })
    setSelectedUploadedImages((prev) => ({ ...prev, [key]: [], [indexId]: [] }))
    setOpenProductAttachment((prev) => ({ ...prev, [indexId]: false }))
    enqueueSnackbar('Product attachments updated successfully', { variant: 'success' })
  }

  const renderProductAttachmentModalContent = (productIndexId) => (
    <Grid container spacing={3} sx={{ justifyContent: 'center', width: '100%' }}>
      <Grid item xs={12}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Upload Attachment
        </Typography>
        <Tabs
          value={attachmentTabValue[productIndexId] || 0}
          onChange={(e, newValue) => handleAttachmentTabChange(e, newValue, productIndexId)}
          sx={{ mb: 2 }}
        >
          <Tab label="Select from Uploaded" />
          <Tab label="Upload New" />
        </Tabs>

        {(attachmentTabValue[productIndexId] || 0) === 0 ? (
          <Box>
            {(() => {
              const allProductAttachmentFiles = Object.values(productAttachments).flat()

              const availableAvatarFiles = (avatarUrl || []).filter((file) => {
                return !allProductAttachmentFiles.some((pfile) => attachmentMatches(pfile, file))
              })

              const allFiles = [
                ...availableAvatarFiles,
                ...allProductAttachmentFiles.map((file) => {
                  const product = (productRows || []).find(
                    (p) => Number(p?.indexId) === Number(file.product_index_id),
                  )
                  if (product) {
                    return mapDesignOrderProductAttachmentForDisplay(
                      file,
                      product,
                      groupedProductsMap,
                    )
                  }
                  return file
                }),
              ]

              const allFilesUnique = (() => {
                const seen = []
                return allFiles.filter((file) => {
                  if (seen.some((f) => attachmentMatches(f, file))) return false
                  seen.push(file)
                  return true
                })
              })()

              if (allFilesUnique.length === 0) {
                return (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: 'center', py: 4 }}
                  >
                    No uploaded files available. Please upload files first.
                  </Typography>
                )
              }

              const availableImages = allFilesUnique.filter((file) => {
                const isAddedToOtherProduct = Object.entries(productAttachments).some(
                  ([productId, attachments]) => {
                    if (String(productId) === String(productIndexId)) return false
                    return (
                      attachments &&
                      attachments.some((f) => attachmentMatches(f, file))
                    )
                  },
                )
                return !isAddedToOtherProduct
              })

              if (availableImages.length === 0) {
                return (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ textAlign: 'center', py: 4 }}
                  >
                    All images are added to other products. No images left in the uploaded files.
                  </Typography>
                )
              }

              const selectionKey = String(productIndexId)
              const rowSelection =
                selectedUploadedImages[selectionKey] ||
                selectedUploadedImages[productIndexId] ||
                []

              const original = getProductAttachmentsList(productIndexId)
              const toLink = rowSelection.filter((file) => !original.some((orig) => attachmentMatches(orig, file)))
              const toUnlink = original.filter((file) => !rowSelection.some((sel) => attachmentMatches(sel, file)))
              const hasChanges = toLink.length > 0 || toUnlink.length > 0

              return (
                <>
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    {availableImages.map((file, idx) => {
                      const isSelected = rowSelection.some((f) => attachmentMatches(f, file))
                      const isAlreadyAddedToCurrent = original.some((f) => attachmentMatches(f, file))
                      const url = file.url || file.name
                      const preview = file.preview || url
                      const fileExt = (
                        file.extension || url.split('.').pop().split('?')[0]
                      ).toLowerCase()
                      const isOffice = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(fileExt)
                      const isDesign = ['ai', 'psd', 'eps', 'dwg', 'dxf'].includes(fileExt)
                      const isPdf = file.file_type === 'application/pdf' || fileExt === 'pdf'

                      return (
                        <Grid item xs={6} sm={4} md={3} key={`${url}-${idx}`}>
                          <Card
                            sx={{
                              position: 'relative',
                              border:
                                isSelected ? '2px solid' : '1px solid',
                              borderColor:
                                isSelected
                                  ? 'primary.main'
                                  : 'divider',
                              cursor: 'pointer',
                              opacity: 1,
                            }}
                            onClick={() => {
                              handleImageSelect(file, productIndexId, !isSelected)
                            }}
                          >
                            <Box
                              sx={{
                                position: 'relative',
                                width: '100%',
                                paddingTop: '100%',
                                overflow: 'hidden',
                              }}
                            >
                              {isPdf || isOffice || isDesign ? (
                                <IconButton
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    window.open(url, '_blank', 'noopener,noreferrer')
                                  }}
                                  aria-label="open file"
                                  sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    p: 0,
                                    borderRadius: 0,
                                  }}
                                >
                                  <Box
                                    component="iframe"
                                    src={
                                      isPdf
                                        ? url
                                        : isOffice
                                        ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`
                                        : `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`
                                    }
                                    title="File Preview"
                                    frameBorder="0"
                                    // sandbox="allow-scripts allow-same-origin" before it was this caused pdf preview not working and fixed with below code, if any future issues came i have done only the pdf part that will only in me others i will be author
                                    sandbox={isPdf ? undefined : 'allow-scripts allow-same-origin'} 
                                    sx={{
                                      position: 'absolute',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                      pointerEvents: 'none',
                                    }}
                                  />
                                </IconButton>
                              ) : (
                                <Box
                                  component="img"
                                  src={preview}
                                  alt={file.name || 'Uploaded file'}
                                  sx={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                  }}
                                  onError={(e) => {
                                    if (preview !== url) {
                                      e.target.src = url
                                    }
                                  }}
                                />
                              )}
                              <AttachmentDownloadIconButton
                                file={file}
                                fileIndex={idx}
                                hidden={isClient || userType === 3}
                                sx={{ position: 'absolute', top: 4, left: 4, zIndex: 2 }}
                              />
                              <Checkbox
                                checked={isSelected}
                                sx={{
                                  position: 'absolute',
                                  top: 4,
                                  right: 4,
                                  zIndex: 3,
                                  bgcolor: 'rgba(255, 255, 255, 0.8)',
                                }}
                                onChange={(e) => {
                                  e.stopPropagation()
                                  handleImageSelect(file, productIndexId, e.target.checked)
                                }}
                              />
                              {isAlreadyAddedToCurrent && isSelected && (
                                <Chip
                                  label="Added"
                                  size="small"
                                  color="success"
                                  sx={{ position: 'absolute', bottom: 4, left: 4 }}
                                />
                              )}
                            </Box>
                          </Card>
                        </Grid>
                      )
                    })}
                  </Grid>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <AttachmentDownloadAllButton
                      files={rowSelection}
                      allFiles={availableImages}
                      onToggleSelectAll={(checked) => {
                        const key = String(productIndexId)
                        setSelectedUploadedImages((prev) => ({
                          ...prev,
                          [key]: checked ? [...availableImages] : [],
                          [productIndexId]: checked ? [...availableImages] : [],
                        }))
                      }}
                      label="Download Selected"
                      hidden={isClient || userType === 3}
                    />
                    <Button
                      variant="contained"
                      onClick={() => handleAddSelectedImages(productIndexId)}
                      disabled={!hasChanges}
                    >
                      Save Selection ({rowSelection.length})
                    </Button>
                  </Box>
                </>
              )
            })()}
          </Box>
        ) : (
          <UploadMultiFile
            showPreview
            multiple
            maxSize={1024 * 1024 * 1024}
            files={getProductAttachmentsList(productIndexId).map((file) =>
              enrichDesignOrderAttachmentForDisplay(
                file,
                productIndexId,
                productRows,
                groupedProductsMap,
              ),
            )}
            onDrop={(acceptedFiles) => handleProductDrop(acceptedFiles, productIndexId)}
            onRemove={(file) => handleProductRemove(file, productIndexId)}
            onRemoveAll={() => handleProductRemove(null, productIndexId)}
            isUploading={isUploadingProduct[productIndexId] || false}
            showProductLabels
          />
        )}
      </Grid>
    </Grid>
  )

  const handleProductDrop = useCallback(
    async (acceptedFiles, productIndexId) => {
      if (!acceptedFiles || acceptedFiles.length === 0) return

      setIsUploadingProduct((prev) => ({ ...prev, [productIndexId]: true }))

      try {
        const uploadPromises = acceptedFiles.map(async (file) => {
          const timestamp = Date.now()
          const sanitizedFileName = file.name.replace(/\s+/g, '_')
          const fileName = `${timestamp}_${sanitizedFileName}`
          const filePath = `design-order/product-attachments/${fileName}`

          const { error: uploadError } = await supabase.storage
            .from('signwise-attachments')
            .upload(filePath, file)

          if (uploadError) throw uploadError

          const { data: publicUrlData, error: urlError } = supabase.storage
            .from('signwise-attachments')
            .getPublicUrl(filePath)

          if (urlError || !publicUrlData?.publicUrl) {
            throw new Error('Failed to generate public URL')
          }

          return {
            url: publicUrlData.publicUrl,
            file_type: file.type,
            extension: file.name.split('.').pop(),
            size: file.size,
            name: file.name,
            product_index_id: productIndexId,
          }
        })

        const uploadedFiles = await Promise.all(uploadPromises)

        setProductAttachments((prev) => {
          const current = prev[productIndexId] || []
          const existingUrls = current.map((file) => file.url)
          const newFiles = uploadedFiles.filter((file) => !existingUrls.includes(file.url))
          return {
            ...prev,
            [productIndexId]: [...current, ...newFiles],
          }
        })

        setAvatarUrl((prev) => {
          const existingUrls = prev.map((file) => file.url)
          const newFiles = uploadedFiles.filter((file) => !existingUrls.includes(file.url))
          return [...prev, ...newFiles]
        })
      } catch (error) {
        console.error('Error uploading product file:', error)
        enqueueSnackbar('Failed to upload file', { variant: 'error' })
      } finally {
        setIsUploadingProduct((prev) => ({ ...prev, [productIndexId]: false }))
      }
    },
    [enqueueSnackbar],
  )

  const getDragTransferTypes = (dataTransfer) => {
    if (!dataTransfer?.types) return []
    const { types } = dataTransfer
    if (typeof types.includes === 'function') return [...types]
    const list = []
    for (let i = 0; i < types.length; i += 1) {
      list.push(types[i])
    }
    return list
  }

  const isExternalFileDragEvent = (e) => {
    const types = getDragTransferTypes(e.dataTransfer)
    if (types.some((type) => String(type).toLowerCase().includes('react-beautiful-dnd'))) {
      return false
    }
    return (
      types.includes('Files') ||
      types.includes('application/x-moz-file') ||
      Array.from(e.dataTransfer?.items || []).some((item) => item.kind === 'file')
    )
  }

  const handleProductIconDragOver = (e, productIndexId) => {
    if (!isExternalFileDragEvent(e)) return
    e.preventDefault()
    e.stopPropagation()
    if (e.dataTransfer) {
      e.dataTransfer.dropEffect = 'copy'
    }
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: true }))
  }

  const handleProductIconDragLeave = (e, productIndexId) => {
    e.preventDefault()
    e.stopPropagation()
    const related = e.relatedTarget
    if (related && e.currentTarget.contains(related)) return
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }))
  }

  const handleProductIconDrop = (e, productIndexId) => {
    e.preventDefault()
    e.stopPropagation()
    setProductAttachmentDragOver((prev) => ({ ...prev, [productIndexId]: false }))
    const files = Array.from(e.dataTransfer?.files || [])
    if (files.length > 0) {
      handleProductDrop(files, productIndexId)
    }
  }

  const handleProductRemove = (file, productIndexId) => {
    if (!file) {
      setProductAttachments((prev) => ({
        ...prev,
        [productIndexId]: [],
      }))
      return
    }
    setProductAttachments((prev) => {
      const current = prev[productIndexId] || []
      return {
        ...prev,
        [productIndexId]: current.filter((item) => !attachmentMatches(item, file)),
      }
    })
    setAvatarUrl((prev) => prev.filter((f) => !attachmentMatches(f, file)))
    setSelectedUploadedImages((prev) => pruneAttachmentMapsByFile(prev, file))
  }

  const getProductAttachmentRowProps = useCallback(
    (productIndexId) => ({
      eventHandlers: {
        onDragEnterCapture: (e) => handleProductIconDragOver(e, productIndexId),
        onDragOverCapture: (e) => handleProductIconDragOver(e, productIndexId),
        onDragLeave: (e) => handleProductIconDragLeave(e, productIndexId),
        onDropCapture: (e) => handleProductIconDrop(e, productIndexId),
      },
      sx: productAttachmentDragOver[productIndexId]
        ? {
            backgroundColor: 'action.hover',
            outline: `2px dashed ${theme.palette.primary.main}`,
            outlineOffset: -2,
          }
        : {},
    }),
    [
      handleProductIconDragOver,
      handleProductIconDragLeave,
      handleProductIconDrop,
      productAttachmentDragOver,
      theme.palette.primary.main,
    ],
  )

  const renderProductAttachmentModal = useCallback(
    (productIndexId) => {
      const key = String(productIndexId)
      return (
        <Dialog
          key={`group-product-attachment-dialog-${key}`}
          open={Boolean(openProductAttachment[productIndexId] || openProductAttachment[key])}
          onClose={() => handleCloseAttachment(productIndexId)}
          maxWidth="md"
          fullWidth
          disableScrollLock
        >
          <DialogContent>
            {renderProductAttachmentModalContent(productIndexId)}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleCloseAttachment(productIndexId)}>Close</Button>
          </DialogActions>
        </Dialog>
      )
    },
    [openProductAttachment],
  )
  

  const handleDeleteService = (servId, indexId) => {
    const newFilteredServices = additionalSelectedServices?.filter(data => !(data.id == servId && data.indexId == indexId));
    const newLocationStates = { ...serviceOnlyLocationStates };
    delete newLocationStates[indexId];
    setServiceOnlyLocationStates(newLocationStates);
    // const allFilteredServices = filteredServices?.find(data => data.id !== servId);
    // setFieldValue('services', newFilteredServices);
    setAdditionalSelectedServices(newFilteredServices);
  };


  return (
    <Page title="Design Order: list | Sign Wise Solutions">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <HeaderBreadcrumbs heading={'Design Order'} />
          <Box sx={{display:'flex' , alignItems:'center',gap:2}}>
          {(!user.isVendor && !open) && (
            <Button
              ref={refSettings}
              onClick={handleOpenFilters}
              variant="contained"
              color="success"
              sx={{ 
                color: 'common.white',
                border: filtersApplied ? '2px solid rgb(255, 0, 0)' : '1px solid #00c2ff',
              }}
              startIcon={<FilterList />}
            >
              Filters
            </Button>
          )}
          {(
            (userType === 3 && !user.isVendor)  ||
            explodedPermissions?.some((permission) =>
              ['Create Design Order'].includes(permission),
            )) &&
          !user.isVendor &&
          open == false ? (
            <>
              {/* {
                userType !==3? */}
              <LoadingButton
                loading={loadingAddFormData}
                disabled={loadingAddFormData}
                onClick={async () => {
                  if (!open) {
                    setProductRows([createEmptyProductRow(1)])
                    setProductIndexCounter(1)
                    setRowErrors({})
                    resetCatalogProductFields()
                    setFieldValue('split_catalog_type', splitOrderCatalogTypes.find((type) => type.id === 'all'))
                  }
                  await fetchAddFormData()
                  setOpen(true)
                }}
                variant="contained"
                startIcon={!loadingAddFormData ? <Icon icon={plusFill} /> : null}
              >
                {loadingAddFormData ? 'Loading Data...' : 'Add New Order'}
              </LoadingButton>
              {/* :""} */}
            </>
          ) : (
            ''
          )}
          </Box>
        </Stack>
        <Popover
          open={isFiltersOpen}
          anchorEl={filtersAnchorEl}
          onClose={handleCloseFilters}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              width: { xs: '92vw', sm: 620, md: 780 },
              maxWidth: '92vw',
              p: 2,
            },
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems="flex-start">
                <Button variant='outlined' 
                  sx={{ height:'40px', maxHeight:'36px', backgroundColor : dueData ? '#1ccaff' : '',color : dueData ? "#fff" : '' }} 
                  onClick={handleByDue} endIcon={<Stack> {dueData ? <Visibility /> : <VisibilityOff />} </Stack>}>
                  By Due
                </Button>
                <Stack>
                  <Button
                    ref={refSort}
                    onClick={() => setSortOpen((prevState) => !prevState)}
                    variant="outlined"
                    disabled={dueData}
                    type="button"
                    endIcon={
                      <Stack>
                        {sortOpen ? (
                          <ExpandLess sx={{ ml: 'auto' }} />
                        ) : (
                          <ExpandMore sx={{ ml: 'auto' }} />
                        )}
                      </Stack>
                    }
                  >
                    {sort.label}
                  </Button>
                  {dueData && (
                    <FormHelperText sx={{ color: 'error.main', fontSize: '0.65rem', mt: 0.5 }}>
                      Disable "By Due" to enable this.
                    </FormHelperText>
                  )}
                  <Menu
                    open={Boolean(sortOpen)}
                    anchorEl={refSort.current}
                    onClose={() => setSortOpen(false)}
                    PaperProps={{
                      sx: {
                        width: 'auto',
                        maxWidth: '100%',
                        maxHeight: '250px',
                      },
                    }}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                    {SORT.map((category) => (
                      <MenuItem
                        key={category.id}
                        onClick={() => handleChangeSort(category)}
                      >
                        <ListItemText primary={category.label} />
                      </MenuItem>
                    ))}
                  </Menu>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12} sm={6}>
              <MobileDateRangePicker
                startText="Filter Date"
                endText="Filter Date"
                value={filterDateValue}
                onChange={(newValue) => {
                  setFilterDateValue(newValue)
                }}
                renderInput={(startProps, endProps) => (
                  <>
                    <TextField
                      {...startProps}
                      sx={{ width: '100%' }}
                      helperText="Filter By Due Date"
                      label="From Date"
                      size="small"
                      InputLabelProps={{
                        style: {
                          color: theme.palette.primary.main,
                          borderColor: theme.palette.primary.main,
                        },
                      }}
                    />
                    <Box sx={{ mx: 1, color: theme.palette.primary.main }}>
                      {' '}
                      -{' '}
                    </Box>
                    <TextField
                      {...endProps}
                      sx={{ width: '100%' }}
                      helperText=""
                      label="To Date"
                      size="small"
                      InputLabelProps={{
                        style: {
                          color: theme.palette.primary.main,
                          borderColor: theme.palette.primary.main,
                        },
                      }}
                    />
                  </>
                )}
              />
            </Grid>
            <Grid item xs={12}>
              <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={1}
                alignItems={{ xs: 'flex-start', md: 'center' }}
                justifyContent="space-between"
                sx={{ flexWrap: 'wrap' }}
              >
                <Tabs
                  value={tabValue}
                  onChange={handleChange}
                  textColor="secondary"
                  indicatorColor="none"
                  aria-label="secondary tabs example"
                  sx={{ mb: { xs: 1, md: 0 } }}
                >
                  <CustomTab value="one" icon={<ViewModule />} />
                  <CustomTab value="two" icon={<ViewList />} />
                  <CustomTab value="three" icon={<ListIcon />} />
                </Tabs>

                <Stack
                  direction="row"
                  spacing={1}
                  justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
                  flexWrap="wrap"
                >
                  {!user.isVendor && userType !==3 && !isClient && !open &&(
                    <Button
                      ref={refClients}
                      onClick={() =>
                        setClientsOpen((prevState) => !prevState)
                      }
                      variant="outlined"
                      type="submit"
                      sx={{ alignItems: 'flex-end' }}
                      endIcon={
                        <Stack>
                          {clientsOpen ? (
                            <ExpandLess sx={{ ml: 'auto' }} />
                          ) : (
                            <ExpandMore sx={{ ml: 'auto' }} />
                          )}
                        </Stack>
                      }
                    >
                      Filter By Client
                    </Button>
                  )}
                  <Menu
                    open={Boolean(clientsOpen)}
                    anchorEl={refClients.current}
                    onClose={() => setClientsOpen(false)}
                    PaperProps={{
                      sx: { width: 'auto', maxWidth: '100%' },
                    }}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                    <Box sx={{ p: 2, pb: 1 }}>
                      <TextField
                        size="small"
                        placeholder="Search clients..."
                        value={clientSearchTerm}
                        onChange={(e) => setClientSearchTerm(e.target.value)}
                        fullWidth
                        variant="outlined"
                        sx={{ 
                          mb: 1,
                        }}
                      />
                      <Divider sx={{ mt: 1 }}/>
                    </Box>
                    <Box style={{ maxHeight: '200px', overflowY: 'auto' }}>
                      {(() => {
                        const filteredClients = clientData?.filter((type) =>
                          type.name?.toLowerCase().includes(clientSearchTerm.toLowerCase())
                        ) || [];
                        
                        // Sort in strict alphanumeric order
                        const sortedClients = filteredClients.sort((a, b) => {
                          const nameA = (a.name || '').trim();
                          const nameB = (b.name || '').trim();
                          return nameA.localeCompare(nameB, undefined, { 
                            numeric: true, 
                            sensitivity: 'base' 
                          });
                        });
                        
                        if (sortedClients.length === 0 && clientSearchTerm) {
                          return (
                            <MenuItem disabled sx={{ justifyContent: 'center' }}>
                              <ListItemText 
                                primary="No result found" 
                                sx={{ textAlign: 'center' }}
                              />
                            </MenuItem>
                          );
                        }
                        
                        return sortedClients.map((type) => (
                          <MenuItem key={type.id}>
                            {type.id === 'other' ? (
                              <ListItemText primary={`${type.name}`} />
                            ) : (
                              <ListItemText
                                primary={`${type.name}`}
                              />
                            )}
                            <Checkbox
                              checked={filterClient.includes(type.id)}
                              onChange={() => {
                                setPage(0)
                                handleToggleClient(type.id)
                              }}
                            />
                          </MenuItem>
                        ));
                      })()}
                    </Box>
                  </Menu>

                  {!user.isVendor && userType !==3 && !isClient && !open &&(
                    <Button
                      ref={refProjects}
                      onClick={() =>
                        setProjectsOpen((prevState) => !prevState)
                      }
                      variant="outlined"
                      type="submit"
                      sx={{ alignItems: 'flex-end' }}
                      endIcon={
                        <Stack>
                          {projectsOpen ? (
                            <ExpandLess sx={{ ml: 'auto' }} />
                          ) : (
                            <ExpandMore sx={{ ml: 'auto' }} />
                          )}
                        </Stack>
                      }
                    >
                      Filter By Project
                    </Button>
                  )}
                  <Menu
                    open={Boolean(projectsOpen)}
                    anchorEl={refProjects.current}
                    onClose={() => setProjectsOpen(false)}
                    PaperProps={{
                      sx: { width: 'auto', maxWidth: '100%' },
                    }}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                    <Box sx={{ p: 2, pb: 1 }}>
                      <TextField
                        size="small"
                        placeholder="Search projects..."
                        value={projectSearchTerm}
                        onChange={(e) => setProjectSearchTerm(e.target.value)}
                        fullWidth
                        variant="outlined"
                        sx={{ 
                          mb: 1,
                        }}
                      />
                      <Divider sx={{ mt: 1 }}/>
                    </Box>
                    <Box style={{ maxHeight: '200px', overflowY: 'auto' }}>
                      {(() => {
                        const filteredProjects = projectData?.filter((type) =>
                          type.name?.toLowerCase().includes(projectSearchTerm.toLowerCase())
                        ) || [];
                        
                        // Sort in strict alphanumeric order
                        const sortedProjects = filteredProjects.sort((a, b) => {
                          const nameA = (a.name || '').trim();
                          const nameB = (b.name || '').trim();
                          return nameA.localeCompare(nameB, undefined, { 
                            numeric: true, 
                            sensitivity: 'base' 
                          });
                        });
                        
                        if (sortedProjects.length === 0 && projectSearchTerm) {
                          return (
                            <MenuItem disabled sx={{ justifyContent: 'center' }}>
                              <ListItemText 
                                primary="No result found" 
                                sx={{ textAlign: 'center' }}
                              />
                            </MenuItem>
                          );
                        }
                        
                        return sortedProjects.map((type) => (
                          <MenuItem key={type.id}>
                            {type.id === 'other' ? (
                              <ListItemText primary={`${type.name}`} />
                            ) : (
                              <ListItemText
                                primary={`${type.name}`}
                              />
                            )}
                            <Checkbox
                              checked={filterProject.includes(type.id)}
                              onChange={() => {
                                setPage(0)
                                handleToggleProject(type.id)
                              }}
                            />
                          </MenuItem>
                        ));
                      })()}
                    </Box>
                  </Menu>
                </Stack>
              </Stack>
            </Grid>
            {filtersApplied && (
              <Button
                variant="outlined"
                color="error"
                onClick={deleteDesignOrderFilters}
                disabled={isDeletingFilters}
                startIcon={<Delete />}
                sx={{ mt: 2, ml: 2 }}
              >
                {isDeletingFilters ? 'Resetting...' : 'Reset Filters'}
              </Button>
            )}
            <Grid item xs={12}>
              <Stack direction={{ xs: 'column', md: 'column' }} spacing={1}>
                {filterClient?.length > 0 && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      border: 1,
                      borderColor: 'primary.main',
                      borderRadius: 2,
                      px: 1,
                      py: 0.5,
                      maxWidth: '100%',
                      height: 70,
                      overflowY: 'auto',
                      overflowX: 'hidden',
                    }}
                  >
                    <span
                      style={{
                        color: theme.palette.primary.darker,
                        marginRight: 8,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Selected Clients{' '}
                    </span>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {clientData
                        .filter((client) =>
                          filterClient?.includes(client.id),
                        )
                        .map((client) => (
                          <Chip
                            key={client.id}
                            label={client.name}
                            size="small"
                            onDelete={() =>
                              setFilterClient((prev) =>
                                prev.filter((id) => id !== client.id),
                              )
                            }
                          />
                        ))}
                    </Box>
                  </Box>
                )}
                {filterProject?.length > 0 && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      border: 1,
                      borderColor: theme.palette.primary.main,
                      borderRadius: 2,
                      px: 1,
                      py: 0.5,
                      maxWidth: '100%',
                      height: 70,
                      overflowY: 'auto',
                      overflowX: 'hidden',
                    }}
                  >
                    <span
                      style={{
                        color: theme.palette.primary.main,
                        marginRight: 8,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Selected Projects{' '}
                    </span>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {projectData
                        .filter((project) =>
                          filterProject?.includes(project.id),
                        )
                        .map((project) => (
                          <Chip
                            key={project.id}
                            label={project.name}
                            size="small"
                            onDelete={() =>
                              setFilterProject((prev) =>
                                prev.filter((id) => id !== project.id),
                              )
                            }
                          />
                        ))}
                    </Box>
                  </Box>
                )}
              </Stack>
            </Grid>
          </Grid>
        </Popover>
        {open ? (
          <FormikProvider value={formik}>
            <Form noValidate autoComplete="off" onSubmit={handleFormSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={12}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                      <Button
                        variant="outlined"
                        onClick={handleCancel}
                        sx={{ alignItems: 'right' }}
                        startIcon={
                          <Stack>
                            <KeyboardBackspaceOutlined />
                          </Stack>
                        }
                      >
                        Back
                      </Button>
                    </Box>
                  <Card sx={{ p: 3 }}>
                    <CardHeader sx={{ ml: -3, mt: -4 }} />
                    <Tabs
                      value={mainTab}
                      onChange={(e, newValue) => setMainTab(newValue)}
                      sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
                    >
                      <Tab label="New Order" sx={{ fontSize: '1.1rem', fontWeight: 600 }}/>
                      <Tab label="Design Form" sx={{ fontSize: '1.1rem', fontWeight: 600 }}/>
                    </Tabs>
                    
                    {/* First Tab - Form Content */}
                    {mainTab === 0 && (
                      <Stack spacing={3}>
                        <Stack
                          direction={{ xs: 'column', sm: 'row' }}
                          spacing={{ xs: 3, sm: 2 }}
                        >
                          <Stack flexDirection={'column'}>
                            <TextField
                              required
                              //   fullWidth
                              sx={{ width: 400 }}
                              label="Order Name"
                              name="name"
                              value={orderTextFields.name}
                              onChange={(e) => {
                                const v = e.target.value
                                setOrderTextFields((prev) => ({ ...prev, name: v }))
                                if (v.trim()) {
                                  setOrderTextFieldErrors((prev) => {
                                    const next = { ...prev }
                                    delete next.name
                                    return next
                                  })
                                }
                              }}
                              error={Boolean(orderTextFieldErrors.name)}
                              helperText={orderTextFieldErrors.name || ''}
                            />
                          </Stack>
                        </Stack>
                      <LabelStyle>Description</LabelStyle>
                      <TextField
                        required
                        fullWidth
                        multiline
                        minRows={3}
                        maxRows={7}
                        label="keep the summary brief and make it communicates"
                        name="description"
                        value={orderTextFields.description}
                        onChange={(e) => {
                          const v = e.target.value
                          setOrderTextFields((prev) => ({ ...prev, description: v }))
                          if (v.trim()) {
                            setOrderTextFieldErrors((prev) => {
                              const next = { ...prev }
                              delete next.description
                              return next
                            })
                          }
                        }}
                        error={Boolean(orderTextFieldErrors.description)}
                        helperText={orderTextFieldErrors.description || ''}
                      />

                      {userType == 3 ||
                        explodedPermissions?.some((permission) =>
                          ['Create Design Order'].includes(permission),
                        ) ? (
                          <>
                            {values?.project_categories?.name !=
                              'Service only' &&
                              values?.project_categories?.name !=
                                'Time & Material' && (
                                <>
                                  <LabelStyle>Upload Reference</LabelStyle>
                                  <UploadMultiFile
                                    showPreview
                                    // maxSize={1024 * 1024 * 1024}
                                    maxSize={1024 * 1024 * 1024}
                                    files={referenceFiles}
                                    onDrop={handleDropReference}
                                    onRemove={handleRemoveReference}
                                    onRemoveAll={handleRemoveAllReference}
                                    isUploading={isUploadingReference}
                                  />
                                  {(userType != 3 && !isClient) ?
                                    <>
                                      <LabelStyle>Upload Design</LabelStyle>
                                      <UploadMultiFile
                                        showPreview
                                        // maxSize={1024 * 1024 * 1024}
                                        maxSize={500 * 1024 * 1024 * 1024}
                                        files={designPreviewFiles}
                                        onDrop={handleDrop}
                                        onRemove={handleRemove}
                                        onRemoveAll={handleRemoveAll}
                                        isUploading={isUploading}
                                        showProductLabels
                                      />
                                    </>
                                  : ''}
                                </>
                              )}
                            <Stack
                              direction={{ xs: 'column', sm: 'row' }}
                              spacing={{ xs: 3, sm: 2 }}
                            >
                              {userType !==3 && !isClient && (
                              <Autocomplete
                                // multiple
                                // fullWidth
                                  sx={{ width: '50%' }}
                                id="combo-box-demo"
                                options={allClients}
                                value={values.clients}
                                onChange={(event, newValue) => {
                                  if (newValue) {
                                    setFieldValue('clients', newValue)
                                    setFieldValue('community', null)
                                    fetchAllCommunityByClient(newValue)
                                  } else {
                                    setFieldValue('clients', null)
                                    setFieldValue('community', null)
                                    setCommunities([])
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    required
                                    {...params}
                                    label="Clients"
                                    error={Boolean(
                                      touched.clients && errors.clients,
                                    )}
                                    helperText={
                                      touched.clients && errors.clients
                                    }
                                  />
                                )}
                                getOptionLabel={(option) => option.name}
                              />)}
                              {isCommunityLoading ?
                              <Stack flexDirection={'row'} alignItems='center' justifyContent='center'>
                                <CircularProgress color="primary" variant="indeterminate" />
                                <Typography variant='body2'>Loading projects...</Typography>
                              </Stack> :
                              ((communities?.length > 0 ? (
                                <Autocomplete
                                  // fullWidth
                                  sx={{ width: '50%' }}
                                  id="community"
                                  options={(communities || []).sort((a, b) => 
                                    alphanumericCompare(a?.name || '', b?.name || '')
                                  )}
                                  value={values.community}
                                  onChange={(event, newValue) =>{
                                    if(newValue){
                                    setFieldValue('community', newValue)
                                    setCollaborators([])
                                    const repOptions = getSalesRepOptionsFromCommunity(newValue);
                                    setSalesRepOptions(repOptions);
                                    if (repOptions.length > 0) {
                                      setSalesRepName(repOptions[0]?.name || '');
                                      setSalesRepId(repOptions[0]?.id || null);
                                    } else {
                                      setSalesRepName('');
                                      setSalesRepId(null);
                                    }
                                    if(userType ===3 || isClient){
                                      setFieldValue('clients', client)
                                    }
                                    console.log('dataaaaaaaaaaaaaa',newValue)
                                    if(newValue.tax_category){

                                   let taxCat = taxCategories?.find(cat => newValue.tax_category === cat.id)
                                    setSelectedTaxCategory(taxCat)
                                    }
                                  }else {
                              
                                    setFieldValue('community', null);
                                    setSelectedTaxCategory(null);
                                    setSalesRepName('');
                                    setSalesRepId(null);
                                    setSalesRepOptions([]);
                                  }
 
                                  }}
                                  renderInput={(params) => (
                                    <Tooltip
                                      title={values.community ? formatProjectAddress(values.community) : ''}
                                    >
                                      <TextField
                                        required
                                        {...params}
                                        label="Project"
                                        error={Boolean(touched.community && errors.community)}
                                        helperText={touched.community && errors.community}
                                      />
                                    </Tooltip>
                                  )}
                                  getOptionLabel={(option) => option.name}
                                  renderOption={(props, option) => {
                                    const { style, ...liProps } = props
                                    return (
                                      <li
                                        {...liProps}
                                        style={{
                                          ...style,
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <Tooltip title={formatProjectAddress(option)}>
                                          <span
                                            style={{
                                              flex: 1,
                                              minWidth: 0,
                                              display: 'block',
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: 'block',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                              }}
                                            >
                                              {option?.name || ''}
                                            </span>
                                            {/* <span
                                              style={{
                                                display: 'block',
                                                fontSize: 12,
                                                color: '#6b7280',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                              }}
                                            >
                                              {formatProjectAddress(option)}
                                            </span> */}
                                          </span>
                                        </Tooltip>
                                        <span style={{ display: 'none' }}>{option?.name || ''}</span>
                                      </li>
                                    )
                                  }}
                                />
                              ) : (
                                <Stack sx={{ width: '50%' }} justifyContent={'center'}>
                                  {values?.clients ?
                                    <Typography sx={{ color: "red" }}>The selected client does not have any projects yet. Please create a new project for them!</Typography>
                                    :( userType !==3 || !isClient)? <Typography sx={{ color: "red" }}>No client selected. Please choose a client from the list.</Typography>:''}
                                </Stack>
                              )))
                            }
                            </Stack>
                          </>
                        ):''}

                     {salesRepOptions?.length > 0 && (
                        <Stack sx={{ width: '100%' }}>
                          <Autocomplete
                            id="sales-rep"
                            options={salesRepOptions}
                            value={
                              salesRepOptions.find((opt) => {
                                if (salesRepId != null && opt?.id != null) {
                                  return String(opt.id) === String(salesRepId);
                                }
                                return salesRepName && opt?.name === salesRepName;
                              }) || null
                            }
                            onChange={(event, newValue) => {
                              setSalesRepName(newValue?.name || '');
                              setSalesRepId(newValue?.id || null);
                            }}
                            isOptionEqualToValue={(option, value) =>
                              (option?.id != null && value?.id != null && String(option.id) === String(value.id)) ||
                              option?.name === value?.name
                            }
                            getOptionLabel={(option) => option?.name || ''}
                            renderInput={(params) => (
                              <TextField {...params} label="Sales Rep" fullWidth />
                            )}
                          />
                        </Stack>
                      )}
                        {/* {(values.community?.id != null && values.community?.sales_rep_names != null)&& ( */}
                        <Stack sx={{ width: '100%' }}>
                            <Autocomplete
                              multiple
                              id="collaborators"
                              options={collaboratorOptions}
                              value={collaborators}
                              onChange={(event, newValue) => setCollaborators(newValue || [])}
                              loading={teamMembersLoading}
                              isOptionEqualToValue={(option, value) => (option?.id != null && value?.id != null && String(option.id) === String(value.id))}
                              getOptionLabel={(option) => {
                                if (!option) return '';
                                const name = option.name || [option.first_name, option.last_name].filter(Boolean).join(' ').trim();
                                return name || String(option.id || '');
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Collaborators"
                                  fullWidth
                                  placeholder="Select Collaborators"
                                />
                              )}
                            />
                          </Stack>
                        {/* )} */}
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <Box
                          component={MobileDatePicker}
                          // minDate={moment()}
                          label="Start Date"
                          value={moment.unix(values.start)}
                          onChange={(date) =>
                            setFieldValue('start', moment(date).unix())
                          }
                          // value={values.start}
                          // onChange={(date) => setFieldValue('start', moment(date).format('YYYY-MM-DD'))}
                          renderInput={(params) => (
                            <TextField size="medium" {...params} fullWidth />
                          )}
                        />
                        <Box
                          component={MobileDatePicker}
                          minDate={moment.unix(values.start)}
                          label="Due Date"
                          value={moment.unix(values.end)}
                          onChange={(date) =>
                            setFieldValue('end', moment(date).unix())
                          }
                          // value={values.end}
                          // onChange={(date) => setFieldValue('end', moment(date).format('YYYY-MM-DD'))}
                          renderInput={(params) => (
                            <TextField
                              size="medium"
                              {...params}
                              fullWidth
                              error={Boolean(touched.end && errors.end)}
                              helperText={touched.end && errors.end}
                            />
                          )}
                        />
                      </Stack>


                      {(userType !== 3 || !isClient) &&
                       ( explodedPermissions?.some((permission) =>
                          ['Create Design Order'].includes(permission),
                        ) && !isClient)&& (
                          <>
                            <LabelStyle>Products</LabelStyle>
                          <DesignOrderGroupDialogs
                            openAddToGroupModal={grouping.openAddToGroupModal}
                            setOpenAddToGroupModal={grouping.setOpenAddToGroupModal}
                            addToGroupOptions={grouping.addToGroupOptions}
                            addToGroupId={grouping.addToGroupId}
                            setAddToGroupId={grouping.setAddToGroupId}
                            handleAddToExistingGroup={grouping.handleAddToExistingGroup}
                            groupSelectedProductIds={grouping.groupSelectedProductIds}
                            openGroupCatalogSourceModal={grouping.openGroupCatalogSourceModal}
                            resetGroupCatalogSourceModal={grouping.resetGroupCatalogSourceModal}
                            showGroupCatalogCreateForm={grouping.showGroupCatalogCreateForm}
                            groupCatalogCustomName={grouping.groupCatalogCustomName}
                            setGroupCatalogCustomName={grouping.setGroupCatalogCustomName}
                            groupCatalogCustomDescription={grouping.groupCatalogCustomDescription}
                            setGroupCatalogCustomDescription={grouping.setGroupCatalogCustomDescription}
                            groupCatalogCreateError={grouping.groupCatalogCreateError}
                            setGroupCatalogCreateError={grouping.setGroupCatalogCreateError}
                            getCatalogSourceDropdownOptions={grouping.getCatalogSourceDropdownOptions}
                            groupCatalogSourceInputValue={grouping.groupCatalogSourceInputValue}
                            setGroupCatalogSourceInputValue={grouping.setGroupCatalogSourceInputValue}
                            setGroupCatalogSourceIndexId={grouping.setGroupCatalogSourceIndexId}
                            setGroupCatalogCustomSourceId={grouping.setGroupCatalogCustomSourceId}
                            setShowGroupCatalogCreateForm={grouping.setShowGroupCatalogCreateForm}
                            groupCatalogCustomSourceId={grouping.groupCatalogCustomSourceId}
                            customCatalogGroupSources={grouping.customCatalogGroupSources}
                            groupCatalogSourceIndexId={grouping.groupCatalogSourceIndexId}
                            getSelectedLineCatalogProducts={grouping.getSelectedLineCatalogProducts}
                            handleCancelGroupCatalogCreate={grouping.handleCancelGroupCatalogCreate}
                            handleCreateCustomCatalogGroup={grouping.handleCreateCustomCatalogGroup}
                            buildGroupFromSelection={grouping.buildGroupFromSelection}
                          />
                          <DesignOrderGroupActionBar
                            groupSelectedProductIds={grouping.groupSelectedProductIds}
                            groupEditMode={grouping.groupEditMode}
                            selectedProducts={catalogProducts}
                            handleCreateGroupFromSelection={grouping.handleCreateGroupFromSelection}
                            setOpenAddToGroupModal={grouping.setOpenAddToGroupModal}
                          />
                            <Stack direction={{ xs: 'column', sm: 'row' }} alignItems="center" spacing={{ xs: 3, sm: 2 }}>
                              <Autocomplete
                                sx={{ width: { xs: '100%', sm: '50%' } }}
                                multiple
                                id="design-order-product-autocomplete"
                                options={filteredProducts}
                                value={selectedCatalogProductsForAutocomplete}
                                onChange={handleAutocompleteCatalogProductsChange}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    required
                                    error={Boolean(touched.products && errors.products)}
                                    helperText={touched.products && errors.products}
                                    label="Select a product"
                                  />
                                )}
                                renderOption={(props, option) => {
                                  const { style, ...liProps } = props
                                  const description = option.description
                                  const name = getCatalogProductDisplayName(option)
                                  const suffix = getCatalogProductSuffix(option)
                                  return (
                                    <li
                                      {...liProps}
                                      style={{
                                        ...style,
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <div style={{ display: 'flex', alignItems: 'center', width: 40, justifyContent: 'center' }}>
                                        {option?.syncWithQuickbooks === 1 && (
                                          <img
                                            src={quickbookLogo}
                                            width="40px"
                                            height="20px"
                                            alt="QuickBooks"
                                          />
                                        )}
                                      </div>
                                      <Tooltip title={`${description || ''} ${suffix}`}>
                                        <span
                                          style={{
                                            flex: 1,
                                            minWidth: 0,
                                            display: 'block',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                          }}
                                        >
                                          {`${name || ''} ${suffix}`}
                                        </span>
                                      </Tooltip>
                                      <span style={{ display: 'none' }}>{option.name}</span>
                                    </li>
                                  )
                                }}
                                renderTags={(value, getTagProps) =>
                                  value.map((option, index) => {
                                    const name = getCatalogProductDisplayName(option)
                                    const suffix = getCatalogProductSuffix(option)
                                    return (
                                      <Tooltip key={index} title={getCatalogAutocompleteTooltip(option, suffix)}>
                                        <Chip
                                          {...getTagProps({ index })}
                                          label={`${name} ${suffix}`}
                                        />
                                      </Tooltip>
                                    )
                                  })
                                }
                                isOptionEqualToValue={() => false}
                                getOptionLabel={(option) => {
                                  const name = getCatalogProductDisplayName(option)
                                  const description = option.description || ''
                                  const suffix = getCatalogProductSuffix(option)
                                  return `${description} ${suffix} \u200B${name}`
                                }}
                                filterOptions={(options, { inputValue }) => {
                                  if (!inputValue) return options;
                                  const searchTerms = inputValue.toLowerCase().split(/\s+/).filter(Boolean);
                                  return options.filter((option) => {
                                    const displayNameMatch = searchTerms.every(term => getCatalogProductDisplayName(option).toLowerCase().includes(term));
                                    const nameMatch = searchTerms.every(term => option.name?.toLowerCase().includes(term));
                                    const descriptionMatch = searchTerms.every(term => option.description?.toLowerCase().includes(term));
                                    const tagsMatch = searchTerms.every(term => String(option.tags ?? '').toLowerCase().includes(term));
                                    const idMatch = searchTerms.every(term => String(option.id).includes(term));
                                    return displayNameMatch || nameMatch || descriptionMatch || tagsMatch || idMatch;
                                  });
                                }}
                              />
                              <Autocomplete
                              sx={{ width: { xs: '100%', sm: '50%' } }}
                              id="view-design-order-catalog-type"
                              options={splitOrderCatalogTypes}
                              value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                              onChange={(event, newValue) => {
                                const finalValue = newValue || splitOrderCatalogTypes.find((type) => type.id === 'all')
                                setFieldValue('split_catalog_type', finalValue)
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Catalog Type" placeholder="Select catalog type" />
                              )}
                              getOptionLabel={(option) => option.label}
                            />
                            </Stack>
                          <TableContainer component={Paper} sx={{ mt: 2, overflowX: 'auto' }}>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell padding="checkbox" sx={{ width: 40 }} />
                                  <TableCell padding="checkbox" sx={{ width: 40 }} />
                                  <TableCell align="center">Sl No</TableCell>
                                  <TableCell align="center">Mode</TableCell>
                                  {/* <TableCell align="center">Qb</TableCell> */}
                                  <TableCell align="center" sx={PRODUCT_TABLE_PRODUCT_COL_SX}>
                                    Products
                                  </TableCell>
                                  <TableCell align="center" sx={PRODUCT_TABLE_DESCRIPTION_COL_SX}>
                                    Description
                                  </TableCell>
                                  <TableCell align="center">Notes</TableCell>
                                  <TableCell align="center">Attachments</TableCell>
                                  <TableCell align="center">Formula cost Each</TableCell>
                                  <TableCell align="center">Markup (%)</TableCell>
                                  <TableCell align="center">Retail Each</TableCell>
                                  <TableCell align="center">Qty</TableCell>
                                  <TableCell align="center">Location</TableCell>
                                  <TableCell align="center">Marketing Adjustment Type</TableCell>
                                  <TableCell align="center">Marketing Adjustment</TableCell>
                                  <TableCell align="center">Subtotal</TableCell>
                                  <TableCell align="center">Product Total</TableCell>
                                  <TableCell align="center" />
                                </TableRow>
                              </TableHead>
                              <DragDropContext onDragEnd={handleProductRowsDragEnd}>
                                <Droppable droppableId="design-order-product-rows">
                                  {(droppableProvided) => (
                              <TableBody
                                ref={droppableProvided.innerRef}
                                {...droppableProvided.droppableProps}
                              >
                                {productTableBodyRenderOrder.map((bodyItem, index) => {
                                  if (bodyItem.type === 'group') {
                                    const group = groupedProductsMap.get(bodyItem.groupId)
                                    if (!group) return null
                                    const isGroupOpen = grouping.openGroupedRows[group.id] === true
                                    return (
                                      <DesignOrderGroupSummaryRow
                                        key={`design-group-${group.id}`}
                                        group={group}
                                        index={index}
                                        isGroupOpen={isGroupOpen}
                                        tableVariant="design"
                                        getGroupAnchorIndexId={getGroupAnchorIndexId}
                                        selectedProducts={catalogProducts}
                                        getGroupLosingMoneyFlags={grouping.getGroupLosingMoneyFlags}
                                        getLosingMoneyRowSx={grouping.getLosingMoneyRowSx}
                                        setOpenGroupedRows={grouping.setOpenGroupedRows}
                                        groupEditMode={grouping.groupEditMode}
                                        handleGroupFieldChange={grouping.handleGroupFieldChange}
                                        handleOpenGroupNote={handleOpenGroupNote}
                                        handleOpenAttachment={handleAddAttachment}
                                        getProductAttachmentsList={getProductAttachmentsList}
                                        theme={theme}
                                        handleGroupQuantityChange={grouping.handleGroupQuantityChange}
                                        setGroupLocationStates={grouping.setGroupLocationStates}
                                        handleGroupMarketingTypeChange={grouping.handleGroupMarketingTypeChange}
                                        handleGroupMarketingAdjustmentChange={grouping.handleGroupMarketingAdjustmentChange}
                                        hasMarkupPermission={hasMarkupPermission}
                                        markupType={markupType}
                                        hasNegativeMarketingPermission={hasNegativeDesignMarketingPermission}
                                        handleDeleteGroup={grouping.handleDeleteGroup}
                                        setGroupEditMode={grouping.setGroupEditMode}
                                        groupSelectedProductIds={grouping.groupSelectedProductIds}
                                        setGroupSelectedProductIds={grouping.setGroupSelectedProductIds}
                                        enqueueSnackbar={enqueueSnackbar}
                                        getSelectedLineCatalogCount={grouping.getSelectedLineCatalogCount}
                                        setSelectedProducts={setCatalogProducts}
                                        groupProductQuantityDrafts={grouping.groupProductQuantityDrafts}
                                        clearGroupLineQuantityDrafts={grouping.clearGroupLineQuantityDrafts}
                                        resetGroupMarketingAdjustments={grouping.resetGroupMarketingAdjustments}
                                        openGroupProductNoteIndex={grouping.openGroupProductNoteIndex}
                                        setOpenGroupProductNoteIndex={grouping.setOpenGroupProductNoteIndex}
                                        currentNote={currentNote}
                                        setCurrentNote={setCurrentNote}
                                        handleNoteChange={handleNoteChange}
                                        handleSaveNote={handleSaveNote}
                                        handleClearNote={handleClearNote}
                                        isSavingNote={isSavingNote}
                                        isClearingNote={false}
                                        MAX_CHARACTERS={MAX_CHARACTERS}
                                        expandedTableProps={{
                                          VALUE: designOrderGroupValueColumns,
                                          markupType,
                                          hasMarkupPermission,
                                          theme,
                                          tableVariant: 'design',
                                          productColSx: DESIGN_ORDER_PRODUCT_TABLE_PRODUCT_COL_SX,
                                          descriptionColSx: DESIGN_ORDER_PRODUCT_TABLE_DESCRIPTION_COL_SX,
                                          groupProductQuantityDrafts: grouping.groupProductQuantityDrafts,
                                          groupEditMode: grouping.groupEditMode,
                                          groupSelectedProductIds: grouping.groupSelectedProductIds,
                                          toggleGroupProductSelection: grouping.toggleGroupProductSelection,
                                          handleOpenNote,
                                          handleOpenAttachment: handleAddAttachment,
                                          handleOpenProductFormula: () => {},
                                          handleOpenInstallNote: (idx, note) =>
                                            handleOpenNote(`${idx}_install`, note),
                                          handleOpenGroupInstallNote,
                                          getProductAttachmentsList,
                                          isUploadingProduct,
                                          getProductAttachmentRowProps,
                                          handleGroupLineQuantityDraftChange:
                                            grouping.handleGroupLineQuantityDraftChange,
                                          handleGroupInstallQuantityChange:
                                            grouping.handleGroupInstallQuantityChange,
                                          handleGroupInstallMarketingTypeChange:
                                            grouping.handleGroupInstallMarketingTypeChange,
                                          handleGroupInstallMarketingAdjustmentChange:
                                            grouping.handleGroupInstallMarketingAdjustmentChange,
                                          handleGroupAllLocationSameChange:
                                            grouping.handleGroupAllLocationSameChange,
                                          handleGroupSingleCardChange: grouping.handleGroupSingleCardChange,
                                          handleGroupLocationFieldChange:
                                            grouping.handleGroupLocationFieldChange,
                                          groupLocationStates: grouping.groupLocationStates,
                                          setGroupLocationStates: grouping.setGroupLocationStates,
                                          setSelectedProducts: setCatalogProducts,
                                          setRefreshCalculation: grouping.setRefreshCalculation,
                                          handleDeleteGroupInstall: grouping.handleDeleteGroupInstall,
                                          renderProductAttachmentModal,
                                        }}
                                      />
                                    )
                                  }

                                  const row = productRows.find((r) => r.indexId === bodyItem.indexId)
                                  if (!row) return null
                                  const isWrite = row.entryMode !== 'choose'
                                  const rawData = row.catalogProduct
                                  const hasCatalog = !isWrite && rawData
                                  const data = hasCatalog ? getCatalogProductWithAdjustment(rawData) : rawData
                                  const price = hasCatalog
                                    ? (data.max_price ? data.max_price : (data.actual_retail_price || data.retail_price))
                                    : 0
                                  const installCost = hasCatalog ? parseFloat(data?.install_cost) || 0 : 0
                                  const formulaCost = hasCatalog
                                    ? ((data.inhouse === 0
                                      ? parseFloat(data?.sub_contract_price) || 0
                                      : (
                                        (parseFloat(data?.expected_material_cost_with_markup) || 0) +
                                        (parseFloat(data?.expected_service_cost_with_markup) || 0)
                                      )) || parseFloat(data?.expected_formula_price) || parseFloat(data?.expected_cost) || 0)
                                    : 0
                                  const qty = hasCatalog ? (data.quantity || 1) : null
                                  const productSubTotal = hasCatalog
                                    ? (data.actual_retail_price || 0) * (qty || 1)
                                    : null
                                  const installSubTotal = hasCatalog && installCost > 0
                                    ? installCost * (data.install_quantity || 1)
                                    : 0
                                  const productTotal = hasCatalog
                                    ? (productSubTotal || 0) + installSubTotal
                                    : null
                                  const hasNegativeMarketingPermission = explodedPermissions?.some((permission) =>
                                    ['Allow Negative Marketing Adjustment Design'].includes(permission),
                                  )
                                  const hasNegativeInstallMarketingPermission = explodedPermissions?.some((permission) =>
                                    ['Allow Negative Marketing Adjustment Design',].includes(permission),
                                  )

                                  const productFormulaEach = hasCatalog
                                    ? (data?.inhouse === 0
                                      ? Number(data?.sub_contract_price || 0)
                                      : Number(
                                        (data?.expected_material_cost_with_markup || 0) +
                                          (data?.expected_service_cost_with_markup || 0),
                                      ))
                                    : 0
                                  const retailPriceMin = hasNegativeMarketingPermission
                                    ? 0.01
                                    : Math.max(0.01, productFormulaEach)
                                  const dataActualRetail = Number(
                                    data?.actual_retail_price ?? price ?? 0,
                                  )
                                  const signedInstallAdj = data?.install_adj_value_type
                                    ? (Number.isFinite(Number(data?.install_adjustment))
                                        ? Number(data.install_adjustment)
                                        : 0)
                                    : -(Number.isFinite(Number(data?.install_adjustment))
                                        ? Number(data.install_adjustment)
                                        : 0)
                                  const productRetailEach = hasCatalog
                                    ? Math.max(
                                      0,
                                      Number(
                                        data?.actual_retail_price ??
                                          data?.retail_price ??
                                          0,
                                      ),
                                    )
                                    : 0
                                  const isNegativeProductAdjustmentMode =
                                    data?.adj_value_type === false ||
                                    data?.adj_value_type === 0 ||
                                    data?.adj_value_type === '0' ||
                                    data?.adj_value_type === 'false'
                                  const isProductLosingMoney =
                                    hasCatalog &&
                                    isNegativeProductAdjustmentMode &&
                                    productRetailEach < productFormulaEach

                                  const installFormulaEach = Number(
                                    data?.expected_install_labor_cost_with_markup || 0,
                                  )
                                  const installRetailEach = Math.max(
                                    0,
                                    Number(data?.install_cost || 0),
                                  )
                                  const isNegativeInstallAdjustmentMode =
                                    data?.install_adj_value_type === false ||
                                    data?.install_adj_value_type === 0 ||
                                    data?.install_adj_value_type === '0' ||
                                    data?.install_adj_value_type === 'false'
                                  const isInstallLosingMoney =
                                    hasCatalog &&
                                    installRetailEach > 0 &&
                                    isNegativeInstallAdjustmentMode &&
                                    installRetailEach < installFormulaEach

                                  const isLosingMoneyItem = isProductLosingMoney || isInstallLosingMoney

                                  const losingMoneyRowSx = getLosingMoneyRowSx(isLosingMoneyItem)

                                  return (
                                    <Fragment key={`product-row-group-${row.indexId}`}>
                                      <Draggable
                                        draggableId={`design-order-product-row-${row.indexId}`}
                                        index={index}
                                      >
                                        {(provided, snapshot) => (
                                      <TableRow
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        onDragEnterCapture={(e) => handleProductIconDragOver(e, row.indexId)}
                                        onDragOverCapture={(e) => handleProductIconDragOver(e, row.indexId)}
                                        onDragLeave={(e) => handleProductIconDragLeave(e, row.indexId)}
                                        onDropCapture={(e) => handleProductIconDrop(e, row.indexId)}
                                        sx={{
                                          ...losingMoneyRowSx,
                                          ...(productAttachmentDragOver[row.indexId] && {
                                            backgroundColor: 'action.hover',
                                            outline: `2px dashed ${theme.palette.primary.main}`,
                                            outlineOffset: -2,
                                          }),
                                        }}
                                        style={{
                                          ...provided.draggableProps.style,
                                          ...(snapshot.isDragging
                                            ? { backgroundColor: theme.palette.action.hover }
                                            : {}),
                                        }}
                                      >
                                        <TableCell
                                          padding="checkbox"
                                          {...provided.dragHandleProps}
                                          sx={{ width: 40, cursor: 'grab', verticalAlign: 'middle' }}
                                        >
                                          <DragIndicator fontSize="small" color="action" />
                                        </TableCell>
                                        <TableCell padding="checkbox">
                                          {(() => {
                                            const isAnyGroupInEditMode = Object.values(
                                              groupEditMode || {},
                                            ).some(Boolean)
                                            const gid = row?.catalogProduct?.group_id
                                              ? String(row.catalogProduct.group_id)
                                              : null
                                            const isGroupRow = Boolean(gid)
                                            const canSelectUngrouped =
                                              !isAnyGroupInEditMode && !isGroupRow && row.entryMode === 'choose'
                                            const canSelectGrouped =
                                              isGroupRow && !!groupEditMode?.[gid]
                                            const show = canSelectUngrouped || canSelectGrouped
                                            if (!show || row.entryMode !== 'choose' || !hasCatalog) return null
                                            return (
                                              <Checkbox
                                                checked={isIndexIdInList(groupSelectedProductIds, row.indexId)}
                                                onChange={() => toggleGroupProductSelection({
                                                  ...row.catalogProduct,
                                                  indexId: row.indexId,
                                                  entryMode: 'choose',
                                                })}
                                              />
                                            )
                                          })()}
                                        </TableCell>
                                    <TableCell align="center">#{index + 1}</TableCell>
                                    <TableCell align="center">
                                          <ProductLineEntryToggle
                                            mode={isWrite ? 'write' : 'choose'}
                                            onChange={(mode) => handleRowEntryModeChange(row.indexId, mode)}
                                          />
                                        </TableCell>
                                        {/* {isWrite ? (
                                          <TableCell align="center">-</TableCell>
                                        ) : (
                                          <TableCell align="center">
                                            {hasCatalog && data?.syncWithQuickbooks === 1 ? (
                                              <img src={quickbookLogo} alt="QuickBooks" style={{ width: 55, height: 55, objectFit: 'contain' }} />
                                            ) : (
                                              '-'
                                            )}
                                          </TableCell>
                                        )} */}
                                        <TableCell align="center" sx={PRODUCT_TABLE_PRODUCT_COL_SX}>
                                          {isWrite ? (
                                      <TextField
                                        fullWidth
                                        variant="outlined"
                                              size="small"
                                        value={row.product_name}
                                        onChange={(e) => handleProductNameChange(row.indexId, e.target.value)}
                                        placeholder="Product Name"
                                        error={Boolean(rowErrors[row.indexId])}
                                        helperText={rowErrors[row.indexId]}
                                        sx={{ width: '100%', minWidth: 0 }}
                                      />
                                          ) : hasCatalog ? (
                                            <Box>
                                              <Typography sx={{ fontWeight: 600, textAlign: 'center' }}>
                                                {data.name}
                                              </Typography>
                                              {data.product_notes ? (
                                                <Typography sx={{ color: 'error.main', fontSize: '0.8rem', whiteSpace: 'pre-wrap' }}>
                                                  Note: {data.product_notes}
                                                </Typography>
                                              ) : null}
                                            </Box>
                                          ) : (
                                            <Button
                                              size="small"
                                              variant="outlined"
                                              color="primary"
                                              onClick={() => openCatalogPickerForRow(row.indexId)}
                                            >
                                              Select Product
                                            </Button>
                                          )}
                                          {isWrite && row.product_notes ? (
                                            <Typography sx={{ color: 'error.main', fontSize: '0.8rem', whiteSpace: 'pre-wrap' }}>
                                              Note: {row.product_notes}
                                            </Typography>
                                          ) : null}
                                    </TableCell>
                                    <TableCell align="center" sx={PRODUCT_TABLE_DESCRIPTION_COL_SX}>
                                          {isWrite ? (
                                      <TextField
                                        fullWidth
                                        variant="outlined"
                                              size="small"
                                        value={row.product_desc}
                                        onChange={(e) => handleProductDescChange(row.indexId, e.target.value)}
                                        placeholder="Product Description"
                                        multiline
                                        minRows={2}
                                              maxRows={4}
                                              sx={{ width: '100%', minWidth: 0 }}
                                            />
                                          ) : hasCatalog ? (
                                            <TextField
                                              fullWidth
                                              variant="outlined"
                                              size="small"
                                              value={data.description || data.product_desc || ''}
                                              onChange={(e) => handleProductDescChange(row.indexId, e.target.value)}
                                              placeholder="Product Description"
                                              multiline
                                              minRows={2}
                                              maxRows={4}
                                              sx={{ width: '100%', minWidth: 0 }}
                                            />
                                          ) : (
                                            '-'
                                          )}
                                        </TableCell>
                                        <TableCell align="center">
                                          <IconButton
                                            onClick={() =>
                                              handleOpenNote(
                                                row.indexId,
                                                hasCatalog ? data.product_notes : row.product_notes,
                                              )
                                            }
                                          >
                                                            <NoteAdd
                                                              sx={{
                                                color: (hasCatalog ? data.product_notes : row.product_notes)
                                                  ? theme.palette.primary.main
                                                  : '',
                                                              }}
                                                            />
                                                          </IconButton>
                                                        </TableCell>
                                        <TableCell align="center">
                                          <Tooltip title="Drop files on row or click to open attachments">
                                            <IconButton onClick={() => handleAddAttachment(row.indexId)}>
                                              {isUploadingProduct[row.indexId] ? (
                                                <CircularProgress size={34} />
                                              ) : (
                                                <UploadFile
                                                  sx={{
                                                    color:
                                                      !productAttachments[row.indexId] ||
                                                      productAttachments[row.indexId]?.length === 0
                                                        ? 'error.main'
                                                        : theme.palette.primary.main,
                                                  }}
                                                />
                                              )}
                                            </IconButton>
                                          </Tooltip>
                                                        </TableCell>
                                        <TableCell align="center">
                                          {hasCatalog ? `$${fUSPrice(formulaCost)}` : '-'}
                                                        </TableCell>
                                        <TableCell align="center">
                                          {hasCatalog && data.inhouse === 0
                                            ? ((data?.sub_contract_markup ?? data?.markup) != null &&
                                              (data?.sub_contract_markup ?? data?.markup) !== ''
                                              ? `${Number(data.sub_contract_markup ?? data.markup).toFixed(2)}`
                                              : '0.00')
                                            : '-'}
                                                        </TableCell>
                                        <TableCell align="center">
                                          {hasCatalog ? (
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              size="small"
                                              label="Retail Price Each"
                                              sx={{ width: 120 }}
                                              value={
                                                data.retail_price_draft !== undefined
                                                  ? limitDecimalInput(data.retail_price_draft)
                                                  : formatRetailPriceDisplay(
                                                      dataActualRetail ?? 0,
                                                    )
                                              }
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onKeyPress={(event) => {
                                                if (event.key === '-') {
                                                  event.preventDefault()
                                                }
                                                if (event.key === 'e') {
                                                  event.preventDefault()
                                                }
                                              }}
                                              onKeyDown={(event) => {
                                                if (
                                                  event.key === 'ArrowUp' ||
                                                  event.key === 'ArrowDown'
                                                ) {
                                                  event.preventDefault()
                                                  const current =
                                                    data.retail_price_draft !== undefined
                                                      ? data.retail_price_draft
                                                      : formatRetailPriceDisplay(
                                                          dataActualRetail ?? 0,
                                                        )
                                                  handleRetailPriceChange(
                                                    row.indexId,
                                                    stepRetailPriceByArrow(
                                                      current,
                                                      event.key === 'ArrowUp'
                                                        ? 'up'
                                                        : 'down',
                                                      retailPriceMin,
                                                    ),
                                                    { isBlur: true },
                                                  )
                                                }
                                              }}
                                              inputProps={{ min: retailPriceMin, step: 1 }}
                                              onChange={(event) => {
                                                const current =
                                                  data.retail_price_draft !== undefined
                                                    ? data.retail_price_draft
                                                    : formatRetailPriceDisplay(
                                                        dataActualRetail ?? 0,
                                                      )
                                                handleRetailPriceChange(
                                                  row.indexId,
                                                  normalizeRetailArrowChange(
                                                    current,
                                                    event.target.value,
                                                    retailPriceMin,
                                                  ),
                                                )
                                              }}
                                              onBlur={(event) => {
                                                handleRetailPriceChange(
                                                  row.indexId,
                                                  event.target.value,
                                                  { isBlur: true },
                                                )
                                              }}
                                            />
                                          ) : '-'}
                                                        </TableCell>
                                        <TableCell align="center">
                                          {hasCatalog ? (
                                                                <TextField
                                                                  required
                                                                  type="number"
                                                            size="small"
                                              value={qty}
                                              style={{ width: 72 }}
                                              onChange={(e) => handleCatalogRowQuantityChange(row.indexId, e.target.value)}
                                              InputProps={{ inputProps: { min: 0 } }}
                                            />
                                          ) : (
                                            '-'
                                          )}
                                                        </TableCell>
                                        <TableCell align="center">
                                          {hasCatalog ? (
                                            <>
                                              <IconButton onClick={() => handleOpenLocation(row.indexId)}>
                                                            <LocationOn
                                                              sx={{
                                                    color: hasCompleteProductLocation(data)
                                                      ? theme.palette.primary.main
                                                      : 'error.main',
                                                              }}
                                                            />
                                                          </IconButton>
                                              <Modal
                                                open={locationStates[row.indexId] || false}
                                                handleClose={() => handleCloseLocation(row.indexId)}
                                              >
                                                <Grid container spacing={3} sx={{ p: 2 }}>
                                                  <Grid item xs={12}>
                                                    <Typography variant="h6">Location</Typography>
                                                  </Grid>
                                                  <Grid item xs={12}>
                                                    <TextField
                                                      fullWidth
                                                      required
                                                      label="Address"
                                                      value={data.location?.[0]?.address || ''}
                                                      onChange={(e) =>
                                                        handleLocationFieldChange(
                                                          row.indexId,
                                                          'address',
                                                          e.target.value,
                                                        )
                                                      }
                                                      sx={{ mb: 2 }}
                                                    />
                                                    <Stack direction="row" spacing={2}>
                                                      <TextField
                                                        fullWidth
                                                        required
                                                        label="City"
                                                        value={data.location?.[0]?.city || ''}
                                                        onChange={(e) =>
                                                          handleLocationFieldChange(
                                                            row.indexId,
                                                            'city',
                                                            e.target.value,
                                                          )
                                                        }
                                                      />
                                                      <TextField
                                                        fullWidth
                                                        required
                                                        label="State"
                                                        value={data.location?.[0]?.state || ''}
                                                        onChange={(e) =>
                                                          handleLocationFieldChange(
                                                            row.indexId,
                                                            'state',
                                                            e.target.value,
                                                          )
                                                        }
                                                      />
                                                      <TextField
                                                        fullWidth
                                                        required
                                                        label="Zip"
                                                        value={data.location?.[0]?.zip || ''}
                                                        onChange={(e) =>
                                                          handleLocationFieldChange(
                                                            row.indexId,
                                                            'zip',
                                                            e.target.value,
                                                          )
                                                        }
                                                            />
                                                          </Stack>
                                                  </Grid>
                                                  <Grid
                                                    item
                                                    xs={12}
                                                    sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}
                                                  >
                                                    <Button
                                                      variant="contained"
                                                      onClick={() => {
                                                        if (!hasCompleteProductLocation(data)) {
                                                          enqueueSnackbar(
                                                            'Please fill address, city, state, and zip.',
                                                            { variant: 'warning' },
                                                          )
                                                          return
                                                        }
                                                        handleCloseLocation(row.indexId)
                                                      }}
                                                    >
                                                      Save
                                                    </Button>
                                                  </Grid>
                                                </Grid>
                                              </Modal>
                                            </>
                                          ) : (
                                            '-'
                                          )}
                                          </TableCell>
                                        <TableCell align="center">
                                          {hasCatalog ? (
                                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                              <Remove
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const formulaEach = Number(
                                                    (data?.expected_material_cost_with_markup || 0) +
                                                      (data?.expected_service_cost_with_markup || 0),
                                                  )
                                                  const retailEachBase = Math.max(
                                                    0,
                                                    Number(
                                                      data.original_actual_retail_price ??
                                                        data.original_retail_price ??
                                                        data.actual_retail_price ??
                                                        data.retail_price ??
                                                        0,
                                                    ),
                                                  )
                                                  if (retailEachBase <= formulaEach && !hasNegativeMarketingPermission) {
                                                    enqueueSnackbar(
                                                      'To apply a negative marketing adjustment, Retail Price Each must be higher than the Product formula cost Each.',
                                                      { variant: 'error' },
                                                    )
                                                    return
                                                  }
                                                  const maxNegative = getMaxNegativeAdjustment(data, hasNegativeMarketingPermission)
                                                  const adjustment = Number(data.adjustment) || 0
                                                  if (Number(adjustment) >= maxNegative && hasNegativeMarketingPermission) {
                                                    enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                    return
                                                  }
                                                  if (Number(adjustment) > maxNegative && !hasNegativeMarketingPermission) {
                                                    enqueueSnackbar(
                                                      `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
                                                      { variant: 'error' },
                                                    )
                                                    return
                                                  }
                                                  handleCatalogAdjValueTypeChange(row.indexId, data, false)
                                                }}
                                              />
                                              <FormControlLabel
                                                control={
                                                  <Switch
                                                    checked={Boolean(data.adj_value_type)}
                                                    onChange={(event) =>
                                                      handleCatalogAdjValueTypeChange(row.indexId, data, event.target.checked)
                                                    }
                                                  />
                                                }
                                                label=""
                                              />
                                              <Add
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleCatalogAdjValueTypeChange(row.indexId, data, true)}
                                              />
                                            </Stack>
                                          ) : (
                                            '-'
                                          )}
                                        </TableCell>
                                        <TableCell align="center">
                                          {hasCatalog ? (
                                            <TextField
                                              type="number"
                                              size="small"
                                              inputProps={{ min: 0 }}
                                              label="$"
                                              value={Number(data.adjustment) || ''}
                                              onWheel={(e) => e.target.blur()}
                                              onBeforeInput={(e) => {
                                                const inputElement = e.target
                                                const nextValue = inputElement.value
                                                const maxNegative = getMaxNegativeAdjustment(data, hasNegativeMarketingPermission)
                                                if (
                                                  Number(nextValue) >= maxNegative &&
                                                  (data.adj_value_type === false || data.adj_value_type === 0) &&
                                                  hasNegativeMarketingPermission
                                                ) {
                                                  e.preventDefault()
                                                  enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                } else if (
                                                  Number(nextValue) > maxNegative &&
                                                  (data.adj_value_type === false || data.adj_value_type === 0) &&
                                                  !hasNegativeMarketingPermission
                                                ) {
                                                  e.preventDefault()
                                                  enqueueSnackbar(
                                                    `Negative Adjustment Amount cannot reduce total below Product Formula Cost. Max allowed: $${Number(maxNegative).toFixed(2)}`,
                                                    { variant: 'error' },
                                                  )
                                                }
                                              }}
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                const numValue = parseFloat(newValue) || 0
                                                if (numValue < 0) {
                                                  newValue = '0'
                                                } else if (newValue.includes('.')) {
                                                  const parts = newValue.split('.')
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`
                                                  }
                                                } else {
                                                  newValue = String(numValue)
                                                }
                                                handleCatalogAdjustmentChange(row.indexId, data, newValue)
                                              }}
                                              onKeyDown={(event) => {
                                                if (event.key === '-' || event.key === '+') {
                                                  event.preventDefault()
                                                }
                                              }}
                                              style={{ width: 90 }}
                                            />
                                          ) : (
                                            '-'
                                          )}
                                        </TableCell>
                                                        <TableCell align="center">
                                          {hasCatalog ? `$${fUSPrice(productSubTotal)}` : '-'}
                                        </TableCell>
                                        <TableCell align="center">
                                          {hasCatalog && data?.install_cost
                                            ? ''
                                            : hasCatalog
                                              ? `$${fUSPrice(productTotal)}`
                                              : '-'}
                                        </TableCell>
                                    <TableCell align="center" sx={DESIGN_ORDER_ROW_ACTIONS_CELL_SX}>
                                      <Box sx={DESIGN_ORDER_ROW_ACTIONS_BOX_SX}>
                                        <Box sx={DESIGN_ORDER_ROW_ACTIONS_LEADING_SLOT_SX}>
                                          {!isWrite && hasCatalog ? (
                                            <Tooltip title="Change product">
                                              <IconButton
                                                size="small"
                                                color="success"
                                                onClick={() => openCatalogPickerForRow(row.indexId, data)}
                                              >
                                                <SwapHorizontalCircleOutlined fontSize="small" />
                                              </IconButton>
                                            </Tooltip>
                                          ) : null}
                                        </Box>
                                          <IconButton onClick={() => handleDeleteProduct(row.indexId)} color="error">
                                          <Delete />
                                          </IconButton>
                                      </Box>
                                    </TableCell>
                                                      </TableRow>
                                        )}
                                      </Draggable>
                                      {hasCatalog && data?.install_cost ? (
                                        <TableRow sx={losingMoneyRowSx}>
                                          <TableCell />
                                          <TableCell />
                                          <TableCell align="center">#{index + 1}</TableCell>
                                          <TableCell align="center">-</TableCell>
                                          <TableCell align="center" sx={PRODUCT_TABLE_PRODUCT_COL_SX}>                                            
                                            {data.install_notes ? (
                                                <Typography sx={{ color: 'error.main', whiteSpace: 'pre-wrap' }}>
                                                 {data.install_notes}
                                                </Typography>
                                              ) : <Typography>Install Price</Typography>}
                                                          </TableCell>
                                          <TableCell align="center" sx={PRODUCT_TABLE_DESCRIPTION_COL_SX}>
                                            -
                                          </TableCell>
                                                          <TableCell align="center">
                                            <IconButton onClick={() => handleOpenNote(`${row.indexId}_install`, data.install_notes)}>
                                              <NoteAdd sx={{ color: data.install_notes ? theme.palette.primary.main : '' }} />
                                                            </IconButton>
                                                          </TableCell>
                                                          <TableCell align="center">-</TableCell>
                                          <TableCell align="center">
                                            ${
                                              data?.install_formula_cost_each != null &&
                                              data?.install_formula_cost_each !== ''
                                                ? fUSPrice(Number(data.install_formula_cost_each))
                                                : fUSPrice(data?.expected_install_labor_cost_with_markup || 0)
                                            }
                                          </TableCell>
                                                          <TableCell align="center">-</TableCell>
                                          <TableCell align="center">
                                            {(() => {
                                              const installFormulaEach = Number(
                                                data?.expected_install_labor_cost_with_markup ||
                                                  0,
                                              )
                                              const installPriceMin =
                                                hasNegativeInstallMarketingPermission
                                                  ? 0.01
                                                  : Math.max(
                                                      0.01,
                                                      installFormulaEach,
                                                    )
                                              const dataInstallCost = getDisplayedInstallPrice(data)
                                              return (
                                            <TextField
                                              required
                                              fullWidth
                                              type="number"
                                              size="small"
                                              label="Install Price Each"
                                              sx={{ width: 120 }}
                                              value={
                                                data.install_price_draft !== undefined
                                                  ? limitDecimalInput(
                                                      data.install_price_draft,
                                                    )
                                                  : formatRetailPriceDisplay(
                                                      dataInstallCost,
                                                    )
                                              }
                                              onFocus={selectInputValue}
                                              onClick={selectInputValue}
                                              onKeyPress={(event) => {
                                                if (event.key === '-') {
                                                  event.preventDefault()
                                                }
                                                if (event.key === 'e') {
                                                  event.preventDefault()
                                                }
                                              }}
                                              onKeyDown={(event) => {
                                                if (
                                                  event.key === 'ArrowUp' ||
                                                  event.key === 'ArrowDown'
                                                ) {
                                                  event.preventDefault()
                                                  const current =
                                                    data.install_price_draft !== undefined
                                                      ? data.install_price_draft
                                                      : formatRetailPriceDisplay(
                                                          dataInstallCost,
                                                        )
                                                  handleInstallPriceChange(
                                                    row.indexId,
                                                    stepRetailPriceByArrow(
                                                      current,
                                                      event.key === 'ArrowUp'
                                                        ? 'up'
                                                        : 'down',
                                                      installPriceMin,
                                                    ),
                                                    { isBlur: true },
                                                  )
                                                }
                                              }}
                                              inputProps={{
                                                min: installPriceMin,
                                                step: 1,
                                              }}
                                              onChange={(event) => {
                                                const current =
                                                  data.install_price_draft !== undefined
                                                    ? data.install_price_draft
                                                    : formatRetailPriceDisplay(
                                                        dataInstallCost,
                                                      )
                                                handleInstallPriceChange(
                                                  row.indexId,
                                                  normalizeRetailArrowChange(
                                                    current,
                                                    event.target.value,
                                                    installPriceMin,
                                                  ),
                                                )
                                              }}
                                              onBlur={(event) => {
                                                handleInstallPriceChange(
                                                  row.indexId,
                                                  event.target.value,
                                                  { isBlur: true },
                                                )
                                              }}
                                            />
                                              )
                                            })()}
                                          </TableCell>
                                                          <TableCell align="center">
                                                            <TextField
                                                              type="number"
                                              size="small"
                                              value={data.install_quantity || 1}
                                              style={{ width: 72 }}
                                              onChange={(e) => handleInstallQuantityChange(row.indexId, e.target.value)}
                                              InputProps={{ inputProps: { min: 0 } }}
                                            />
                                          </TableCell>
                                          <TableCell align="center">-</TableCell>
                                          <TableCell align="center">
                                            <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
                                              <Remove
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                  const formulaEach = Number(data?.expected_install_labor_cost_with_markup || 0)
                                                  const retailEachBase = Math.max(0, Number(data.install_cost || 0))
                                                  if (retailEachBase <= formulaEach && !hasNegativeInstallMarketingPermission) {
                                                    enqueueSnackbar(
                                                      'To apply a negative marketing adjustment, Install Price Each must be higher than the Install formula cost Each.',
                                                      { variant: 'error' },
                                                    )
                                                    return
                                                  }
                                                  handleInstallAdjValueTypeChange(row.indexId, data, false)
                                                }}
                                              />
                                              <FormControlLabel
                                                control={
                                                  <Switch
                                                    checked={Boolean(data.install_adj_value_type)}
                                                    onChange={(event) =>
                                                      handleInstallAdjValueTypeChange(row.indexId, data, event.target.checked)
                                                    }
                                                  />
                                                }
                                                label=""
                                              />
                                              <Add
                                                fontSize="small"
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => handleInstallAdjValueTypeChange(row.indexId, data, true)}
                                              />
                                            </Stack>
                                          </TableCell>
                                          <TableCell align="center">
                                            <TextField
                                              type="number"
                                              size="small"
                                              inputProps={{ min: 0 }}
                                              label="$"
                                              value={
                                                data.install_adjustment_draft !== undefined
                                                  ? limitDecimalInput(
                                                      data.install_adjustment_draft,
                                                    )
                                                  : Number(data.install_adjustment) || ''
                                              }
                                              onWheel={(e) => e.target.blur()}
                                              onBeforeInput={(e) => {
                                                const inputElement = e.target
                                                const nextValue = inputElement.value
                                                const maxNegative = getMaxNegativeInstallAdjustment(
                                                  data,
                                                  hasNegativeInstallMarketingPermission,
                                                )
                                                if (
                                                  Number(nextValue) >= maxNegative &&
                                                  data.install_adj_value_type === false &&
                                                  hasNegativeInstallMarketingPermission
                                                ) {
                                                  e.preventDefault()
                                                  enqueueSnackbar('Retail value cannot be zero or less', { variant: 'error' })
                                                } else if (
                                                  Number(nextValue) > maxNegative &&
                                                  data.install_adj_value_type === false &&
                                                  !hasNegativeInstallMarketingPermission
                                                ) {
                                                  e.preventDefault()
                                                  enqueueSnackbar(
                                                    `Negative Adjustment Amount cannot reduce below $${Number(maxNegative).toFixed(2)} (Install Formula Limit)`,
                                                    { variant: 'error' },
                                                  )
                                                }
                                              }}
                                              onChange={(event) => {
                                                let newValue = event.target.value
                                                const numValue = parseFloat(newValue) || 0
                                                if (numValue < 0) {
                                                  newValue = '0'
                                                } else if (newValue.includes('.')) {
                                                  const parts = newValue.split('.')
                                                  if (parts[1].length > 2) {
                                                    newValue = `${parts[0]}.${parts[1].slice(0, 2)}`
                                                  }
                                                } else {
                                                  newValue = String(numValue)
                                                }
                                                handleInstallAdjustmentChange(row.indexId, data, newValue)
                                              }}
                                              onKeyDown={(event) => {
                                                if (event.key === '-' || event.key === '+') {
                                                  event.preventDefault()
                                                }
                                              }}
                                              style={{ width: 90 }}
                                            />
                                          </TableCell>
                                          <TableCell align="center">
                                            ${fUSPrice(installSubTotal)}
                                          </TableCell>
                                          <TableCell align="center">${fUSPrice(productTotal)}</TableCell>
                                        <TableCell align="center" sx={DESIGN_ORDER_ROW_ACTIONS_CELL_SX}>
                                          <Box sx={DESIGN_ORDER_ROW_ACTIONS_BOX_SX}>
                                            <Box sx={DESIGN_ORDER_ROW_ACTIONS_LEADING_SLOT_SX} />
                                            <IconButton color="error" onClick={() => handleDeleteInstallCost(row.indexId)}>
                                              <Delete />
                                            </IconButton>
                                          </Box>
                                        </TableCell>
                                        </TableRow>
                                      ) : null}
                                    </Fragment>
                                  )
                                })}
                                {droppableProvided.placeholder}
                              </TableBody>
                                  )}
                                </Droppable>
                              </DragDropContext>
                            </Table>
                          </TableContainer>
                          <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-start' }}>
                            <Button
                              variant="outlined"
                              startIcon={<Icon icon={plusFill} />}
                              onClick={addNewProductRow}
                              sx={{ marginLeft: '20px' }}
                            >
                              Add Rows
                            </Button>
                          </Box>
                            <Typography variant="h6" align="right" sx={{ mt: 2, pr: 22 }}>
                              Total Product Cost: ${fUSPrice(selectedProductsSubTotal?.toFixed(2))}
                            </Typography>
                          <Dialog
                            open={catalogPickerOpen}
                            onClose={() => {
                              setCatalogPickerOpen(false)
                              setCatalogPickerRowIndexId(null)
                              setCatalogPickerDraft(null)
                            }}
                            maxWidth="md"
                            fullWidth
                            disableScrollLock
                          >
                            <DialogTitle>
                              {productRows.find((r) => r.indexId === catalogPickerRowIndexId)?.catalogProduct
                                ? 'Change Catalog Product'
                                : 'Select Catalog Product'}
                            </DialogTitle>
                            <DialogContent>
                              <Stack spacing={2} sx={{ mt: 1 }}>
                                <Autocomplete
                                  options={filteredProducts}
                                  value={catalogPickerDraft}
                                  noOptionsText="No products found"
                                  ListboxProps={{ style: { maxHeight: 280 } }}
                                  onChange={(event, newValue) => setCatalogPickerDraft(newValue)}
                                  isOptionEqualToValue={(option, value) => option?.id === value?.id}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      required
                                      label="Select a product"
                                    />
                                  )}
                                  renderOption={(props, option) => {
                                    const { style, ...liProps } = props
                                    const suffix = getCatalogProductSuffix(option)
                                    const label = `${option?.name || ''} ${suffix}`
                                    return (
                                      <li
                                        {...liProps}
                                        title={`${option.description || ''} ${suffix}`.trim()}
                                        style={{ ...style, display: 'flex', alignItems: 'center' }}
                                      >
                                        <span
                                          style={{
                                            flex: 1,
                                            minWidth: 0,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          {label}
                                        </span>
                                      </li>
                                    )
                                  }}
                                  getOptionLabel={(option) => option?.name || ''}
                                />
                                <Autocomplete
                                  options={splitOrderCatalogTypes}
                                  value={values.split_catalog_type || splitOrderCatalogTypes.find((type) => type.id === 'all')}
                                  onChange={(event, newValue) => {
                                    setFieldValue('split_catalog_type', newValue || splitOrderCatalogTypes.find((type) => type.id === 'all'))
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} label="Catalog Type" placeholder="Select catalog type" />
                                  )}
                                  getOptionLabel={(option) => option.label}
                                />
                              </Stack>
                            </DialogContent>
                            <DialogActions>
                              <Button
                                                                onClick={() => {
                                  setCatalogPickerOpen(false)
                                  setCatalogPickerRowIndexId(null)
                                  setCatalogPickerDraft(null)
                                }}
                              >
                                Cancel
                              </Button>
                              <Button variant="contained" onClick={confirmCatalogPicker}>
                                Confirm
                              </Button>
                            </DialogActions>
                          </Dialog>

                          {productRows.map((row) => (
                            <Dialog
                              key={`product-attachment-dialog-${row.indexId}`}
                              open={Boolean(openProductAttachment[row.indexId])}
                              onClose={() => handleCloseAttachment(row.indexId)}
                              maxWidth="md"
                              fullWidth
                              disableScrollLock
                            >
                              <DialogContent>
                                {renderProductAttachmentModalContent(row.indexId)}
                              </DialogContent>
                              <DialogActions>
                                <Button onClick={() => handleCloseAttachment(row.indexId)}>Close</Button>
                              </DialogActions>
                            </Dialog>
                          ))}

                          <Dialog
                            open={Object.keys(openProductNote).some((key) => openProductNote[key])}
                            onClose={() => {
                              const openKey = Object.keys(openProductNote).find((key) => openProductNote[key])
                              if (openKey) handleCloseNote(openKey)
                            }}
                            maxWidth="sm"
                            fullWidth
                            disableScrollLock
                          >
                            <DialogTitle>Product Note</DialogTitle>
                            <DialogContent>
                              <TextField
                                fullWidth
                                multiline
                                rows={4}
                                value={currentNote}
                                onChange={handleNoteChange}
                                inputProps={{ maxLength: MAX_CHARACTERS }}
                                helperText={`${currentNote.length}/${MAX_CHARACTERS} characters`}
                              />
                            </DialogContent>
                            <DialogActions>
                              <Button
                                                                onClick={() => {
                                  const openKey = Object.keys(openProductNote).find((key) => openProductNote[key])
                                  if (openKey) handleCloseNote(openKey)
                                }}
                              >
                                Cancel
                              </Button>
                              <LoadingButton
                                variant="contained"
                                loading={isSavingNote}
                                onClick={() => {
                                  const openKey = Object.keys(openProductNote).find((key) => openProductNote[key])
                                  if (openKey) handleSaveNote(openKey)
                                }}
                              >
                                Save
                              </LoadingButton>
                            </DialogActions>
                          </Dialog>

                         <Stack direction='row'>
                            <LabelStyleHead>Services</LabelStyleHead>
                          </Stack>

                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <Autocomplete
                              sx={{ width: '50%' }}
                              multiple
                              id="combo-box-demo"
                              options={
                                [...(filteredServices?.filter((item) => item?.status == 1) || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                              }
                              // value={values.services || null}
                              value={additionalSelectedServices} 

                              onChange={(event, newValue) => {
                                setAdditionalSelectedServices(newValue)
                                if(newValue.length > 0){
                                  fetchAllProjectMembers(newValue)
                                  }else{
                                    setDesigners([])
                                  }
                              }}
                          
                              renderInput={(params) => (
                                <TextField {...params} required
                                  error={Boolean(touched.services && errors.services)}
                                  helperText={touched.services && errors.services}
                                  label='Select services'/>
                              )}
                              getOptionLabel={(option) => option.name ? option.name : ''}
                            />
                           { membersLoading ?
                            <Stack flexDirection={'row'} alignItems='center' justifyContent='center' gap={2}>
                                <CircularProgress color="primary" variant="indeterminate" />
                                <Typography variant='body2'>Loading Designers...</Typography>
                              </Stack> :
                            <Autocomplete
                              sx={{ width: '50%' }}
                              multiple
                              id="designer-autocomplete"
                              options={
                                [...(filteredMembers || [])].sort((a, b) => alphanumericCompare(a?.name || '', b?.name || ''))
                              }
                              value={designers}
                              onChange={(event, newValue) => {
                                setDesigners(newValue);
                              }}
                              isOptionEqualToValue={(option, value) => option.id === value.id}
                              getOptionLabel={(option) => option.name || ''}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  required
                                  label="Choose Designer"
                                  error={Boolean(touched.services && errors.services)}
                                  helperText={touched.services && errors.services}
                                />
                              )}
                            />

                            }
                          </Stack>



                          {/* <Stack
                              direction={{ xs: 'column', sm: 'row' }}
                              spacing={{ xs: 3, sm: 2 }}
                            >
                            <FormControlLabel
                              control={
                                <Switch
                                  color="primary"
                                  checked={values.designer_email_sent}
                                  onChange={(event) => setFieldValue('designer_email_sent', event.target.checked ? 1 : 0)}
                                />
                              }
                              label="Send email to designers"
                            />
                            <FormControlLabel
                              control={
                                <Switch
                                  color="primary"
                                  checked={values.designer_sms_sent}
                                  onChange={(event) => setFieldValue('designer_sms_sent', event.target.checked ? 1 : 0)}
                                />
                              }
                              label="Send sms to designers"
                            />
                          </Stack> */}
                          
                          <LabelStyle>Selected services</LabelStyle>

                                                    <Scrollbar>
                                                      <TableContainer sx={{ minWidth: 500 }}>
                                                        <Table>
                                                          <TableHead>
                                                            <TableRow>
                                                              <TableCell padding="checkbox" sx={{ width: 40 }} />
                                                              {VALUE_SERVICES?.map((val) => (
                                                                // ((values.project_categories?.name == 'Time & Material') && val.id === 6) ? <TableCell></TableCell> : 
                                                                ((((values.project_categories?.name == 'Service only') || 
                                                                   (values.project_categories?.name == 'Time & Material')) && val.id === 0)
                                                                  //  || ((values.project_categories?.name !== 'Service only') && val.id === 6)
                                                                  ) ? null : (
                                                                <TableCell>{val.value}</TableCell>
                                                                ))
                                                              )}
                                                            </TableRow>
                                                          </TableHead>
                                                          <DragDropContext onDragEnd={handleServiceTableDragEnd}>
                                                            <Droppable droppableId="design-order-service-rows">
                                                              {(droppableProvided) => (
                                                          <TableBody
                                                            ref={droppableProvided.innerRef}
                                                            {...droppableProvided.droppableProps}
                                                          >
                                                            {/* {additionalSelectedServices?.map((data, index) => {
                                                             
                                                              if(values.project_categories?.name == 'Time & Material'){
                                                                data['total_cost'] = 0
                                                                data['cost'] = 0
                                                                data['quantity'] = 0
                                                              }
                                                              const quantityFieldName = `service_quantity_${index}`;
                                                              const dataQuantity = data?.quantity ? data?.quantity : 1;
                                                              data['quantity'] = dataQuantity
                                                              const total = data.total_cost * data?.quantity
                                                              let markup = 0;
                                                              if (total > 0) {
                                                                markup = data.total_cost / Number(total);
                                                                data['markup'] = markup?.toFixed(2);
                                                              } else {
                                                                markup = 0
                                                                data['markup'] = 0;
                                                              }
                                                              totalServiceMarkup += markup
                          
                                                              let originalMarkup = data.originalMarkup || 0
                                                              originaltotalServiceMarkup += originalMarkup
                                                              data['total'] = total?.toFixed(2)
                                                              data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                                              values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                                              const quantityDifference = Number(data.quantity)
                                                              data['quantityDifference'] = quantityDifference
                                                              data['jobcost_unit_cost'] = data.cost
                                                              data['jobcost_quantity'] = quantityDifference
                                                              data['jobcost_total_cost'] = (data.cost*Number(data.quantity) || 1)?.toFixed(2)
                          
                                                              let newTotalCost = total?.toFixed(2)
                                                              let newTotalProductFormula = (data.cost*quantityDifference)?.toFixed(2)
                                                              totalProductFormula += Number(newTotalProductFormula)
                                                              totalWholesalePrice += Number(newTotalCost)
                                                              totalRetailPrice += Number(newTotalCost)
                                                              values['totalProductFormula'] = totalProductFormula
                                                              values['totalWholesalePrice'] = totalWholesalePrice
                                                              values['totalRetailPrice'] = totalRetailPrice
                          
                                                              return (
                                                                <>
                                                                  <TableRow key={data.id}>
                                                                
                                                                    <TableCell>{data.name}</TableCell>
                                                                    <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                                                    <TableCell>{data.cost}</TableCell>
                                                                    <TableCell>{data.total_cost}</TableCell>
                                                                    <TableCell>
                                                                      <TextField
                                                                        type="number"
                                                                                                                                                      
                                                                        label={'Hours'}
                                                                        value={ Number(data.quantity) || 1}
                                                                        defaultValue={1}
                                                                        onChange={(event) => {
                                                                          let newValue = event.target.value;
                                                                         
                                                                          if (newValue.startsWith('-')) {
                                                                            newValue = newValue.slice(1);
                                                                          }
                                                                          data['quantity'] = newValue || 1;
                                                                          setFieldValue(quantityFieldName, newValue);
                                                                        }}
                                                                        error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                                                        helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                                                      />
                                                                    </TableCell>

                                                                    <TableCell>{(data.cost*quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                                                    <TableCell>{total?.toFixed(2)}</TableCell>
                                                                    <TableCell>{total?.toFixed(2)}</TableCell>
                                                                    <TableCell align='right'>
                                                                      <IconButton onClick={() => handleDeleteService(data.id, data.indexId)}>
                                                                        <Delete />
                                                                      </IconButton>
                                                                    </TableCell>
                                                                  </TableRow>
                                                                  <Modal
                                                                      open={serviceOnlyLocationStates[data.indexId]}
                                                                      handleClose={() => {
                                                                        setServiceOnlyLocationStates({ ...serviceOnlyLocationStates, [data.indexId]: false });
                                                                      }}
                                                                    >
                                                                        {index === 0 && <FormControlLabel
                                                                      control={
                                                                        <Switch
                                                                          checked={allServiceLocationSame}
                                                                         
                                                                        />
                                                                      }
                                                                      label="All Locations Same"
                                                                    />}
                                                                      <Grid
                                                                        container
                                                                        spacing={3}
                                                                        sx={{ justifyContent: 'center', width: '100%' }}
                                                                      >
                          
                                                                        {data?.addresses?.map((addr, i) => (
                                                                          <Grid item xs={12}>
                                                                            
                                                                            <Typography variant="h5" sx={{ mb: 2 }}>
                                                                              Location
                                                                            </Typography>
                          
                                                                            
                          
                                                                            <Stack
                                                                              direction={{ xs: 'column', sm: 'row' }}
                                                                              spacing={{ xs: 3, sm: 2 }}
                                                                              sx={{ mb: 2 }}
                                                                            >
                                                                              <TextField
                                                                                fullWidth
                                                                                label="Address"
                                                                                size="small"
                                                                                value={data.addresses[i].address || ''}
                                                                                onChange={(event) => {
                                                                                  let arrayAddr = [...data.addresses]
                                                                                  arrayAddr[i].address = event.target.value;
                                                                                  setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                                                    
                                                                                    if (p.indexId === data.indexId) {
                                                                                      return {
                                                                                        ...p,
                                                                                        addresses: arrayAddr
                                                                                      }
                                                                                    } else {
                                                                                      return p;
                                                                                    }
                                                                                  })]))
                                                                                }}
                                                                              />
                                                                            </Stack>
                          
                                                                         
                                                                            <Stack
                                                                              direction={{ xs: 'column', sm: 'row' }}
                                                                              spacing={{ xs: 3, sm: 2 }}
                                                                              sx={{ mb: 2 }}
                                                                            >
                                                                              <TextField
                                                                                fullWidth
                                                                                label="City"
                                                                                size="small"
                                                                                value={data.addresses[i].city || ''}
                                                                                onChange={(event) => {
                                                                                  let arrayAddr = [...data.addresses]
                                                                                  arrayAddr[i].city = event.target.value;
                                                                                  setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                                                    
                                                                                    if (p.indexId === data.indexId) {
                                                                                      return {
                                                                                        ...p,
                                                                                        addresses: arrayAddr
                                                                                      }
                                                                                    } else {
                                                                                      return p;
                                                                                    }
                                                                                  })]))
                                                                                }}
                                                                              />
                                                                              <TextField
                                                                                fullWidth
                                                                                label="State"
                                                                                size="small"
                                                                                value={data.addresses[i].state || ''}
                                                                                onChange={(event) => {
                                                                                  let arrayAddr = [...data.addresses]
                                                                                  arrayAddr[i].state = event.target.value;
                                                                                  setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                                                  
                                                                                    if (p.indexId === data.indexId) {
                                                                                      return {
                                                                                        ...p,
                                                                                        addresses: arrayAddr
                                                                                      }
                                                                                    } else {
                                                                                      return p;
                                                                                    }
                                                                                  })]))
                                                                                }}
                                                                              />
                                                                              <TextField
                                                                                fullWidth
                                                                                label="Zip / Postal Code"
                                                                                size="small"
                                                                                value={data.addresses[i].zip || ''}
                                                                                onChange={(event) => {
                                                                                  let arrayAddr = [...data.addresses]
                                                                                  arrayAddr[i].zip = event.target.value;
                                                                                  setAdditionalSelectedServices(pv => ([...pv.map(p => {
                                                                                    if (p.indexId === data.indexId) {
                                                                                   
                                                                                      return {
                                                                                        ...p,
                                                                                        addresses: arrayAddr
                                                                                      }
                                                                                    } else {
                                                                                      return p;
                                                                                    }
                                                                                  })]))
                                                                                }}
                                                                              />
                                                                            </Stack>
                                                                          </Grid>
                                                                        ))}
                                                                      </Grid>
                          
                          
                                                                      <Grid container justifyContent="center" alignItems="center">
                                                                        <Grid item xs={12} md={4}>
                                                                          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 1 }}>
                                                                            <LoadingButton variant="contained" onClick={() => {
                                                                              setIsSaving(true)
                                                                              setTimeout(() => {
                                                                                setIsSaving(false)
                                                                                setServiceOnlyLocationStates(false)
                                                                              }, 100)
                                                                            }} loading={isSaving}>
                                                                              {' Save '}
                                                                            </LoadingButton>
                                                                           
                                                                          </Box>
                                                                        </Grid>
                                                                      </Grid>
                                                                    </Modal>
                                                                </>
                                                              );
                                                            })} */}

{[...(memoizedRows || [])]
                                      .sort(
                                        (a, b) =>
                                          (Number(a?.newIndexId ?? a?.indexId ?? a?.product_index) || 0) -
                                          (Number(b?.newIndexId ?? b?.indexId ?? b?.product_index) || 0),
                                      )
                                      .map((data, index) => {
                                      const serviceLineKey = getServiceLineKey(data);
                                    
                                      // const quantityFieldName = `service_quantity_${index}`;
                                      // const dataQuantity = data?.quantity ? data?.quantity : 1;
                                      // data['quantity'] = dataQuantity
                                      // const total = data.total_cost * data?.quantity
                                      // let markup = 0;
                                      // if (total > 0) {
                                      //   markup = data.total_cost / Number(total);
                                      //   data['markup'] = markup?.toFixed(2);
                                      // } else {
                                      //   markup = 0
                                      //   data['markup'] = 0;
                                      // }
                                      // totalServiceMarkup += markup
  
                                      // let originalMarkup = data.originalMarkup || 0
                                      // originaltotalServiceMarkup += originalMarkup
                                      // data['total'] = total?.toFixed(2)
                                      // data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                      // values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                      // const quantityDifference = Number(data.quantity)
                                      // data['quantityDifference'] = quantityDifference
                                      // data['jobcost_unit_cost'] = data.cost
                                      // data['jobcost_quantity'] = quantityDifference
                                      // data['jobcost_total_cost'] = (data.cost*Number(data.quantity) || 1)?.toFixed(2)
  
                                      // let newTotalCost = total?.toFixed(2)
                                      // let newTotalProductFormula = (data.cost*quantityDifference)?.toFixed(2)
                                      // totalProductFormula += Number(newTotalProductFormula)
                                      // totalWholesalePrice += Number(newTotalCost)
                                      // totalRetailPrice += Number(newTotalCost)
                                      // values['totalProductFormula'] = totalProductFormula
                                      // values['totalWholesalePrice'] = totalWholesalePrice
                                      // values['totalRetailPrice'] = totalRetailPrice
  
                                      return (
                                        <Draggable
                                          key={`service-${serviceLineKey}`}
                                          draggableId={`service-${serviceLineKey}`}
                                          index={index}
                                        >
                                          {(provided, snapshot) => (
                                        <>
                                          <TableRow
                                            key={data.id}
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            style={{
                                              ...provided.draggableProps.style,
                                              ...(snapshot.isDragging
                                                ? { backgroundColor: theme.palette.action.hover }
                                                : {}),
                                            }}
                                          >
                                          <TableCell
                                            padding="checkbox"
                                            {...provided.dragHandleProps}
                                            sx={{ width: 40, cursor: 'grab' }}
                                          >
                                            <DragIndicator fontSize="small" color="action" />
                                          </TableCell>
                                          {/* {(values.project_categories?.name != 'Service only' && values.project_categories?.name != 'Time & Material') ? (
                                            <TableCell></TableCell>
                                          ) : null} */}
                                            <TableCell>{data.name}</TableCell>
                                            {/* <TableCell>{originalMarkup?.toFixed(2)}</TableCell> */}
                                            <TableCell>{data.originalMarkup?.toFixed(2)}</TableCell>
                                            <TableCell>{data.cost}</TableCell>
                                            <TableCell>{data.total_cost}</TableCell>
                                            <TableCell>
                                              <TextField
                                                type="number"
                                                // sx={{ width: 400 }}                                                                                
                                                label={'Hours'}
                                                value={ Number(data.quantity) || 1}
                                                defaultValue={1}
                                                onFocus={selectInputValue}
                                                onClick={selectInputValue}
                                                onChange={(event) => {
                                                  let newValue = event.target.value;
                                                  
                                                  if (newValue.startsWith('-')) {
                                                    newValue = newValue.slice(1);
                                                  }
                                                  // data['quantity'] = newValue || 1;
                                                  const normalizedQuantity = Number(newValue) || 1;
                                                  data['quantity'] = normalizedQuantity;

                                                  setAdditionalSelectedServices((prevServices) =>
                                                    prevServices.map((service) =>
                                                      service.id === data.id
                                                  // ? { ...service, quantity: newValue } // Update quantity for the matching service
                                                        ? { ...service, quantity: normalizedQuantity } // Update quantity for the matching service
                                                        : service // Keep other services unchanged
                                                    )
                                                  );
                                                

                                                }}
                                                
                                              />
                                            </TableCell>
{/*                                                                    
                                            <TableCell>
                                              <IconButton
                                                onClick={() => {
                                                  setServiceOnlyLocationStates({ ...serviceOnlyLocationStates, [data.indexId]: true });
                                                }}
                                              >
                                                <LocationOn sx={{
                                                  color: data?.addresses?.some(obj =>
                                                    Object.values(obj).some(value => value === '')
                                                  ) ? '' : theme.palette.primary.main
                                                }} />
                                              </IconButton>
                                            </TableCell> */}
                                            {/* ) : null} */}
                                            <TableCell>{(data.cost*data.quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell>
                                            {/* <TableCell>{(data.cost*quantityDifference?.toFixed(2))?.toFixed(2)}</TableCell> */}
                                            <TableCell>{data?.total}</TableCell>
                                            <TableCell>${fUSPrice(data?.total)}</TableCell>
                                            <TableCell align='right'>
                                              <IconButton onClick={() => handleDeleteService(data.id)}>
                                                <Delete />
                                              </IconButton>
                                            </TableCell>
                                          </TableRow>
                                        </>
                                          )}
                                        </Draggable>
                                      );
                                    })}
                                                            {droppableProvided.placeholder}
                                                            <TableRow>
                                                              <TableCell colSpan={8}>
                                                                <Typography variant="h6" align="right">
                                                                  Total Additional Service Cost: ${fUSPrice(selectedServicesSubTotal?.toFixed(2))}
                                                                </Typography>
                                                              </TableCell>
                                                            </TableRow>
                                                          </TableBody>
                                                              )}
                                                            </Droppable>
                                                          </DragDropContext>
                                                        </Table>
                                                      </TableContainer>
                                                    </Scrollbar>

                            <Divider />
                            
                            {/* Notes Section */}
                            <LabelStyle>Notes</LabelStyle>
                            <TextField
                              fullWidth
                              multiline
                              minRows={3}
                              maxRows={7}
                              label="Notes"
                              name="notes"
                              value={orderTextFields.notes}
                              onChange={(e) =>
                                setOrderTextFields((prev) => ({
                                  ...prev,
                                  notes: e.target.value,
                                }))
                              }
                              helperText={`${orderTextFields.notes?.length || 0}/${MAX_CHARACTERS} characters`}
                              inputProps={{
                                maxLength: MAX_CHARACTERS,
                              }}
                              InputProps={{
                                sx: {
                                  color: 'error.main',
                                }
                              }}
                            />

                             <Typography variant="h6" align="right">
                               Total Cost: {fUSPrice(selectedProductsAndServicesSubTotal || 0)}
                             </Typography>

                              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            {/* <FormControlLabel
                          control={
                            <Switch
                            {...getFieldProps('client_approve')}
                              color="primary"
                              checked={values.client_approve}
                              onChange={(event) => setFieldValue('client_approve', event.target.checked)}
                            />
                          }
                          labelPlacement="end"
                          label="Enable for Client Approval"
                          sx={{ mt: 0 }}
                        /> */}
                          </Stack>
                            {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <FormControlLabel
                              control={<Switch {...getFieldProps('welcome_message')} color="primary" checked={values.welcome_message} />}
                              labelPlacement="end"
                              label="Use Custom Welcome Message"
                              sx={{ mt: 5 }}
                            />
                          </Stack>
                          {values.welcome_message == true && (
                            <>
                              <Stack>
                                <LabelStyle>Subject</LabelStyle>
                                <TextField
                                  //   fullWidth
                                  type='text'
                                  sx={{ width: 400 }}

                                  {...getFieldProps('subject')}
                                  error={Boolean(touched.subject && errors.subject)}
                                  helperText={touched.subject && errors.subject}
                                />
                              </Stack>
                              <LabelStyle>Email Content</LabelStyle>
                              <TextField
                                fullWidth
                                multiline
                                minRows={3}
                                maxRows={7}
                                label="Email Content"
                                {...getFieldProps('email_content')}
                                error={Boolean(touched.email_content && errors.email_content)}
                                helperText={touched.email_content && errors.email_content}
                              />
                            </>
                          )}
                          <LabelStyle>Request state</LabelStyle>
                          <Typography>While in draft mode, clients you add to request tasks won't be notified</Typography>
                          <FormControlLabel
                            control={<Switch {...getFieldProps('draft')} color="primary" checked={values.draft} />}
                            labelPlacement="end"
                            label="Draft"
                            sx={{ mt: 5 }}
                          /> */}
                          </>
                        )}

                        </Stack>
                    )}

                    {/* Second Tab - Design Form */}
                    {mainTab === 1 && (
                      <Stack spacing={3}>
                        <DesignFormTabs 
                          designOrderId={null} 
                          savedFormData={designFormData}
                          onFormDataChange={(formData) => {
                            // Store form data in component state
                            setDesignFormData(formData)
                          }}
                        />
                      </Stack>
                    )}

                    {/* Common Save/Cancel Buttons for both tabs */}
                    <Box
                      sx={{
                        mt: 3,
                        display: 'flex',
                        justifyContent: 'flex-end',
                        gap: 1,
                      }}
                    >
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        loading={isSubmitting}
                        disabled={isSavingDraft}
                      >
                        Save Order
                      </LoadingButton>
                      <LoadingButton
                        type="button"
                        variant="outlined"
                        loading={isSavingDraft}
                        disabled={isSubmitting}
                        onClick={handleSaveDraft}
                      >
                        Save as Draft
                      </LoadingButton>
                      <Button
                        variant="outlined"
                        onClick={() => handleCancel()}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Card>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        ) : (
          <>
            <Stack
              mb={3}
              direction={{ xs: 'column', sm: 'row' }}
              spacing={{ xs: 3, sm: 2 }}
              alignItems="center"
              justifyContent="space-between"
            >
              <Box sx={{ mt: -4, }}>
                <OfficialRequestSearch
                  searching={searching}
                  setPage={setPage}
                  setSearching={setSearching}
                  setAllRequest={setAllRequest}
                />
              </Box>
            </Stack>
            <Scrollbar>
              <Grid container spacing={2} sx={{width: '100%', marginLeft: '0px'}}>
                <Tabs
                  value={currentTab}
                  scrollButtons="auto"
                  variant="scrollable"
                  allowScrollButtonsMobile
                  onChange={handleChangeTab}
                >
                  {ACCOUNT_TABS.map((tabItem) => (
                    <Tab
                      sx={{
                        justifyContent: 'center',
                        // marginX: 6,
                        // mt: 2.5,
                        overflow:'visible'
                      }}
                      disableRipple
                      key={tabItem.value}
                      label={
                        <Typography variant="subtitle2" sx={{ textAlign: 'center', ml: 0.5, fontSize: '13px' }}>
                          {capitalCaseWithSlash(tabItem.name.replace('/', ' / '))}
                        </Typography>
                      }
                      value={tabItem.value}
                    />
                  ))}
                </Tabs>
                {loadingCards ? (
                  <Grid
                    container
                    alignItems={'center'}
                    justifyContent={'center'}
                  >
                    <Stack sx={{ my: 15 }}>
                      <LoadingScreen />
                    </Stack>
                  </Grid>
                ) : (
                  <>
                    {filteredUsers?.length > 0 ? (
                      <>
                       {tabValue==='one' && <DragDropContext onDragEnd={handleOnDragEnd}>
                          <Droppable
                            droppableId="officialRequests"
                            direction="vertical"
                          >
                            {(provided) => (
                              <Grid
                                container
                                spacing={0}
                                sx={{
                                  display: 'grid',
                                  gap: 0,
                                  gridTemplateColumns: {
                                    xs: '1fr',                 // mobile: 1 per row
                                    sm: 'repeat(2, 1fr)',      // tablet: 2 per row
                                    md: 'repeat(4, minmax(0, 1fr))', // desktop: logical 6-column grid
                                    lg: 'repeat(4, minmax(0, 1fr))', // desktop: logical 6-column grid
                                    xl: 'repeat(6, minmax(0, 1fr))', // desktop: logical 6-column grid
                                  },
                                  justifyContent: 'center',    // ✅ centers when fewer items
                                }}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                              >
                                {filteredUsers.map((row, index) => {
                                  const team_member =
                                    requestTeam?.length > 0
                                      ? requestTeam.filter(
                                          (member) =>
                                            member.request_id === row.id,
                                        )
                                      : []
                                      let designOrderNewCard = false;
                                  if(isNewRowIdPresent?.length > 0){
                                    designOrderNewCard = isNewRowIdPresent?.split(',').includes(row.id.toString()) || false;
                                  }
                                  return (
                                    <Draggable
                                      key={row.id}
                                      draggableId={row.id.toString()}
                                      index={index}
                                    >
                                      {(provided, snapshot) => (
                                        <Grid
                                          item
                                          // xs={12}
                                          // sm={6}
                                          // md={4}
                                          sx={{ mt: 3 }}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={{
                                            ...provided.draggableProps.style,
                                            opacity: snapshot.isDragging
                                              ? 0.5
                                              : 1,
                                          }}
                                        >
                                          <OfficialCard
                                            card={row}
                                            setRenderCards={setRenderCards}
                                            renderCards={renderCards}
                                            currentTab={currentTab}
                                            team_member={team_member}
                                            designOrder={true}
                                            designOrderNewCard={designOrderNewCard}
                                            handleOpenViewDesignOrder={handleOpenViewDesignOrder}
                                            handleOpenDetailsDesignOrder={handleOpenDetailsDesignOrder}
                                          />
                                        </Grid>
                                      )}
                                    </Draggable>
                                  )
                                })}
                                {provided.placeholder}
                              </Grid>
                            )}
                          </Droppable>
                        </DragDropContext>}
                        {tabValue==='two'&&
                        <DesignOrderList
                        isDesign={true}
                        designOrder={true}
                        projectData={filteredUsers}
                        currentTab={currentTab}
                        setRenderCards={setRenderCards}
                        renderCards={renderCards}
                        handleOpenViewDesignOrder={handleOpenViewDesignOrder}
                        handleOpenDetailsDesignOrder={handleOpenDetailsDesignOrder}
                        />
                        }
                        {tabValue==='three'&&
                        <DesignOrderList
                        isDesign={true}
                        designOrder={true}
                        projectData={filteredUsers}
                        currentTab={currentTab}
                        setRenderCards={setRenderCards}
                        renderCards={renderCards}
                        noImage={true}
                        handleOpenViewDesignOrder={handleOpenViewDesignOrder}
                        handleOpenDetailsDesignOrder={handleOpenDetailsDesignOrder}
                        />
                        }
                      </>
                    ) : (
                      <Grid
                        container
                        alignItems={'center'}
                        justifyContent={'center'}
                      >
                        <Stack sx={{ my: 15 }}>
                          <Typography
                            gutterBottom
                            align="center"
                            variant="subtitle1"
                          >
                            No {capitalCaseWithSlash(currentTab)} Design Orders Found
                          </Typography>
                        </Stack>
                      </Grid>
                    )}
                  </>
                )}
              </Grid>
            </Scrollbar>
            {loadingCards ? (
              ''
            ) : (
              <Stack gap={2} sx={{ mt: 2 }}>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 100, 500]}
                  component="div"
                  count={totalCount || 0}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Stack>
            )}
          </>
        )}
        {openPreview && (
          <Modal
            width={900}
            open={openPreview}
            handleClose={() => {
              setOpenPreview(false)
            }}
            modalTitle={'Preview'}
          >
            <ReactToPrint
              trigger={() => (
                <Button variant="contained" color="primary">
                  Print A3
                </Button>
              )}
              content={() => printableContentRef.current}
              pageStyle={`@media print {
                    .print-black {
                    color: black !important;
                    background:white !important
                    }
                    table {
                    width: 100%;
                    border-collapse: collapse;
                    margin-bottom: 10px;
                    }
                    * {
                    color: black !important;
                    background-color: white !important;
                    }
                    .MuiTableCell-root {
                    color: black !important;
                    }
                    .MuiInputBase-input {
                    color: black !important;
                    }
                    .no-scrollbar::-webkit-scrollbar {
                    display: none;
                    }
                    .no-scrollbar {
                    -ms-overflow-style: none;  /* IE and Edge */
                    scrollbar-width: none;  /* Firefox */
                    }
                    .enable-for-print {
                    pointer-events: auto;
                    color: black !important;
                    }
                    .print-black .enable-for-print input[type='number'],
                    .print-black .enable-for-print input[type='text'] {
                    color: black !important; /* Set the text color to black for input fields */
                    }
                    .css-wr96yv-MuiInputBase-input-MuiOutlinedInput-input {
                        
                    color: black !important;
                    opacity: 1;
                        -webkit-text-fill-color:black !important;
                    }
                        input[type=number]{
                        color:black !important}
                    }`}
            />
            <div ref={printableContentRef} className="print-black">
              <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                <Grid item xs={12} md={12}>
                  <Stack
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                    spacing={2}
                  >
                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>
                          Name:{' '}
                        </span>
                        {preview?.name}
                      </Typography>
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>
                          Use custom welcome message:{' '}
                        </span>
                        {preview.welcome_message == null
                          ? 'No'
                          : preview.welcome_message == false
                          ? 'No'
                          : 'Yes'}
                      </Typography>
                    </Stack>
                    <Stack>
                      <Typography
                        variant="subtitle2"
                        style={{ color: theme.palette.primary.darker }}
                      >
                        Description:
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        style={{
                          overflowWrap: 'break-word',
                          wordWrap: 'break-word',
                          wordBreak: 'break-word',
                          whiteSpace: 'pre-line',
                        }}
                      >
                        {preview?.description}
                      </Typography>
                    </Stack>
                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>
                          Client:{' '}
                        </span>
                        {preview?.clients?.name}
                      </Typography>
                      {/* <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>Project: </span>
                        {preview?.community?.name}
                      </Typography> */}
                    </Stack>

                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>
                          Start Date:{' '}
                        </span>
                        {formatDateOnly(preview.start)}
                      </Typography>
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>
                          Due Date:{' '}
                        </span>
                        {formatDateOnly(preview.end)}
                      </Typography>
                    </Stack>
                    <Stack>
                      <Typography
                        variant="subtitle2"
                        style={{ color: theme.palette.primary.darker }}
                      >
                        Notes:
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        sx={{
                          overflowWrap: 'break-word',
                          wordWrap: 'break-word',
                          wordBreak: 'break-word',
                          textAlign: 'justify',
                          color: 'error.main',
                          whiteSpace: 'pre-line'
                        }}
                      >
                        <Scrollbar
                          sx={{
                            maxHeight: 200,
                            '& .simplebar-content': {
                              maxHeight: 200,
                              display: 'flex',
                              flexDirection: 'column',
                            },
                          }}
                        >
                          {preview?.notes}
                        </Scrollbar>
                      </Typography>

                      
                    </Stack>
                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">
                        <Label
                          variant={
                            theme.palette.mode === 'light' ? 'ghost' : 'filled'
                          }
                          color={getStatusColorAndLabel(preview?.status, preview?.hold).color}
                        >
                          {getStatusColorAndLabel(preview?.status, preview?.hold).label}
                        </Label>
                      </Typography>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </div>
          </Modal>
        )}
        {/* <Box sx={{display:"none"}}>
        <NavSection  added={added}/>
      </Box> */}
      
      {/* 🚀 PROGRESS TRACKING: Request Progress Modal */}
      {/* <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        onSocketReady={setSocketReady}
        heading={progressHeading}
      /> */}
      <RequestProgressModal
        open={showProgressModal}
        onClose={() => setShowProgressModal(false)}
        requestData={progressRequestData}
        heading={progressHeading}
        message="We're processing your request. Please wait..."
      />
      <FullScreenDialogDesignOrder
        open={handleOpenDesignOrder}
        setOpen={setHandleOpenDesignOrder}
        projectId={designOrderId}
        projectName={designOrderName}
        isEditDesignOrder={isEditDesignOrder}
        setRenderCards={setRenderCards}
        renderCards={renderCards}
        setIsEditDesignOrder={setIsEditDesignOrder}
      />

      {/* Auto-save confirmation dialog */}
      <Dialog
        open={openBackConfirm}
        onClose={() => setOpenBackConfirm(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Go back?</DialogTitle>
        <DialogContent>
          <Typography variant="body1">
            Do you want to auto save this design order before going back?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBackConfirmNo} variant="outlined" color="primary">
            No, Go Back
          </Button>
          <Button onClick={handleBackConfirmYes} variant="contained" color="primary">
            Yes, Auto Save
          </Button>
        </DialogActions>
      </Dialog>
      </Container>
    </Page>
  )
}
